import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import "./MapElement.scss";
gsap.registerPlugin(DrawSVGPlugin);

const MapElement = ({zoomToElement, displayNewLines, displayU1, displayU9, displayU11, displayU14, scale}) => {
  // get ref elements
  // ref track groups
  const unchangedTracks = useRef();
  const oldTracks = useRef();
  const oldTracksMisc = useRef();
  const newTracks = useRef();

  const changeTracksGroupAnim = useRef();
  const changeUnchangedOpacity = useRef();

  const showLineU1Anim = useRef();
  const showStationsU1Anim = useRef();
  const displayDottedLineAnimU1 = useRef();
  const hideUnselectedLinesAnimU1 = useRef();

  const showLineU9Anim = useRef();
  const showStationsU9Anim = useRef();
  const displayDottedLineAnimU9 = useRef();
  const hideUnselectedLinesAnimU9 = useRef();

  const showLineU11Anim = useRef();
  const showStationsU11Anim = useRef();
  const displayDottedLineAnimU11 = useRef();
  const hideUnselectedLinesAnimU11 = useRef();

  const showLineU14Anim = useRef();
  const showStationsU14Anim = useRef();
  const displayDottedLineAnimU14 = useRef();
  const hideUnselectedLinesAnimU14 = useRef();

  const hideAllDottedLinesAnim = useRef();
  const hideAllStationsAnim = useRef();
  const showAllStationsAnim = useRef();

  const demoU1 = useRef();
  const demoU9 = useRef();
  const demoU11 = useRef();
  const demoU14 = useRef();


  // animate switch from maps
  useEffect(() => {
    const oldTracksNodeList = oldTracks.current.childNodes[0].childNodes
    const oldTracksArray = Array.from(oldTracksNodeList)

    const U1NewNode = document.getElementById('U1_Line-2').childNodes;
    const U1NewArray = Array.from(U1NewNode);

    const U9NewNode = document.getElementById('U9_Line').childNodes;
    const U9NewArray = Array.from(U9NewNode);

    const U11NewNode = document.getElementById('U11_Line').childNodes;
    const U11NewArray = Array.from(U11NewNode);

    const U14NewNode = document.getElementById('U14_Line').childNodes;
    const U14NewArray = Array.from(U14NewNode);

    const newTracksArray = [...U1NewArray, ...U9NewArray, ...U11NewArray, ...U14NewArray]

    changeTracksGroupAnim.current = gsap.timeline({
      paused: true
    })
    changeUnchangedOpacity.current = gsap.timeline({
      paused: true
    })

    changeTracksGroupAnim.current.to(oldTracksArray, {
      opacity: 0,
      duration: .8,
      drawSVG: 0,
      ease: 'linear'
    });
    changeTracksGroupAnim.current.to(oldTracksMisc.current, {
      opacity: 0,
      duration: .8,
      ease: 'linear'
    }, "<");
     changeTracksGroupAnim.current.to(newTracks.current, {
      opacity: 1,
      duration: .8,
      ease: 'linear'
    });
    changeTracksGroupAnim.current.fromTo(newTracksArray, {
      opacity: 1,
      duration: .8,
      drawSVG: "0%",
      ease: 'linear'
    },
    {
      drawSVG: "100%",
    }, "<");
    changeUnchangedOpacity.current.to(unchangedTracks.current, {
      opacity: 0.2,
    })

  }, [unchangedTracks, oldTracks, newTracks])

  useEffect(() => {

    if (displayNewLines === true) {
      changeTracksGroupAnim.current.play()
      changeUnchangedOpacity.current.play()
    }
    else if (displayNewLines === false) {
      changeTracksGroupAnim.current.reverse()
      changeUnchangedOpacity.current.reverse()
    }

  }, [displayNewLines])

  useEffect(() => {

    const U1NewNode = document.getElementById('U1_Line-2').childNodes;
    const U1NewArray = Array.from(U1NewNode);
    const U1StationsArray = document.getElementById('U1_Stations').childNodes;
    const U1StartAndEndArray = document.getElementById('U1_StartandEnd').childNodes;

    const U9NewNode = document.getElementById('U9_Line').childNodes;
    const U9NewArray = Array.from(U9NewNode);
    const U9StationsArray = document.getElementById('U9_Stations').childNodes;
    const U9StartAndEndArray = document.getElementById('U9_StartandEnd').childNodes;

    const U11NewNode = document.getElementById('U11_Line').childNodes;
    const U11NewArray = Array.from(U11NewNode);
    const U11StationsArray = document.getElementById('U11_Stations').childNodes;
    const U11StartAndEndArray = document.getElementById('U11_StartandEnd').childNodes;

    const U14NewNode = document.getElementById('U14_Line').childNodes;
    const U14NewArray = Array.from(U14NewNode);
    const U14StationsArray = document.getElementById('U14_Stations').childNodes;
    const U14StartAndEndArray = document.getElementById('U14_StartandEnd').childNodes;

    const allDottedLines = [demoU1.current, demoU9.current, demoU11.current, demoU14.current]
    const allStationNames = [U1StationsArray, U1StartAndEndArray, U9StationsArray, U9StartAndEndArray, U11StationsArray, U11StartAndEndArray, U14StationsArray, U14StartAndEndArray]

    let compareTracksToHideU1 = [U9NewArray, U11NewArray, U14NewArray];
    let compareSelectedTrackU1 = [demoU1.current];
    let lineToShowU1 = [U1NewArray];

    let compareTracksToHideU9 = [U1NewArray, U11NewArray, U14NewArray];
    let compareSelectedTrackU9 = [demoU9.current];
    let lineToShowU9 = [U9NewArray];

    let compareTracksToHideU11 = [U9NewArray, U1NewArray, U14NewArray];
    let compareSelectedTrackU11 = [demoU11.current];
    let lineToShowU11 = [U11NewArray];

    let compareTracksToHideU14 = [U9NewArray, U11NewArray, U1NewArray];
    let compareSelectedTrackU14 = [demoU14.current];
    let lineToShowU14 = [U14NewArray];

    hideAllDottedLinesAnim.current = gsap.timeline({
      paused: true
    })
    hideAllStationsAnim.current = gsap.timeline({
      paused: true
    })
    showAllStationsAnim.current = gsap.timeline({
      paused: true
    })

    showLineU1Anim.current = gsap.timeline({
      paused: true
    })
    showStationsU1Anim.current = gsap.timeline({
      paused: true
    })
    displayDottedLineAnimU1.current = gsap.timeline({
      paused: true
    })
    hideUnselectedLinesAnimU1.current = gsap.timeline({
      paused: true
    })


    showLineU9Anim.current = gsap.timeline({
      paused: true
    })
    showStationsU9Anim.current = gsap.timeline({
      paused: true
    })
    displayDottedLineAnimU9.current = gsap.timeline({
      paused: true
    })
    hideUnselectedLinesAnimU9.current = gsap.timeline({
      paused: true
    })


    showLineU11Anim.current = gsap.timeline({
      paused: true
    })
    showStationsU11Anim.current = gsap.timeline({
      paused: true
    })
    displayDottedLineAnimU11.current = gsap.timeline({
      paused: true
    })
    hideUnselectedLinesAnimU11.current = gsap.timeline({
      paused: true
    })


    showLineU14Anim.current = gsap.timeline({
      paused: true
    })
    showStationsU14Anim.current = gsap.timeline({
      paused: true
    })
    displayDottedLineAnimU14.current = gsap.timeline({
      paused: true
    })
    hideUnselectedLinesAnimU14.current = gsap.timeline({
      paused: true
    })

    hideAllDottedLinesAnim.current.to(allDottedLines, {
      opacity: 0,
      duration: 0.8,
      ease: 'linear'
    });
    hideAllStationsAnim.current.to(allStationNames, {
      opacity: 0,
      duration: 0.8,
      ease: 'linear'
    });
    showAllStationsAnim.current.to(allStationNames, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });

    showLineU1Anim.current.to(lineToShowU1, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    showStationsU1Anim.current.to([U1StationsArray, U1StartAndEndArray], {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    hideUnselectedLinesAnimU1.current.to(compareTracksToHideU1, {
      opacity: 0.1,
      duration: 0.8,
      ease: 'linear'
    });
    displayDottedLineAnimU1.current.to(compareSelectedTrackU1, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });

    showLineU9Anim.current.to(lineToShowU9, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    showStationsU9Anim.current.to([U9StationsArray, U9StartAndEndArray], {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    hideUnselectedLinesAnimU9.current.to(compareTracksToHideU9, {
      opacity: 0.1,
      duration: 0.8,
      ease: 'linear'
    });
    displayDottedLineAnimU9.current.to(compareSelectedTrackU9, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });

    showLineU11Anim.current.to(lineToShowU11, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    showStationsU11Anim.current.to([U11StationsArray, U11StartAndEndArray], {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    hideUnselectedLinesAnimU11.current.to(compareTracksToHideU11, {
      opacity: 0.1,
      duration: 0.8,
      ease: 'linear'
    });
    displayDottedLineAnimU11.current.to(compareSelectedTrackU11, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });

    showLineU14Anim.current.to(lineToShowU14, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    showStationsU14Anim.current.to([U14StationsArray, U14StartAndEndArray], {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });
    hideUnselectedLinesAnimU14.current.to(compareTracksToHideU14, {
      opacity: 0.1,
      duration: 0.8,
      ease: 'linear'
    });
    displayDottedLineAnimU14.current.to(compareSelectedTrackU14, {
      opacity: 1,
      duration: 0.8,
      ease: 'linear'
    });

    hideAllDottedLinesAnim.current.play();

    if(!displayU1 && !displayU9 && !displayU11 && !displayU14){
      showLineU1Anim.current.play()
      showLineU9Anim.current.play()
      showLineU11Anim.current.play()
      showLineU14Anim.current.play()
      showAllStationsAnim.current.play()
    }
    else if(displayU1){

      if(scale > 1){
        zoomToElement(U1NewArray[0], 2.5);
      }else{
        zoomToElement(U1NewArray[0], 1.03);
      }
      hideAllStationsAnim.current.play();
      showStationsU1Anim.current.play();
      hideUnselectedLinesAnimU1.current.play();
      showLineU1Anim.current.play();
      displayDottedLineAnimU1.current.play();
    }
    else if(displayU9){
      if(scale > 1){
        zoomToElement(U9NewArray[0], 2.5);
      }else{
        zoomToElement(U9NewArray[0], 1.03);
      }
      hideAllStationsAnim.current.play();
      showStationsU9Anim.current.play();
      hideUnselectedLinesAnimU9.current.play();
      showLineU9Anim.current.play();
      displayDottedLineAnimU9.current.play();
    }
    else if(displayU11){
      if(scale > 1){
        zoomToElement(U11NewArray[0], 3);
      }else{
        zoomToElement(U11NewArray[0], 1.5);
      }
      hideAllStationsAnim.current.play();
      showStationsU11Anim.current.play();
      hideUnselectedLinesAnimU11.current.play();
      showLineU11Anim.current.play();
      displayDottedLineAnimU11.current.play();
    }
    else if(displayU14){
      //zoomed to U11 on purpose since it looks better centered
      if(scale > 1){
        zoomToElement(U1NewArray[0], 2.5);
      }else{
        zoomToElement(U1NewArray[0], .7);
      }
      hideAllStationsAnim.current.play();
      showStationsU14Anim.current.play();
      hideUnselectedLinesAnimU14.current.play();
      showLineU14Anim.current.play();
      displayDottedLineAnimU14.current.play();
    }

  },[displayU1, displayU9, displayU11, displayU14, zoomToElement, scale])

    return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="R-S-U_Liniennetz_2024"
      data-name="R-S-U Liniennetz 2024"
      viewBox="0 0 2411.46 1806.32"
    >
      <defs>
        <symbol id="Seilbahn" viewBox="0 0 38.27 38.27">
          <g strokeWidth="0">
            <path fill="#fff" d="M0 0H38.27V38.27H0z"></path>
            <path
              fill="#fbba00"
              d="M8.06 29.31c-.46.25-.47.78-.28 1.22l1.38-.76c-.23-.43-.63-.72-1.1-.46zM14.74 18.31c-.23-.43-.63-.72-1.1-.46-.46.25-.47.78-.28 1.22l1.38-.76zM22.51 17.07c.7-.39.2-1.49-.07-2s-.88-1.43-1.56-1.06c-.67.37-.21 1.4.05 1.89.29.54.82 1.58 1.58 1.17zM15.3 25.47c-.67.37-.21 1.4.05 1.89.29.54.82 1.58 1.58 1.17.7-.39.2-1.49-.07-2s-.88-1.43-1.56-1.06zM20.22 24.79c-.45.29-1.09.8-.77 1.42.14.27.43.47.73.3.1-.05.19-.14.25-.24.22-.33.2-.72.02-1.06l-.23-.43z"
            ></path>
            <path
              fill="#fbba00"
              d="M33.28 8.45c-.17-.32-.48-.87-.92-.62-.71.39-.39 1.62-.08 2.19l.81 1.51-.76.42-1.95-3.66.76-.42.46.87h.01c-.05-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l.29.55V4.26H4.37v29.76h2.19c.2-.17.33-.41.19-.67-.31-.58-1.69-.03-2.38-.64v-1.67c.14-.14.3-.26.48-.36.29-.16.6-.25.92-.32l.35.66c-.38-.04-.75-.05-1.1.14-.23.13-.46.38-.31.67.35.66 2.03-.19 2.65.98.25.47.19.88-.03 1.22h26.79V10.04l-.85-1.59zm-9.07 3.14c1-.55 1.5-.25 2 .68l1.26 2.36-.76.42-.27-.51h-.01c-.02.49-.27.92-.7 1.16-.51.28-1.17.18-1.47-.37-.55-1.03.62-1.86 1.36-2.32l-.17-.32c-.2-.37-.56-1.06-1.07-.78-.48.27-.35.71-.16 1.12l-.8.44c-.39-.89-.02-1.44.78-1.89zm-5.17.84l1.15 2.15h.02c.05-.53.21-.89.69-1.16 1.08-.6 1.89.27 2.38 1.18.58 1.1.57 2.14-.59 2.78-1.28.71-1.94.09-2.54-1.05l-1.86-3.49.76-.42zm-1.69.94l2.82 5.3-.76.42-2.83-5.3.76-.42zm1.02 6.3l-.76.42-1.95-3.66.76-.42 1.95 3.66zm-2.79-5.32l.41.77-.82.45-.41-.77.82-.46zm-2.07 3.17c.97-.54 1.68-.2 2.18.73l-2.15 1.19c.46.87 1.42 1.7 2.42 1.15.23-.13.44-.31.6-.53l.19.35c-.28.35-.55.57-.94.79-1.24.69-2.27.11-2.9-1.08-.56-1.04-.5-1.99.6-2.6zm-3.07 1.7c.29-.16.6-.25.92-.32l.35.66c-.38-.04-.75-.05-1.1.14-.23.13-.46.38-.31.67.35.66 2.03-.19 2.65.98.44.82-.07 1.47-.78 1.86-.33.18-.67.3-1.04.37l-.38-.71c.4.04.83.04 1.2-.17.28-.15.55-.46.37-.8-.34-.64-2.03.12-2.59-.92-.4-.74.03-1.38.7-1.75zm-.44 6.6l.41.77-.82.46-.41-.77.82-.45zm.23 6.84c-1.24.69-2.27.11-2.9-1.08-.56-1.04-.5-1.99.6-2.6.97-.54 1.68-.2 2.18.73L7.96 30.9c.46.87 1.42 1.7 2.42 1.15.23-.13.44-.31.6-.53l.19.35c-.28.35-.54.57-.94.79zm1.8-1.11l-1.95-3.66.76-.42 1.95 3.66-.76.42zm1.81-1l-2.83-5.3.76-.42 2.83 5.3-.76.42zm3.27-1.7c-1.28.71-1.94.09-2.54-1.05l-1.86-3.49.76-.42 1.15 2.15h.02c.05-.53.21-.89.69-1.16 1.08-.6 1.89.27 2.38 1.18.59 1.1.57 2.14-.59 2.78zm4.03-2.34l-.27-.51h-.01c-.01.49-.27.92-.7 1.16-.51.28-1.17.18-1.47-.37-.55-1.03.62-1.86 1.36-2.32l-.17-.32c-.2-.37-.56-1.06-1.07-.78-.48.27-.35.71-.15 1.12l-.8.44c-.39-.89-.02-1.44.78-1.88 1-.55 1.5-.25 2 .68l1.26 2.36-.76.42zm3.89-2.15l-1.22-2.29c-.17-.32-.48-.87-.92-.63-.71.39-.39 1.62-.08 2.19l.81 1.51-.76.42-2.83-5.3.76-.42 1.34 2.51h.01c-.04-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l1.42 2.67-.76.42zm3.9-2.16l-1.22-2.29c-.17-.32-.48-.87-.92-.62-.71.39-.39 1.62-.08 2.19l.81 1.51-.76.42-1.95-3.66.76-.42.46.87h.02c-.05-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l1.42 2.67-.76.42zm1.67-9.3l-1.22-2.29c-.17-.32-.48-.87-.92-.62-.71.39-.39 1.62-.08 2.19l.81 1.51-.76.42-2.83-5.3.76-.42 1.34 2.51h.01c-.05-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l1.42 2.67-.76.42z"
            ></path>
            <path
              fill="#fbba00"
              d="M25.03 14.75c.14.27.43.47.73.3.1-.05.19-.14.25-.24.22-.33.2-.72.02-1.06l-.23-.43c-.45.29-1.09.8-.77 1.42z"
            ></path>
            <path
              fill="#004f9f"
              d="M12.32 21.88c.18.34-.09.65-.37.8-.37.2-.8.21-1.2.17l.38.71c.37-.07.71-.18 1.04-.37.71-.39 1.21-1.04.78-1.86-.62-1.17-2.3-.32-2.65-.98-.15-.28.07-.54.31-.67.35-.19.72-.18 1.1-.14l-.35-.66c-.32.07-.64.16-.92.32-.66.37-1.1 1-.7 1.75.56 1.04 2.25.28 2.59.92zM15.8 21.19c.39-.22.66-.43.94-.79l-.19-.35c-.17.22-.37.4-.6.53-1 .55-1.96-.28-2.42-1.15l2.15-1.19c-.5-.94-1.21-1.27-2.18-.73-1.1.61-1.15 1.55-.6 2.6.63 1.19 1.66 1.77 2.9 1.08zm-2.16-3.34c.48-.26.87.03 1.1.46l-1.38.76c-.19-.44-.18-.96.28-1.22z"
            ></path>
            <path
              fill="#004f9f"
              d="M17.6 20.09L18.36 19.67 16.41 16.01 15.65 16.43 17.6 20.09z"
            ></path>
            <path
              fill="#004f9f"
              d="M15.98 15.12L15.57 14.35 14.74 14.8 15.15 15.57 15.98 15.12z"
            ></path>
            <path
              fill="#004f9f"
              d="M20.17 18.67L17.34 13.37 16.58 13.79 19.41 19.09 20.17 18.67z"
            ></path>
            <path
              fill="#004f9f"
              d="M22.68 17.39c1.16-.64 1.17-1.68.59-2.78-.49-.91-1.3-1.78-2.38-1.18-.48.26-.64.62-.69 1.15h-.02l-1.15-2.14-.76.42 1.86 3.49c.61 1.14 1.26 1.76 2.54 1.05zm-1.8-3.38c.68-.38 1.29.55 1.56 1.06s.77 1.61.07 2c-.75.42-1.29-.63-1.58-1.17-.26-.49-.72-1.52-.05-1.89zM24.23 13.03c-.19-.41-.33-.85.16-1.12.51-.28.87.41 1.07.78l.17.32c-.74.46-1.91 1.29-1.36 2.32.29.55.96.66 1.47.37.42-.23.68-.67.7-1.15h.01l.27.5.76-.42-1.26-2.36c-.5-.94-1.01-1.23-2-.68-.8.44-1.18 1-.78 1.89l.8-.44zm1.57.31l.23.43c.18.34.19.73-.02 1.06a.82.82 0 01-.25.24c-.29.16-.58-.04-.73-.3-.33-.62.32-1.13.77-1.42zM28.46 9.24c-.62.34-.8.98-.75 1.65h-.01l-1.34-2.5-.76.42 2.83 5.3.76-.42-.81-1.51c-.3-.57-.62-1.79.08-2.19.44-.24.75.3.92.62l1.22 2.29.76-.42-1.42-2.67c-.3-.57-.87-.9-1.47-.57zM32.37 7.08c-.62.34-.8.98-.75 1.65h-.01l-.46-.86-.76.42 1.95 3.66.76-.42-.81-1.51c-.3-.57-.62-1.79.08-2.19.44-.24.75.3.92.62l.85 1.59V8.19l-.29-.55c-.3-.57-.87-.9-1.47-.57zM7.37 32.79c-.62-1.17-2.3-.32-2.65-.98-.15-.28.07-.54.31-.67.35-.19.72-.18 1.1-.14l-.35-.66c-.32.07-.64.16-.92.32-.18.1-.35.22-.48.36v1.67c.69.62 2.07.07 2.38.64.14.26 0 .51-.19.67h.78c.23-.34.28-.75.03-1.22zM10.37 32.04c-1 .55-1.96-.28-2.42-1.15l2.15-1.19c-.5-.94-1.21-1.27-2.18-.73-1.1.61-1.15 1.55-.6 2.6.63 1.19 1.66 1.77 2.9 1.08.39-.22.66-.43.94-.79l-.19-.35c-.17.22-.37.4-.6.53zm-2.58-1.51c-.19-.44-.18-.96.28-1.22.48-.26.87.03 1.1.46l-1.38.76z"
            ></path>
            <path
              fill="#004f9f"
              d="M10.4 26.58L9.99 25.81 9.17 26.26 9.58 27.03 10.4 26.58z"
            ></path>
            <path
              fill="#004f9f"
              d="M10.08 27.89L12.02 31.55 12.79 31.12 10.84 27.47 10.08 27.89z"
            ></path>
            <path
              fill="#004f9f"
              d="M11.01 25.25L13.83 30.55 14.59 30.12 11.77 24.82 11.01 25.25z"
            ></path>
            <path
              fill="#004f9f"
              d="M15.31 24.88c-.48.26-.64.62-.69 1.15h-.02l-1.15-2.14-.76.42 1.86 3.49c.61 1.14 1.26 1.76 2.54 1.05 1.16-.64 1.17-1.68.59-2.78-.49-.91-1.3-1.78-2.38-1.18zm1.62 3.64c-.75.42-1.29-.63-1.58-1.17-.26-.49-.72-1.52-.05-1.89.68-.38 1.29.55 1.56 1.06s.77 1.61.07 2zM18.64 23.04c-.8.44-1.18 1-.78 1.88l.8-.44c-.19-.41-.33-.85.15-1.12.51-.28.87.41 1.07.78l.17.32c-.74.46-1.91 1.29-1.36 2.32.29.55.95.66 1.47.37.42-.23.68-.67.7-1.15h.01l.27.5.76-.42-1.26-2.36c-.5-.94-1.01-1.23-2-.68zm1.79 3.24a.82.82 0 01-.25.24c-.29.16-.58-.03-.73-.3-.33-.62.32-1.13.77-1.42l.23.43c.18.34.19.73-.02 1.06zM22.89 20.69c-.62.34-.8.98-.75 1.65h-.01l-1.34-2.5-.76.42 2.83 5.3.76-.42-.81-1.51c-.3-.57-.62-1.79.08-2.19.44-.24.75.3.92.63l1.22 2.29.76-.42-1.42-2.67c-.3-.57-.87-.9-1.47-.57zM26.79 18.53c-.62.34-.8.98-.75 1.65h-.02l-.46-.86-.76.42 1.95 3.66.76-.42-.81-1.51c-.3-.57-.62-1.79.08-2.19.44-.24.75.3.92.62l1.22 2.29.76-.42-1.42-2.67c-.3-.57-.87-.9-1.47-.57z"
            ></path>
          </g>
        </symbol>
        <symbol id="Zacke" viewBox="0 0 29.76 29.76">
          <g strokeWidth="0">
            <path fill="#fbba00" d="M0 0H29.76V29.76H0z"></path>
            <g fill="#004f9f">
              <path d="M5.37 18.56l-4.03.89.23 1.05 1.94-.43c.21-.05.3-.08.52-.18-.1.26-.14.38-.17.56l-1.29 6.1 4.24-.94-.24-1.07L4.5 25c-.24.05-.32.08-.54.17.09-.28.12-.4.16-.61l1.25-6.01z"></path>
              <path d="M26 13.98L22.56 14.74 24.12 21.78 27.76 20.97 27.54 19.96 25.01 20.52 24.55 18.41 26.73 17.93 26.52 16.99 24.34 17.47 23.9 15.49 26.23 14.97 26 13.98z"></path>
              <path d="M14.85 17.38c.4-.09.75-.06 1.31.12l-.25-1.13c-.55-.1-1.01-.1-1.47 0-1.61.36-2.3 1.99-1.79 4.25.52 2.36 1.81 3.47 3.59 3.07.55-.12.99-.34 1.37-.68l-.27-1.23c-.53.54-.85.74-1.32.85-1.08.24-1.87-.55-2.25-2.26-.37-1.68.02-2.76 1.08-3z"></path>
              <path d="M21.53 14.97L20.47 15.21 18.94 18.89 22.12 22.22 23.11 22.01 23.31 21.96 20.15 18.62 21.67 14.95 21.53 14.97z"></path>
              <path d="M7.93 17.99l-.35 7.46 1.17-.26.04-1.66 2.03-.45.76 1.49 1.21-.27-3.48-6.61-1.38.3zm2.49 4.21l-1.63.36.06-1.7c.02-.52 0-1-.05-2.02h.04c.39.96.58 1.41.81 1.85l.78 1.51z"></path>
              <path d="M17.23 15.93L17.08 15.96 18.64 23 18.78 22.97 19.74 22.75 18.19 15.72 17.23 15.93z"></path>
            </g>
          </g>
        </symbol>
      </defs>
      <g ref={oldTracks} id="Changed_2023" data-name="Changed 2023">
        <g id="Linien" fill="none" strokeMiterlimit="10" strokeWidth="5.39">
          <path
            stroke="#6eb53e"
            d="M1932.38 196.34L1651.31 196.34 1387.16 460.43 1387.16 661.8 1123.17 925.83 1114.72 925.83 864.92 676.21"
          ></path>
          <path
            stroke="#6eb53e"
            d="M1126.29 716.15L1057.72 648.47 888.07 648.48 860.78 675.78"
          ></path>
          <path
            stroke="#ffd400"
            d="M1941.71 1142.34L1763.67 964.89 1605.3 964.89 1491.07 850.66 1440.45 850.42 1349.85 759.61 927.71 1181.75"
          ></path>
          <path
            stroke="#d2a070"
            d="M2210.25 862.16L1818.88 470.8 1614.69 470.8 1453.23 632.21 1441.36 632.01 1276.73 796.59 1276.73 820.64 917.26 1180.14 614.27 1180.13 493 1301.27"
          ></path>
          <path
            stroke="#bcbcbb"
            d="M1185.11 876L1126.61 934.51 1111.13 934.51 858.92 682.31"
          ></path>
          <path
            stroke="#bcbcbb"
            d="M1542.85 744.09L1442.1 643.34 1282.81 802.68 1258.46 802.68 1208.2 852.93"
          ></path>
          <path
            stroke="#bcbcbb"
            d="M1132.34 710.11L1061.29 639.95 884.42 640.01 837.89 686.53"
          ></path>
        </g>
        <g ref={oldTracksMisc}>
          <g id="U9_Startend" strokeWidth="0" data-name="U9 Startend">
            <path
              fill="#fff"
              d="M1894.09 1132.17H1940.32V1166.19H1894.09z"
            ></path>
            <path
              fill="#ffd400"
              d="M1898.35 1136.43H1936.05V1161.94H1898.35z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M1920.2 1153.3c.06 3.35 2.97 4.42 5.51 4.42 2.18 0 3.3-.37 4.76-1.95.82-.89 1.88-3.25 1.94-5.45.14-4.81-1.18-9.14-6.33-9.14-3.14 0-6.1 1.65-6.1 5.48 0 3.09 2.29 5.02 4.95 5.02 1.3 0 2.62-.53 3.43-1.65l.04.05c-.08 2.04 0 4.67-2.54 4.67-.43 0-.88-.09-1.23-.32s-.6-.6-.62-1.12h-3.8zm8.04-6.76c0 1.1-.74 2.38-2.23 2.38-1.28 0-2.23-.73-2.23-2.38 0-1.44.85-2.38 2.23-2.38s2.23.85 2.23 2.38"
            ></path>
            <path
              fill="#fff"
              d="M918.94 1183.07H965.1700000000001V1217.09H918.94z"
            ></path>
            <path
              fill="#ffd400"
              d="M923.2 1187.32H960.9000000000001V1212.83H923.2z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M937.34 1191.73v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.6 3.36 6.42 7.11 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12zM945.05 1204.2c.06 3.35 2.97 4.42 5.51 4.42 2.18 0 3.3-.37 4.76-1.95.82-.89 1.88-3.25 1.94-5.45.14-4.81-1.18-9.14-6.33-9.14-3.14 0-6.1 1.65-6.1 5.48 0 3.09 2.29 5.02 4.95 5.02 1.3 0 2.62-.53 3.43-1.65l.04.05c-.08 2.04 0 4.67-2.54 4.67-.43 0-.89-.09-1.23-.32-.35-.23-.6-.6-.62-1.12h-3.8zm8.04-6.76c0 1.1-.74 2.38-2.23 2.38-1.28 0-2.23-.73-2.23-2.38 0-1.44.85-2.38 2.23-2.38s2.23.85 2.23 2.38M1913.08 1140.83v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.6 3.36 6.42 7.11 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12z"
            ></path>
          </g>
          <g id="Station_Names" data-name="Station Names">
            <path
              fill="none"
              stroke="#fff"
              strokeWidth="9.92"
              d="M1593.36 254.28L1607.58 240.06"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.58 229.95H1616.83V235.89999999999998H1612.58z"
              transform="rotate(-45 1614.702 232.928)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.14 267.39H1579.39V273.34H1575.14z"
              transform="rotate(-45 1577.26 270.368)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.69 304.83H1541.94V310.78H1537.69z"
              transform="rotate(-45 1539.818 307.807)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.25 342.28H1504.5V348.22999999999996H1500.25z"
              transform="rotate(-45 1502.37 345.258)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1462.8 379.72H1467.05V385.67H1462.8z"
              transform="rotate(-45 1464.928 382.697)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.36 417.16H1429.61V423.11H1425.36z"
              transform="rotate(-45 1427.486 420.136)"
            ></path>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1433.01 438.16)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                M
              </tspan>
              <tspan x="16.94" y="0" letterSpacing="0em">
                ü
              </tspan>
              <tspan x="27.92" y="0" letterSpacing="0em">
                hl
              </tspan>
              <tspan x="43.96" y="0" letterSpacing="0em">
                s
              </tspan>
              <tspan x="52.96" y="0" letterSpacing="0em">
                te
              </tspan>
              <tspan x="69.01" y="0">
                g
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1471.44 400.53)"
            >
              <tspan x="0" y="0">
                K
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1483.44 400.53)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                r
              </tspan>
              <tspan x="7.03" y="0" letterSpacing="0em">
                a
              </tspan>
              <tspan x="17.03" y="0" letterSpacing="0em">
                f
              </tspan>
              <tspan x="23.06" y="0" letterSpacing="0em">
                t
              </tspan>
              <tspan x="29.08" y="0" letterSpacing="0em">
                w
              </tspan>
              <tspan x="44.04" y="0" letterSpacing="0em">
                e
              </tspan>
              <tspan x="54.03" y="0" letterSpacing="0em">
                rk
              </tspan>
              <tspan x="70.08" y="0" letterSpacing="0em"></tspan>
              <tspan x="75.11" y="0" letterSpacing="0em">
                M
              </tspan>
              <tspan x="92.05" y="0" letterSpacing="0em">
                ü
              </tspan>
              <tspan x="103.03" y="0" letterSpacing="0em">
                n
              </tspan>
              <tspan x="114.02" y="0" letterSpacing="0em">
                s
              </tspan>
              <tspan x="123.02" y="0" letterSpacing="0em">
                te
              </tspan>
              <tspan x="139.07" y="0">
                r
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1507.66 363.4)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                M
              </tspan>
              <tspan x="16.94" y="0" letterSpacing="0em">
                ü
              </tspan>
              <tspan x="27.92" y="0" letterSpacing="0em">
                nst
              </tspan>
              <tspan x="53.96" y="0" letterSpacing="0em">
                e
              </tspan>
              <tspan x="63.96" y="0" letterSpacing="0em">
                r
              </tspan>
              <tspan x="70.99" y="0" letterSpacing="0em"></tspan>
              <tspan x="76.02" y="0" letterSpacing="0em">
                V
              </tspan>
              <tspan x="88.02" y="0" letterSpacing="0em">
                i
              </tspan>
              <tspan x="93.05" y="0" letterSpacing="0em">
                a
              </tspan>
              <tspan x="103.06" y="0" letterSpacing="0em">
                d
              </tspan>
              <tspan x="114.04" y="0" letterSpacing="0em">
                u
              </tspan>
              <tspan x="125.04" y="0" letterSpacing="0em">
                k
              </tspan>
              <tspan x="134.03" y="0">
                t
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1560.35 311.17)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Mü
              </tspan>
              <tspan x="27.93" y="0" letterSpacing="0em">
                n
              </tspan>
              <tspan x="38.91" y="0" letterSpacing="0em">
                s
              </tspan>
              <tspan x="47.93" y="0" letterSpacing="0em">
                t
              </tspan>
              <tspan x="53.94" y="0" letterSpacing="0em">
                er
              </tspan>
              <tspan x="70.99" y="0" letterSpacing="0em"></tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1541.45 330.18)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                R
              </tspan>
              <tspan x="12" y="0" letterSpacing="0em">
                a
              </tspan>
              <tspan x="21.99" y="0" letterSpacing="0em">
                tha
              </tspan>
              <tspan x="49.03" y="0" letterSpacing="0em">
                u
              </tspan>
              <tspan x="60.01" y="0" letterSpacing="0em">
                s
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1591.63 279.24)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Fre
              </tspan>
              <tspan x="27.06" y="0" letterSpacing="0em">
                ib
              </tspan>
              <tspan x="43.07" y="0" letterSpacing="0em">
                erg
              </tspan>
              <tspan x="71.11" y="0" letterSpacing="0em">
                s
              </tspan>
              <tspan x="80.11" y="0" letterSpacing="0em">
                tr
              </tspan>
              <tspan x="93.18" y="0" letterSpacing="0em">
                .
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 1619.79 252.5)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                E
              </tspan>
              <tspan x="10.98" y="0" letterSpacing="0em">
                l
              </tspan>
              <tspan x="16.03" y="0" letterSpacing="0em">
                b
              </tspan>
              <tspan x="27.01" y="0" letterSpacing="0em">
                e
              </tspan>
              <tspan x="37.02" y="0" letterSpacing="0em">
                s
              </tspan>
              <tspan x="46.02" y="0" letterSpacing="0em">
                tr
              </tspan>
              <tspan x="59.08" y="0">
                .
              </tspan>
            </text>
            <g
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
            >
              <text transform="matrix(1 0 0 1.18 850.16 1203.41)">
                <tspan x="0" y="0" letterSpacing="0em">
                  W
                </tspan>
                <tspan x="17.92" y="0" letterSpacing="0em">
                  a
                </tspan>
                <tspan x="27.94" y="0" letterSpacing="0em">
                  l
                </tspan>
                <tspan x="32.97" y="0" letterSpacing="0em">
                  d
                </tspan>
                <tspan x="43.96" y="0">
                  -
                </tspan>
              </text>
              <text transform="matrix(1 0 0 1.18 861.16 1222.42)">
                <tspan x="0" y="0" letterSpacing="0em">
                  e
                </tspan>
                <tspan x="10" y="0" letterSpacing="0em">
                  c
                </tspan>
                <tspan x="19.01" y="0">
                  k
                </tspan>
              </text>
              <text transform="matrix(1 0 0 1.18 780.6 1203.24)">
                <tspan x="0" y="0" letterSpacing="0em">
                  K
                </tspan>
                <tspan x="12" y="0" letterSpacing="0em">
                  al
                </tspan>
                <tspan x="27.02" y="0" letterSpacing="0em">
                  te
                </tspan>
                <tspan x="43.07" y="0" letterSpacing="0em">
                  n
                </tspan>
                <tspan x="54.05" y="0">
                  -
                </tspan>
              </text>
              <text transform="matrix(1 0 0 1.18 800.11 1222.25)">
                <tspan x="0" y="0" letterSpacing="0em">
                  t
                </tspan>
                <tspan x="6.03" y="0" letterSpacing="0em">
                  a
                </tspan>
                <tspan x="16.03" y="0" letterSpacing="0em">
                  l
                </tspan>
              </text>
              <text transform="matrix(1 0 0 1.18 712.81 1203.24)">
                <tspan x="0" y="0" letterSpacing="0em">
                  Eng
                </tspan>
                <tspan x="32.99" y="0" letterSpacing="0em">
                  e
                </tspan>
                <tspan x="42.98" y="0">
                  l
                </tspan>
              </text>
              <text transform="matrix(1 0 0 1.18 709.24 1222.25)">
                <tspan x="0" y="0" letterSpacing="0em">
                  bo
                </tspan>
                <tspan x="21.99" y="0" letterSpacing="0em">
                  l
                </tspan>
                <tspan x="27.02" y="0" letterSpacing="0em">
                  ds
                </tspan>
                <tspan x="47.03" y="0" letterSpacing="0em">
                  t
                </tspan>
                <tspan x="53.05" y="0" letterSpacing="0em">
                  r
                </tspan>
                <tspan x="60.08" y="0" letterSpacing="0em">
                  .
                </tspan>
              </text>
            </g>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 507.05 1203.69)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Fa
              </tspan>
              <tspan x="20.03" y="0" letterSpacing="0em">
                u
              </tspan>
              <tspan x="31.01" y="0" letterSpacing="0em">
                s
              </tspan>
              <tspan x="40.02" y="0" letterSpacing="0em">
                ts
              </tspan>
              <tspan x="55.03" y="0" letterSpacing="0em">
                tr
              </tspan>
              <tspan x="68.1" y="0">
                .
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 342.26 1245.17)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                V
              </tspan>
              <tspan x="12" y="0" letterSpacing="0em">
                a
              </tspan>
              <tspan x="21.99" y="0" letterSpacing="0em">
                ih
              </tspan>
              <tspan x="38.04" y="0" letterSpacing="0em">
                i
              </tspan>
              <tspan x="43.07" y="0" letterSpacing="0em">
                nge
              </tspan>
              <tspan x="75.08" y="0" letterSpacing="0em">
                n
              </tspan>
              <tspan x="86.05" y="0" letterSpacing="0em">
                {" "}
                S
              </tspan>
              <tspan x="103.1" y="0" letterSpacing="0em">
                c
              </tspan>
              <tspan x="112.1" y="0" letterSpacing="0em">
                h
              </tspan>
              <tspan x="123.09" y="0" letterSpacing="0em">
                i
              </tspan>
              <tspan x="128.13" y="0" letterSpacing="0em">
                l
              </tspan>
              <tspan x="133.18" y="0" letterSpacing="0em">
                l
              </tspan>
              <tspan x="138.21" y="0" letterSpacing="0em">
                erpla
              </tspan>
              <tspan x="181.32" y="0" letterSpacing="0em">
                t
              </tspan>
              <tspan x="187.33" y="0" letterSpacing="0em">
                z
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 592.48 1149.85)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                V
              </tspan>
              <tspan x="12" y="0" letterSpacing="0em">
                ai
              </tspan>
              <tspan x="27.02" y="0" letterSpacing="0em">
                hi
              </tspan>
              <tspan x="43.07" y="0" letterSpacing="0em">
                n
              </tspan>
              <tspan x="54.05" y="0" letterSpacing="0em">
                ge
              </tspan>
              <tspan x="75.06" y="0">
                n
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="17.85"
              transform="matrix(1 0 0 1.18 603.48 1168.85)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                V
              </tspan>
              <tspan x="12" y="0" letterSpacing="0em">
                ia
              </tspan>
              <tspan x="27.02" y="0" letterSpacing="0em">
                duk
              </tspan>
              <tspan x="58.03" y="0">
                t
              </tspan>
            </text>
          </g>
          <g id="U1_Startend" strokeWidth="0" data-name="U1 Startend">
            <path
              fill="#fff"
              d="M2204.44 848.8H2250.67V882.8199999999999H2204.44z"
            ></path>
            <path
              fill="#d2a070"
              d="M2208.7 853.06H2246.3999999999996V878.5699999999999H2208.7z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M2222.94 857.47v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.08-1.81 7.11-6.42v-10.47h-4.12zM2236.73 858.16a11.55 11.55 0 01-4.12 2.55v3.53c1.24-.46 2.39-1.19 3.49-1.97v11.76h3.92v-15.86h-3.28z"
            ></path>
            <path fill="#fff" d="M365.78 1265.22H412.01V1299.24H365.78z"></path>
            <path
              fill="#d2a070"
              d="M370.05 1269.48H407.75V1294.99H370.05z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M384.28 1273.89v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.08-1.81 7.11-6.42v-10.47h-4.12zM398.07 1274.58a11.55 11.55 0 01-4.12 2.55v3.53c1.24-.46 2.39-1.19 3.49-1.97v11.76h3.92v-15.86h-3.28z"
            ></path>
          </g>
          <g id="u14_StartEnd" strokeWidth="0" data-name="u14 StartEnd">
            <path fill="#fff" d="M1930.4 191.78H1974.93V220.81H1930.4z"></path>
            <path
              fill="#6eb53e"
              d="M1934.66 193.68H1972.3600000000001V219.19H1934.66z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M1946.23 198.1v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44V198.1h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42V198.1h-3.44zM1955.67 198.79c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.45 2-1.19 2.91-1.97v11.76h3.27v-15.86h-2.73zM1962.63 208.33l2.77-5.89h.03v5.89h-2.8zm-2.9 2.98h5.65v3.05h3.32v-3.05h1.8v-2.98h-1.8v-9.83h-3.94l-5.03 9.83v2.98z"
            ></path>
            <path fill="#fff" d="M1126.9 657.82H1171.43V686.85H1126.9z"></path>
            <path
              fill="#6eb53e"
              d="M1131.17 659.72H1168.8700000000001V685.23H1131.17z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M1142.74 664.14v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1152.17 664.83c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.45 2-1.19 2.91-1.97v11.76h3.27v-15.86h-2.73zM1159.13 674.38l2.77-5.89h.03v5.89h-2.8zm-2.9 2.98h5.65v3.05h3.32v-3.05h1.8v-2.98h-1.8v-9.83h-3.94l-5.03 9.83v2.98z"
            ></path>
          </g>
          <g id="U11_StartEnd" strokeWidth="0" data-name="U11 StartEnd">
            <path fill="#fff" d="M1528.34 736.73H1574.57V770.75H1528.34z"></path>
            <path fill="#9c9b9b" d="M1532.6 740.99H1570.3V766.5H1532.6z"></path>
            <path
              fill="#fff"
              d="M1544.59 745.28v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1554.54 745.96c-1 1.15-2.18 2.02-3.44 2.55v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1563.94 745.96c-1 1.15-2.18 2.02-3.44 2.55v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.26v-15.86h-2.73z"
            ></path>
            <path fill="#fff" d="M1170.79 655.75H1217.02V689.77H1170.79z"></path>
            <path fill="#9c9b9b" d="M1175.06 660H1212.76V685.51H1175.06z"></path>
            <path
              fill="#fff"
              d="M1187.04 664.29v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1196.99 664.98c-1 1.15-2.18 2.02-3.44 2.55v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1206.39 664.98c-1 1.15-2.18 2.02-3.44 2.55v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.26v-15.86h-2.73z"
            ></path>
          </g>
        </g>
      </g>
      <g ref={unchangedTracks} id="U_Unchanged" data-name="U Unchanged">
        <g id="U_Linien_Unchanged" fill="none" data-name="U Linien Unchanged">
          <path
            id="U19"
            stroke="#fbba00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M2211.56 310.15L1775.3 310.15 1559.41 526.05"
          ></path>
          <path
            stroke="#ef7d00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M846.97 694.12L901.43 748.59 913.6 748.59 1113.97 948.96 1136.5 948.98 1194.2 891.35"
          ></path>
          <g strokeMiterlimit="10">
            <path
              stroke="#fff"
              strokeWidth="8.5"
              d="M907.54 754.69L907.54 742.53"
            ></path>
            <path
              stroke="#8164a9"
              strokeWidth="5.39"
              d="M1200.76 896.86L1140.08 957.54 1110.39 957.54 907.54 754.69 907.54 742.53 853.05 688.04"
            ></path>
          </g>
          <path
            stroke="#ef7d00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M2207.99 301.58L1771.73 301.58 1376.84 696.71 1376.84 708.56 1205.06 880.34"
          ></path>
          <path
            stroke="#ef7d00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M835.64 688.51L559.71 964.43 158.07 964.43"
          ></path>
          <path
            stroke="#8164a9"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1761.47 740.43L1761.47 956.09 1535.48 956.09 1338.68 758.76 1225.71 871.62"
          ></path>
          <path
            stroke="#8164a9"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M557.75 630.93L796 630.93 837.05 672.03"
          ></path>
          <path
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="17.57"
            d="M1398.94 642.62L1375.92 619.52"
          ></path>
          <g strokeMiterlimit="10">
            <path
              stroke="#ccc100"
              strokeWidth="5.67"
              d="M335.01 627.96L665.76 297.15 1213.02 297.15"
            ></path>
            <path
              stroke="#fff"
              strokeWidth="25.51"
              d="M1587.07 462.01L1644.3 462.04"
            ></path>
            <path
              stroke="#ccc100"
              strokeWidth="5.39"
              d="M1210.81 301.46L1370.19 460.76 1370.19 460.76 1370.19 619.76 1399.75 649.32 1587.07 462.01 1822.47 462.04 2218.3 857.87"
            ></path>
          </g>
          <path
            stroke="#fbba00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1005.64 1187.17L960.32 1141.85"
          ></path>
          <path
            stroke="#fbba00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1069.59 1032.89L1262.4 1225.53 1231.44 1256.48"
          ></path>
          <path
            stroke="#e6007e"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1092.22 305.67L1216.51 305.67"
          ></path>
          <path
            stroke="#e6007e"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M138.12 837.07L669.31 305.67 1073.02 305.67"
          ></path>
          <g stroke="#c6bd7f" strokeWidth="5.39">
            <path d="M1420.11 1204.53L1331.98 1204.53 1242.81 1293.65 512.51 1294.22 502.42 1304.18"></path>
            <path d="M1908.05 1604.75L1507.72 1204.53 1421.61 1204.53"></path>
          </g>
          <path
            id="U3"
            stroke="#955c36"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1288.92 1581.35L1010.26 1302.68 516.22 1302.68 505.61 1313.17"
          ></path>
          <g stroke="#004f9f" strokeMiterlimit="10" strokeWidth="5.39">
            <path d="M1098.37 770.23L1691.39 1363.18"></path>
            <path d="M1214.04 310.12L1043.78 480.38 1043.79 715.72 1098.37 770.29"></path>
          </g>
          <path
            stroke="#fff"
            strokeWidth="18.43"
            d="M1321.25 962.34L1321.25 1020.52"
          ></path>
          <path
            stroke="#96c2e9"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1111.95 760.24L1060.64 708.85 1060.64 677.56 1106.45 631.74 1106.45 521.6 1440.62 187.44 2206.06 187.44"
          ></path>
          <path
            stroke="#96c2e9"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1325.28 1187.28L1325.22 972.7 1111.95 759.61"
          ></path>
          <path
            stroke="#fff"
            strokeWidth="10.77"
            d="M760.26 1273.13L719.12 1314.27"
          ></path>
          <path
            stroke="#96c2e9"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M623.36 1408.06L748.04 1285.37 878.73 1285.37 878.76 1285.37 1239.72 1284.73 1325.29 1199.26 1325.28 1179.56"
          ></path>
          <path
            stroke="#00a984"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1220.96 299.34L1220.96 134.83 1273.98 81.83 2204.02 81.83"
          ></path>
          <path
            stroke="#fff"
            strokeWidth="9.92"
            d="M1332.63 1196.34L1311.21 1175"
          ></path>
          <path
            stroke="#00a984"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1103.94 763.83L1052.33 712.27 1052.33 483.61 1231.36 304.86"
          ></path>
          <path
            stroke="#00a984"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1420.11 1195.8L1332.06 1195.8 1316.89 1180.65 1316.83 976.47 1103.94 763.77"
          ></path>
          <path
            stroke="#00a984"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1919.74 1603.93L1511.62 1195.94 1421.61 1195.94"
          ></path>
          <g id="U5">
            <path
              stroke="#fff"
              strokeWidth="18.43"
              d="M909.11 1273.13L867.97 1314.27"
            ></path>
            <path
              stroke="#00b1eb"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1088.62 784.45L1026.82 722.49 1026.82 479.02 709.74 479.02"
            ></path>
            <path
              stroke="#00b1eb"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1299.76 1187.94L1299.77 996.16 1088.62 784.39"
            ></path>
            <path
              stroke="#00b1eb"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M614.44 1561.9L907.69 1268.46 1231.86 1268.46 1299.78 1200.16 1299.78 1180.2"
            ></path>
          </g>
          <path
            stroke="#e6007e"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1308.37 1181.8L1308.33 1203.87 1235.61 1276.99 911.23 1276.99 777.68 1410.58 777.52 1709.59"
          ></path>
          <path
            stroke="#e6007e"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1092.22 776.37L1308.27 992.41 1308.33 1189.56"
          ></path>
          <path
            stroke="#e6007e"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1210.75 301.43L1035.31 476.67 1035.31 719.53 1092.22 776.43"
          ></path>
          <g>
            <path
              stroke="#fff"
              strokeWidth="9.92"
              d="M1770.07 449.22L1770.07 475.04"
            ></path>
            <path
              stroke="#f3a4b9"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M677.28 288.93L1213.02 288.93"
            ></path>
            <path
              stroke="#f3a4b9"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1951.62 1140.47L1770.08 958.85 1770.08 453.82 1583.04 453.79 1399.58 637.25 1378.79 616.47 1378.79 457.46 1214.49 293.23"
            ></path>
          </g>
          <path
            stroke="#004f9f"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M118.54 81.69L1157.19 81.7 1212.44 136.96 1212.44 301.41"
          ></path>
          <path
            stroke="#fbba00"
            strokeMiterlimit="10"
            strokeWidth="5.39"
            d="M1544.42 734.57L1448.49 636.93 1543.84 541.57"
          ></path>
        </g>
        <g id="U_White_Kopie" data-name="U White Kopie">
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.84"
            d="M1200.46 284.92H1233.23V317.91H1200.46z"
            transform="rotate(-45.03 1216.718 301.436)"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.84"
            d="M1758.66 953.28H1772.8200000000002V967.4H1758.66z"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.83"
            d="M1183.75 860.22H1223.27V891.15H1183.75z"
            transform="rotate(-45.02 1203.577 875.71)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M235.99 952.87H240.24V967.33H235.99z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M315.96 952.87H320.21V967.33H315.96z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M395.93 952.87H400.18V967.33H395.93z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M475.9 952.87H480.15V967.33H475.9z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1611.43 953.12H1615.68V967.58H1611.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1647.88 953.12H1652.13V967.58H1647.88z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1660.79 184.67H1665.04V199.13H1660.79z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1724.94 184.67H1729.19V199.13H1724.94z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1793.47 184.67H1797.72V199.13H1793.47z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1862.01 184.67H1866.26V199.13H1862.01z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1930.54 184.67H1934.79V199.13H1930.54z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1999.08 184.34H2003.33V190.53H1999.08z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2067.61 184.34H2071.86V190.53H2067.61z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2136.15 184.34H2140.4V190.53H2136.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M757.88 285.74H762.13V308.79H757.88z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M675.15 285.74H679.4V308.79H675.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M849.67 285.74H853.92V308.79H849.67z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M941.47 285.74H945.72V308.79H941.47z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1163.05 285.74H1167.3V308.8H1163.05z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M832.95 1340.38H837.2V1355.1200000000001H832.95z"
            transform="rotate(-45 834.93 1347.64)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M213.07 756.65H217.32V763H213.07z"
            transform="rotate(-45 215.145 759.764)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M276.07 693.65H280.32V700H276.07z"
            transform="rotate(-45 278.195 696.828)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M336.1 623.49H340.35V638.23H336.1z"
            transform="rotate(-45 338.168 630.806)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M383 576.59H387.25V591.33H383z"
            transform="rotate(-44.99 385.144 583.972)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M429.9 529.7H434.15V544.44H429.9z"
            transform="rotate(-45 431.955 537.029)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M476.79 482.8H481.04V497.54H476.79z"
            transform="rotate(-45 478.854 490.142)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M523.69 435.91H527.94V450.65000000000003H523.69z"
            transform="rotate(-44.99 525.813 443.28)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M570.58 389.01H574.83V403.75H570.58z"
            transform="rotate(-45 572.64 396.365)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M617.48 342.11H621.73V356.85H617.48z"
            transform="rotate(-45 619.604 349.492)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M779.09 1392.75H783.34V1408.93H779.09z"
            transform="rotate(-45 781.354 1400.953)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M723.17 1448.3H727.42V1453.75H723.17z"
            transform="rotate(-45 725.297 1451.032)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M679.24 1348.26H683.49V1353.71H679.24z"
            transform="rotate(-45 681.371 1350.997)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M669.75 1501.73H674V1507.18H669.75z"
            transform="rotate(-45 671.742 1504.325)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1720.79 953.12H1725.04V967.58H1720.79z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1821.49 1021.11H1835.95V1025.3600000000001H1821.49z"
            transform="rotate(-45 1828.708 1023.235)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1420.77 839.83H1435.23V844.08H1420.77z"
            transform="rotate(-45 1427.999 841.954)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1380.71 799.78H1395.17V804.03H1380.71z"
            transform="rotate(-45 1387.908 801.9)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1878.7 1078.32H1893.16V1082.57H1878.7z"
            transform="rotate(-45 1885.921 1080.436)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1684.33 953.12H1688.58V967.58H1684.33z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1418.85 1192.94H1423.1V1207.4H1418.85z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1522.3 1216.09H1545.55V1220.34H1522.3z"
            transform="rotate(-45 1533.878 1218.207)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1552.49 1246.29H1575.74V1250.54H1552.49z"
            transform="rotate(-45 1564.119 1248.41)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1582.69 1276.48H1605.94V1280.73H1582.69z"
            transform="rotate(-45.02 1594.23 1278.587)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1612.88 1306.68H1636.13V1310.93H1612.88z"
            transform="rotate(-45.02 1624.466 1308.788)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1643.08 1336.88H1666.33V1341.13H1643.08z"
            transform="rotate(-45 1654.705 1339.009)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1673.28 1367.07H1696.53V1371.32H1673.28z"
            transform="rotate(-45.02 1684.817 1369.17)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1704.37 1400.39H1719.58V1404.64H1704.37z"
            transform="rotate(-45.01 1712.06 1402.545)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1734.56 1430.59H1749.77V1434.84H1734.56z"
            transform="rotate(-45.01 1742.263 1432.747)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1764.76 1460.78H1779.97V1465.03H1764.76z"
            transform="rotate(-45.01 1772.454 1462.944)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1794.96 1490.98H1810.17V1495.23H1794.96z"
            transform="rotate(-45.01 1802.662 1493.135)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1825.15 1521.18H1840.3600000000001V1525.43H1825.15z"
            transform="rotate(-45.01 1832.852 1523.332)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1855.35 1551.37H1870.56V1555.62H1855.35z"
            transform="rotate(-45.01 1863.055 1553.534)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1885.54 1581.57H1900.75V1585.82H1885.54z"
            transform="rotate(-45.01 1893.246 1583.731)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1023.69 489.08H1055.3700000000001V493.33H1023.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1023.93 572.08H1112.99V576.33H1023.93z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1132.19 822.52H1173.01V826.77H1132.19z"
            transform="rotate(-45.01 1152.574 824.645)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1246.71 937.31H1287.53V941.56H1246.71z"
            transform="rotate(-45.01 1267.1 939.428)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1294.64 1102.47H1330.0500000000002V1106.76H1294.64z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1294.64 1016.78H1330.0500000000002V1021.0699999999999H1294.64z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M974.37 1265.03H978.62V1305.85H974.37z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1241.47 1248.11H1245.72V1288.9299999999998H1241.47z"
            transform="rotate(-45.01 1243.613 1268.525)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1297.77 1202.27H1302.02V1234.36H1297.77z"
            transform="rotate(-45.01 1299.844 1218.296)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1031.29 1265.03H1035.54V1297.19H1031.29z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1088.22 1265.03H1092.47V1297.19H1088.22z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1145.14 1265.03H1149.39V1297.19H1145.14z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1202.07 1265.03H1206.32V1297.19H1202.07z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M764.1 1282.16H768.35V1305.8500000000001H764.1z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M673.78 1282.16H678.03V1305.8500000000001H673.78z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M854.42 1282.16H858.67V1305.8500000000001H854.42z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M917.44 1264.71H921.69V1305.8500000000001H917.44z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M562.49 946.26H566.74V960.72H562.49z"
            transform="rotate(-45 564.614 953.48)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M616.5 892.31H620.75V906.5999999999999H616.5z"
            transform="rotate(-45 618.627 899.456)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M562.71 946.01H566.96V960.3H562.71z"
            transform="rotate(-45 564.831 953.16)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M831.69 677.52H835.94V691.81H831.69z"
            transform="rotate(-45 833.816 684.662)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
            transform="rotate(-45 1030.196 1067.049)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1099.94 983.73H1104.19V1006.36H1099.94z"
            transform="rotate(-45 1102.213 995.098)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M992.53 1091.32H996.78V1113.95H992.53z"
            transform="rotate(-45 994.655 1102.63)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
            transform="rotate(-45 1064.017 1027.29)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M951.78 1128.57H958.52V1144.78H951.78z"
            transform="rotate(-45 955.082 1136.642)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M670.3 838.61H674.55V852.9H670.3z"
            transform="rotate(-45 672.423 845.753)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M724.1 784.91H728.35V799.1999999999999H724.1z"
            transform="rotate(-45 726.23 792.056)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M777.9 731.22H782.15V745.51H777.9z"
            transform="rotate(-45 780.02 738.365)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1112.6 505.93H1116.85V520.39H1112.6z"
            transform="rotate(-45 1114.726 513.155)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1153.94 464.8H1158.19V479.26H1153.94z"
            transform="rotate(-45 1156.071 472.03)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1100.31 410.08H1104.56V433.06H1100.31z"
            transform="rotate(-45 1102.459 421.567)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 142.91H1223.89V147.16H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 176.22H1223.89V180.47H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 209.54H1223.89V213.79H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 242.85H1223.89V247.1H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1758.55 489.61H1773.01V493.86H1758.55z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1487.17 686.98H1501.73V691.23H1487.17z"
            transform="rotate(-45 1494.448 689.11)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M537.47 1251.5H541.72V1257.45H537.47z"
            transform="rotate(-45 539.594 1254.483)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M583.47 1205.46H587.72V1211.41H583.47z"
            transform="rotate(-45 585.592 1208.44)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M632.16 1176.82H636.41V1182.77H632.16z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M659.77 627.96H664.02V633.9100000000001H659.77z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 604.4H1773.04V608.65H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 679.34H1773.04V683.59H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 641.87H1773.04V646.12H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.7 1447.45H780.6500000000001V1451.7H774.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.7 1491.07H780.6500000000001V1495.32H774.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1534.68H780.58V1538.93H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1578.29H780.58V1582.54H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1621.9H780.58V1626.15H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1665.51H780.58V1669.76H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 566.93H1773.04V571.18H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1936.21 586.7H1950.48V590.95H1936.21z"
            transform="rotate(-45 1943.35 588.828)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1989.31 639.8H2003.58V644.05H1989.31z"
            transform="rotate(-45 1996.448 641.934)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1300.01 389.74H1314.4V393.99H1300.01z"
            transform="rotate(-45 1307.207 391.867)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1333.8 423.53H1348.19V427.78H1333.8z"
            transform="rotate(-45 1340.925 425.66)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
            transform="rotate(-45 2049.55 695.028)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2095.52 746.01H2109.79V750.26H2095.52z"
            transform="rotate(-45 2102.648 748.135)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2148.62 799.11H2162.89V803.36H2148.62z"
            transform="rotate(-45 2155.75 801.23)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1147.81 78.74H1152.06V84.69H1147.81z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1281.69 78.74H1285.94V84.69H1281.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1395.74 78.74H1399.99V84.69H1395.74z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1530.56 78.74H1534.81V84.69H1530.56z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2204.69 297.79H2208.94V303.74H2204.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2111.7 298.64H2115.95V313.13H2111.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2018.71 298.64H2022.96V313.13H2018.71z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1925.72 298.64H1929.97V313.13H1925.72z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1832.73 298.64H1836.98V313.13H1832.73z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1522.96 184.78H1527.21V190.73H1522.96z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1799.38 459.31H1803.63V473.48H1799.38z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1742.35 327.67H1746.6V342.17H1742.35z"
            transform="rotate(-45.01 1744.453 334.931)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
            transform="rotate(-45 1615.166 230.136)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1575.42 264.64H1579.67V270.59H1575.42z"
            transform="rotate(-45 1577.718 267.588)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
            transform="rotate(-45 1540.103 305.068)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
            transform="rotate(-45 1502.829 342.478)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1432.76 190.31H1437.01V196.26H1432.76z"
            transform="rotate(-45 1435.028 193.252)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1380.41 242.65H1384.66V248.6H1380.41z"
            transform="rotate(-45 1382.688 245.592)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1328.07 295H1332.32V300.95H1328.07z"
            transform="rotate(-45 1330.313 297.946)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1463.09 376.97H1467.34V382.92H1463.09z"
            transform="rotate(-45 1465.382 379.929)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1425.65 414.42H1429.9V420.37H1425.65z"
            transform="rotate(-45 1427.935 417.38)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1683.77 386.24H1688.02V400.74H1683.77z"
            transform="rotate(-45.01 1685.99 393.483)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1665.39 78.74H1669.64V84.69H1665.39z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1800.21 78.74H1804.46V84.69H1800.21z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1935.04 78.74H1939.29V84.69H1935.04z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2069.86 78.74H2074.11V84.69H2069.86z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M761.73 627.96H765.98V633.9100000000001H761.73z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1253.87 1228.9H1258.12V1234.8500000000001H1253.87z"
            transform="rotate(-45 1255.997 1231.87)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1506.97 866.87H1512.92V871.12H1506.97z"
            transform="rotate(-45 1509.95 868.998)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1102.65 1066.74H1108.6000000000001V1070.99H1102.65z"
            transform="rotate(-45 1105.628 1068.864)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1133.81 1097.9H1139.76V1102.15H1133.81z"
            transform="rotate(-45 1136.786 1100.028)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1164.97 1129.06H1170.92V1133.31H1164.97z"
            transform="rotate(-45 1167.945 1131.191)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1196.13 1160.22H1202.0800000000002V1164.47H1196.13z"
            transform="rotate(-45 1199.132 1162.353)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1227.29 1191.38H1233.24V1195.63H1227.29z"
            transform="rotate(-45 1230.267 1193.507)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1460.37 881.58H1466.32V885.83H1460.37z"
            transform="rotate(-45 1463.342 883.704)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1493.31 914.62H1499.26V918.87H1493.31z"
            transform="rotate(-45 1496.327 916.741)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1335.92 1008.79H1341.8700000000001V1013.04H1335.92z"
            transform="rotate(-45 1338.894 1010.912)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1365.32 1038.1H1371.27V1042.35H1365.32z"
            transform="rotate(-45 1368.262 1040.217)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1394.72 1067.4H1400.67V1071.65H1394.72z"
            transform="rotate(-45 1397.737 1069.538)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1424.13 1096.71H1430.0800000000002V1100.96H1424.13z"
            transform="rotate(-45 1427.106 1098.843)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1086.37 1379.64H1092.32V1383.89H1086.37z"
            transform="rotate(-45 1089.338 1381.771)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1139.08 1432.35H1145.03V1436.6H1139.08z"
            transform="rotate(-45 1142.05 1434.477)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1244.5 1537.78H1250.45V1542.03H1244.5z"
            transform="rotate(-45 1247.48 1539.907)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1191.79 1485.06H1197.74V1489.31H1191.79z"
            transform="rotate(-45 1194.774 1487.189)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1453.53 1126.02H1459.48V1130.27H1453.53z"
            transform="rotate(-45 1456.504 1128.146)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1482.93 1155.33H1488.88V1159.58H1482.93z"
            transform="rotate(-45 1485.913 1157.455)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1512.34 1184.64H1518.29V1188.89H1512.34z"
            transform="rotate(-45 1515.311 1186.758)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1526.26 947.65H1532.21V951.9H1526.26z"
            transform="rotate(-45 1529.229 949.773)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1543.36 903.14H1549.31V907.39H1543.36z"
            transform="rotate(-45 1546.34 905.255)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M321.59 78.74H325.84V84.69H321.59z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M486.83 78.74H491.08V84.69H486.83z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M652.08 78.74H656.33V84.69H652.08z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M817.32 78.74H821.57V84.69H817.32z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M982.57 78.74H986.82V84.69H982.57z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1147.81 78.74H1152.06V84.69H1147.81z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M975.02 628.16H979.27V667.93H975.02z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1569.87 467.81H1574.12V509.37H1569.87z"
            transform="rotate(-45.03 1571.841 488.6)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1145.18 749.99H1192.8V776.44H1145.18z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1783.35 717.73L1783.33 740.22 1740.94 740.23 1740.95 717.73 1783.35 717.73z"
          ></path>
          <g
            id="station_whites"
            fill="#fff"
            strokeWidth="0"
            data-name="station whites"
          >
            <path
              d="M1388.89 660.13H1393.14V692.29H1388.89z"
              transform="rotate(-45.02 1390.95 676.216)"
            ></path>
            <path
              d="M1351.31 697.35H1355.56V729.51H1351.31z"
              transform="rotate(-45.02 1353.404 713.43)"
            ></path>
            <path
              d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
              transform="rotate(-45.03 1420.864 639.565)"
            ></path>
            <path
              d="M1285.1 755.32H1289.35V804.1H1285.1z"
              transform="rotate(-45.03 1287.152 779.707)"
            ></path>
            <path
              d="M1314.76 725.58H1319.01V774.36H1314.76z"
              transform="rotate(-45.03 1316.81 749.964)"
            ></path>
            <path
              d="M1255.33 785.02H1259.58V834.1H1255.33z"
              transform="rotate(-45.03 1257.396 809.55)"
            ></path>
            <path
              d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
              transform="rotate(-45.02 1142.687 932.034)"
            ></path>
          </g>
          <g
            id="Haltepunkte_Standart_Kopie_4_Kopie_Kopie_2_Kopie"
            data-name="Haltepunkte Standart Kopie 4 Kopie Kopie 2 Kopie"
          >
            <g
              id="S-Haltepunkte_Kopie_2_Kopie_4_Kopie_Kopie_2_Kopie"
              strokeWidth="0"
              data-name="S-Haltepunkte Kopie 2 Kopie 4 Kopie Kopie 2 Kopie"
            >
              <path
                fill="#fff"
                d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
              ></path>
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
              <path
                fill="#fff"
                d="M600.73 1560.09H624.65V1568.8799999999999H600.73z"
                transform="rotate(-45 612.555 1564.351)"
              ></path>
              <path
                fill="#fff"
                d="M1264.28 351.67H1279.04V360.46000000000004H1264.28z"
                transform="rotate(-44.99 1271.72 356.064)"
              ></path>
            </g>
          </g>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.84"
            d="M1200.46 284.92H1233.23V317.91H1200.46z"
            transform="rotate(-45.03 1216.718 301.436)"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.84"
            d="M1758.66 953.28H1772.8200000000002V967.4H1758.66z"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.83"
            d="M1183.75 860.22H1223.27V891.15H1183.75z"
            transform="rotate(-45.02 1203.577 875.71)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M235.99 952.87H240.24V967.33H235.99z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M315.96 952.87H320.21V967.33H315.96z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M395.93 952.87H400.18V967.33H395.93z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M475.9 952.87H480.15V967.33H475.9z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1611.43 953.12H1615.68V967.58H1611.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1647.88 953.12H1652.13V967.58H1647.88z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1660.79 184.67H1665.04V199.13H1660.79z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1724.94 184.67H1729.19V199.13H1724.94z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1793.47 184.67H1797.72V199.13H1793.47z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1862.01 184.67H1866.26V199.13H1862.01z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1930.54 184.67H1934.79V199.13H1930.54z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1999.08 184.34H2003.33V190.53H1999.08z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2067.61 184.34H2071.86V190.53H2067.61z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2136.15 184.34H2140.4V190.53H2136.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M757.88 285.74H762.13V308.79H757.88z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M675.15 285.74H679.4V308.79H675.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M849.67 285.74H853.92V308.79H849.67z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M941.47 285.74H945.72V308.79H941.47z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1163.05 285.74H1167.3V308.8H1163.05z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M832.95 1340.38H837.2V1355.1200000000001H832.95z"
            transform="rotate(-45 834.93 1347.64)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M213.07 756.65H217.32V763H213.07z"
            transform="rotate(-45 215.145 759.764)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M276.07 693.65H280.32V700H276.07z"
            transform="rotate(-45 278.195 696.828)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M336.1 623.49H340.35V638.23H336.1z"
            transform="rotate(-45 338.168 630.806)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M383 576.59H387.25V591.33H383z"
            transform="rotate(-44.99 385.144 583.972)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M429.9 529.7H434.15V544.44H429.9z"
            transform="rotate(-45 431.955 537.029)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M476.79 482.8H481.04V497.54H476.79z"
            transform="rotate(-45 478.854 490.142)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M523.69 435.91H527.94V450.65000000000003H523.69z"
            transform="rotate(-44.99 525.813 443.28)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M570.58 389.01H574.83V403.75H570.58z"
            transform="rotate(-45 572.64 396.365)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M617.48 342.11H621.73V356.85H617.48z"
            transform="rotate(-45 619.604 349.492)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M779.09 1392.75H783.34V1408.93H779.09z"
            transform="rotate(-45 781.354 1400.953)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M723.17 1448.3H727.42V1453.75H723.17z"
            transform="rotate(-45 725.297 1451.032)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M679.24 1348.26H683.49V1353.71H679.24z"
            transform="rotate(-45 681.371 1350.997)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M669.75 1501.73H674V1507.18H669.75z"
            transform="rotate(-45 671.742 1504.325)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1720.79 953.12H1725.04V967.58H1720.79z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1821.49 1021.11H1835.95V1025.3600000000001H1821.49z"
            transform="rotate(-45 1828.708 1023.235)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1420.77 839.83H1435.23V844.08H1420.77z"
            transform="rotate(-45 1427.999 841.954)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1380.71 799.78H1395.17V804.03H1380.71z"
            transform="rotate(-45 1387.908 801.9)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1878.7 1078.32H1893.16V1082.57H1878.7z"
            transform="rotate(-45 1885.921 1080.436)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1684.33 953.12H1688.58V967.58H1684.33z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1418.85 1192.94H1423.1V1207.4H1418.85z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1522.3 1216.09H1545.55V1220.34H1522.3z"
            transform="rotate(-45 1533.878 1218.207)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1552.49 1246.29H1575.74V1250.54H1552.49z"
            transform="rotate(-45 1564.119 1248.41)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1582.69 1276.48H1605.94V1280.73H1582.69z"
            transform="rotate(-45.02 1594.23 1278.587)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1612.88 1306.68H1636.13V1310.93H1612.88z"
            transform="rotate(-45.02 1624.466 1308.788)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1643.08 1336.88H1666.33V1341.13H1643.08z"
            transform="rotate(-45 1654.705 1339.009)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1673.28 1367.07H1696.53V1371.32H1673.28z"
            transform="rotate(-45.02 1684.817 1369.17)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1704.37 1400.39H1719.58V1404.64H1704.37z"
            transform="rotate(-45.01 1712.06 1402.545)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1734.56 1430.59H1749.77V1434.84H1734.56z"
            transform="rotate(-45.01 1742.263 1432.747)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1764.76 1460.78H1779.97V1465.03H1764.76z"
            transform="rotate(-45.01 1772.454 1462.944)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1794.96 1490.98H1810.17V1495.23H1794.96z"
            transform="rotate(-45.01 1802.662 1493.135)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1825.15 1521.18H1840.3600000000001V1525.43H1825.15z"
            transform="rotate(-45.01 1832.852 1523.332)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1855.35 1551.37H1870.56V1555.62H1855.35z"
            transform="rotate(-45.01 1863.055 1553.534)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1885.54 1581.57H1900.75V1585.82H1885.54z"
            transform="rotate(-45.01 1893.246 1583.731)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1023.69 489.08H1055.3700000000001V493.33H1023.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1023.93 572.08H1112.99V576.33H1023.93z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1132.19 822.52H1173.01V826.77H1132.19z"
            transform="rotate(-45.01 1152.574 824.645)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1246.71 937.31H1287.53V941.56H1246.71z"
            transform="rotate(-45.01 1267.1 939.428)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1294.64 1102.47H1330.0500000000002V1106.76H1294.64z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1294.64 1016.78H1330.0500000000002V1021.0699999999999H1294.64z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M974.37 1265.03H978.62V1305.85H974.37z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1241.47 1248.11H1245.72V1288.9299999999998H1241.47z"
            transform="rotate(-45.01 1243.613 1268.525)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1297.77 1202.27H1302.02V1234.36H1297.77z"
            transform="rotate(-45.01 1299.844 1218.296)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1031.29 1265.03H1035.54V1297.19H1031.29z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1088.22 1265.03H1092.47V1297.19H1088.22z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1145.14 1265.03H1149.39V1297.19H1145.14z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1202.07 1265.03H1206.32V1297.19H1202.07z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M764.1 1282.16H768.35V1305.8500000000001H764.1z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M673.78 1282.16H678.03V1305.8500000000001H673.78z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M854.42 1282.16H858.67V1305.8500000000001H854.42z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M917.44 1264.71H921.69V1305.8500000000001H917.44z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M562.49 946.26H566.74V960.72H562.49z"
            transform="rotate(-45 564.614 953.48)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M616.5 892.31H620.75V906.5999999999999H616.5z"
            transform="rotate(-45 618.627 899.456)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M562.71 946.01H566.96V960.3H562.71z"
            transform="rotate(-45 564.831 953.16)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M831.69 677.52H835.94V691.81H831.69z"
            transform="rotate(-45 833.816 684.662)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
            transform="rotate(-45 1030.196 1067.049)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1099.94 983.73H1104.19V1006.36H1099.94z"
            transform="rotate(-45 1102.213 995.098)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M992.53 1091.32H996.78V1113.95H992.53z"
            transform="rotate(-45 994.655 1102.63)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
            transform="rotate(-45 1064.017 1027.29)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M951.78 1128.57H958.52V1144.78H951.78z"
            transform="rotate(-45 955.082 1136.642)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M670.3 838.61H674.55V852.9H670.3z"
            transform="rotate(-45 672.423 845.753)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M724.1 784.91H728.35V799.1999999999999H724.1z"
            transform="rotate(-45 726.23 792.056)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M777.9 731.22H782.15V745.51H777.9z"
            transform="rotate(-45 780.02 738.365)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1112.6 505.93H1116.85V520.39H1112.6z"
            transform="rotate(-45 1114.726 513.155)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1153.94 464.8H1158.19V479.26H1153.94z"
            transform="rotate(-45 1156.071 472.03)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1100.31 410.08H1104.56V433.06H1100.31z"
            transform="rotate(-45 1102.459 421.567)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 142.91H1223.89V147.16H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 176.22H1223.89V180.47H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 209.54H1223.89V213.79H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 242.85H1223.89V247.1H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1758.55 489.61H1773.01V493.86H1758.55z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1487.17 686.98H1501.73V691.23H1487.17z"
            transform="rotate(-45 1494.448 689.11)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M537.47 1251.5H541.72V1257.45H537.47z"
            transform="rotate(-45 539.594 1254.483)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M583.47 1205.46H587.72V1211.41H583.47z"
            transform="rotate(-45 585.592 1208.44)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M632.16 1176.82H636.41V1182.77H632.16z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M659.77 627.96H664.02V633.9100000000001H659.77z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 604.4H1773.04V608.65H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 679.34H1773.04V683.59H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 641.87H1773.04V646.12H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.7 1447.45H780.6500000000001V1451.7H774.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.7 1491.07H780.6500000000001V1495.32H774.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1534.68H780.58V1538.93H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1578.29H780.58V1582.54H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1621.9H780.58V1626.15H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1665.51H780.58V1669.76H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 566.93H1773.04V571.18H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1936.21 586.7H1950.48V590.95H1936.21z"
            transform="rotate(-45 1943.35 588.828)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1989.31 639.8H2003.58V644.05H1989.31z"
            transform="rotate(-45 1996.448 641.934)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1300.01 389.74H1314.4V393.99H1300.01z"
            transform="rotate(-45 1307.207 391.867)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1333.8 423.53H1348.19V427.78H1333.8z"
            transform="rotate(-45 1340.925 425.66)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
            transform="rotate(-45 2049.55 695.028)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2095.52 746.01H2109.79V750.26H2095.52z"
            transform="rotate(-45 2102.648 748.135)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2148.62 799.11H2162.89V803.36H2148.62z"
            transform="rotate(-45 2155.75 801.23)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1147.81 78.74H1152.06V84.69H1147.81z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1281.69 78.74H1285.94V84.69H1281.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1395.74 78.74H1399.99V84.69H1395.74z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1530.56 78.74H1534.81V84.69H1530.56z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2204.69 297.79H2208.94V303.74H2204.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2111.7 298.64H2115.95V313.13H2111.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2018.71 298.64H2022.96V313.13H2018.71z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1925.72 298.64H1929.97V313.13H1925.72z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1832.73 298.64H1836.98V313.13H1832.73z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1522.96 184.78H1527.21V190.73H1522.96z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1799.38 459.31H1803.63V473.48H1799.38z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1742.35 327.67H1746.6V342.17H1742.35z"
            transform="rotate(-45.01 1744.453 334.931)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
            transform="rotate(-45 1615.166 230.136)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1575.42 264.64H1579.67V270.59H1575.42z"
            transform="rotate(-45 1577.718 267.588)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
            transform="rotate(-45 1540.103 305.068)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
            transform="rotate(-45 1502.829 342.478)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1432.76 190.31H1437.01V196.26H1432.76z"
            transform="rotate(-45 1435.028 193.252)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1380.41 242.65H1384.66V248.6H1380.41z"
            transform="rotate(-45 1382.688 245.592)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1328.07 295H1332.32V300.95H1328.07z"
            transform="rotate(-45 1330.313 297.946)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1463.09 376.97H1467.34V382.92H1463.09z"
            transform="rotate(-45 1465.382 379.929)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1425.65 414.42H1429.9V420.37H1425.65z"
            transform="rotate(-45 1427.935 417.38)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1683.77 386.24H1688.02V400.74H1683.77z"
            transform="rotate(-45.01 1685.99 393.483)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1665.39 78.74H1669.64V84.69H1665.39z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1800.21 78.74H1804.46V84.69H1800.21z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1935.04 78.74H1939.29V84.69H1935.04z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2069.86 78.74H2074.11V84.69H2069.86z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M761.73 627.96H765.98V633.9100000000001H761.73z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1253.87 1228.9H1258.12V1234.8500000000001H1253.87z"
            transform="rotate(-45 1255.997 1231.87)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1506.97 866.87H1512.92V871.12H1506.97z"
            transform="rotate(-45 1509.95 868.998)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1102.65 1066.74H1108.6000000000001V1070.99H1102.65z"
            transform="rotate(-45 1105.628 1068.864)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1133.81 1097.9H1139.76V1102.15H1133.81z"
            transform="rotate(-45 1136.786 1100.028)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1164.97 1129.06H1170.92V1133.31H1164.97z"
            transform="rotate(-45 1167.945 1131.191)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1196.13 1160.22H1202.0800000000002V1164.47H1196.13z"
            transform="rotate(-45 1199.132 1162.353)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1227.29 1191.38H1233.24V1195.63H1227.29z"
            transform="rotate(-45 1230.267 1193.507)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1460.37 881.58H1466.32V885.83H1460.37z"
            transform="rotate(-45 1463.342 883.704)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1493.31 914.62H1499.26V918.87H1493.31z"
            transform="rotate(-45 1496.327 916.741)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1335.92 1008.79H1341.8700000000001V1013.04H1335.92z"
            transform="rotate(-45 1338.894 1010.912)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1365.32 1038.1H1371.27V1042.35H1365.32z"
            transform="rotate(-45 1368.262 1040.217)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1394.72 1067.4H1400.67V1071.65H1394.72z"
            transform="rotate(-45 1397.737 1069.538)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1424.13 1096.71H1430.0800000000002V1100.96H1424.13z"
            transform="rotate(-45 1427.106 1098.843)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1086.37 1379.64H1092.32V1383.89H1086.37z"
            transform="rotate(-45 1089.338 1381.771)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1139.08 1432.35H1145.03V1436.6H1139.08z"
            transform="rotate(-45 1142.05 1434.477)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1244.5 1537.78H1250.45V1542.03H1244.5z"
            transform="rotate(-45 1247.48 1539.907)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1191.79 1485.06H1197.74V1489.31H1191.79z"
            transform="rotate(-45 1194.774 1487.189)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1453.53 1126.02H1459.48V1130.27H1453.53z"
            transform="rotate(-45 1456.504 1128.146)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1482.93 1155.33H1488.88V1159.58H1482.93z"
            transform="rotate(-45 1485.913 1157.455)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1512.34 1184.64H1518.29V1188.89H1512.34z"
            transform="rotate(-45 1515.311 1186.758)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1526.26 947.65H1532.21V951.9H1526.26z"
            transform="rotate(-45 1529.229 949.773)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1543.36 903.14H1549.31V907.39H1543.36z"
            transform="rotate(-45 1546.34 905.255)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M321.59 78.74H325.84V84.69H321.59z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M486.83 78.74H491.08V84.69H486.83z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M652.08 78.74H656.33V84.69H652.08z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M817.32 78.74H821.57V84.69H817.32z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M982.57 78.74H986.82V84.69H982.57z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1147.81 78.74H1152.06V84.69H1147.81z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M975.02 628.16H979.27V667.93H975.02z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1569.87 467.81H1574.12V509.37H1569.87z"
            transform="rotate(-45.03 1571.841 488.6)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1145.18 749.99H1192.8V776.44H1145.18z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1783.35 717.73L1783.33 740.22 1740.94 740.23 1740.95 717.73 1783.35 717.73z"
          ></path>
          <g
            id="station_whites-2"
            fill="#fff"
            strokeWidth="0"
            data-name="station whites"
          >
            <path
              d="M1388.89 660.13H1393.14V692.29H1388.89z"
              transform="rotate(-45.02 1390.95 676.216)"
            ></path>
            <path
              d="M1351.31 697.35H1355.56V729.51H1351.31z"
              transform="rotate(-45.02 1353.404 713.43)"
            ></path>
            <path
              d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
              transform="rotate(-45.03 1420.864 639.565)"
            ></path>
            <path
              d="M1285.1 755.32H1289.35V804.1H1285.1z"
              transform="rotate(-45.03 1287.152 779.707)"
            ></path>
            <path
              d="M1314.76 725.58H1319.01V774.36H1314.76z"
              transform="rotate(-45.03 1316.81 749.964)"
            ></path>
            <path
              d="M1255.33 785.02H1259.58V834.1H1255.33z"
              transform="rotate(-45.03 1257.396 809.55)"
            ></path>
            <path
              d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
              transform="rotate(-45.02 1142.687 932.034)"
            ></path>
          </g>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
          ></path>
          <g strokeWidth="0">
            <path
              fill="#ededec"
              d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
            ></path>
            <path
              fill="#fff"
              d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
            ></path>
          </g>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M600.73 1560.09H624.65V1568.8799999999999H600.73z"
            transform="rotate(-45 612.555 1564.351)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1264.28 351.67H1279.04V360.46000000000004H1264.28z"
            transform="rotate(-44.99 1271.72 356.064)"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.84"
            d="M1200.46 284.92H1233.23V317.91H1200.46z"
            transform="rotate(-45.03 1216.718 301.436)"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.84"
            d="M1758.66 953.28H1772.8200000000002V967.4H1758.66z"
          ></path>
          <path
            fill="#fff"
            stroke="#fff"
            strokeWidth="2.83"
            d="M1183.75 860.22H1223.27V891.15H1183.75z"
            transform="rotate(-45.02 1203.577 875.71)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M235.99 952.87H240.24V967.33H235.99z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M315.96 952.87H320.21V967.33H315.96z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M395.93 952.87H400.18V967.33H395.93z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M475.9 952.87H480.15V967.33H475.9z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1611.43 953.12H1615.68V967.58H1611.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1647.88 953.12H1652.13V967.58H1647.88z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1660.79 184.67H1665.04V199.13H1660.79z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1724.94 184.67H1729.19V199.13H1724.94z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1793.47 184.67H1797.72V199.13H1793.47z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1862.01 184.67H1866.26V199.13H1862.01z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1930.54 184.67H1934.79V199.13H1930.54z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1999.08 184.34H2003.33V190.53H1999.08z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2067.61 184.34H2071.86V190.53H2067.61z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2136.15 184.34H2140.4V190.53H2136.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M757.88 285.74H762.13V308.79H757.88z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M675.15 285.74H679.4V308.79H675.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M849.67 285.74H853.92V308.79H849.67z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M941.47 285.74H945.72V308.79H941.47z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1163.05 285.74H1167.3V308.8H1163.05z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M832.95 1340.38H837.2V1355.1200000000001H832.95z"
            transform="rotate(-45 834.93 1347.64)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M213.07 756.65H217.32V763H213.07z"
            transform="rotate(-45 215.145 759.764)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M276.07 693.65H280.32V700H276.07z"
            transform="rotate(-45 278.195 696.828)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M336.1 623.49H340.35V638.23H336.1z"
            transform="rotate(-45 338.168 630.806)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M383 576.59H387.25V591.33H383z"
            transform="rotate(-44.99 385.144 583.972)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M429.9 529.7H434.15V544.44H429.9z"
            transform="rotate(-45 431.955 537.029)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M476.79 482.8H481.04V497.54H476.79z"
            transform="rotate(-45 478.854 490.142)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M523.69 435.91H527.94V450.65000000000003H523.69z"
            transform="rotate(-44.99 525.813 443.28)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M570.58 389.01H574.83V403.75H570.58z"
            transform="rotate(-45 572.64 396.365)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M617.48 342.11H621.73V356.85H617.48z"
            transform="rotate(-45 619.604 349.492)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M779.09 1392.75H783.34V1408.93H779.09z"
            transform="rotate(-45 781.354 1400.953)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M723.17 1448.3H727.42V1453.75H723.17z"
            transform="rotate(-45 725.297 1451.032)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M679.24 1348.26H683.49V1353.71H679.24z"
            transform="rotate(-45 681.371 1350.997)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M669.75 1501.73H674V1507.18H669.75z"
            transform="rotate(-45 671.742 1504.325)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1720.79 953.12H1725.04V967.58H1720.79z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1821.49 1021.11H1835.95V1025.3600000000001H1821.49z"
            transform="rotate(-45 1828.708 1023.235)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1420.77 839.83H1435.23V844.08H1420.77z"
            transform="rotate(-45 1427.999 841.954)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1380.71 799.78H1395.17V804.03H1380.71z"
            transform="rotate(-45 1387.908 801.9)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1878.7 1078.32H1893.16V1082.57H1878.7z"
            transform="rotate(-45 1885.921 1080.436)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1684.33 953.12H1688.58V967.58H1684.33z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1418.85 1192.94H1423.1V1207.4H1418.85z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1522.3 1216.09H1545.55V1220.34H1522.3z"
            transform="rotate(-45 1533.878 1218.207)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1552.49 1246.29H1575.74V1250.54H1552.49z"
            transform="rotate(-45 1564.119 1248.41)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1582.69 1276.48H1605.94V1280.73H1582.69z"
            transform="rotate(-45.02 1594.23 1278.587)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1612.88 1306.68H1636.13V1310.93H1612.88z"
            transform="rotate(-45.02 1624.466 1308.788)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1643.08 1336.88H1666.33V1341.13H1643.08z"
            transform="rotate(-45 1654.705 1339.009)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1673.28 1367.07H1696.53V1371.32H1673.28z"
            transform="rotate(-45.02 1684.817 1369.17)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1704.37 1400.39H1719.58V1404.64H1704.37z"
            transform="rotate(-45.01 1712.06 1402.545)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1734.56 1430.59H1749.77V1434.84H1734.56z"
            transform="rotate(-45.01 1742.263 1432.747)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1764.76 1460.78H1779.97V1465.03H1764.76z"
            transform="rotate(-45.01 1772.454 1462.944)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1794.96 1490.98H1810.17V1495.23H1794.96z"
            transform="rotate(-45.01 1802.662 1493.135)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1825.15 1521.18H1840.3600000000001V1525.43H1825.15z"
            transform="rotate(-45.01 1832.852 1523.332)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1855.35 1551.37H1870.56V1555.62H1855.35z"
            transform="rotate(-45.01 1863.055 1553.534)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1885.54 1581.57H1900.75V1585.82H1885.54z"
            transform="rotate(-45.01 1893.246 1583.731)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1023.69 489.08H1055.3700000000001V493.33H1023.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1023.93 572.08H1112.99V576.33H1023.93z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1132.19 822.52H1173.01V826.77H1132.19z"
            transform="rotate(-45.01 1152.574 824.645)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1246.71 937.31H1287.53V941.56H1246.71z"
            transform="rotate(-45.01 1267.1 939.428)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1294.64 1102.47H1330.0500000000002V1106.76H1294.64z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1294.64 1016.78H1330.0500000000002V1021.0699999999999H1294.64z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M974.37 1265.03H978.62V1305.85H974.37z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1241.47 1248.11H1245.72V1288.9299999999998H1241.47z"
            transform="rotate(-45.01 1243.613 1268.525)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1297.77 1202.27H1302.02V1234.36H1297.77z"
            transform="rotate(-45.01 1299.844 1218.296)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1031.29 1265.03H1035.54V1297.19H1031.29z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1088.22 1265.03H1092.47V1297.19H1088.22z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1145.14 1265.03H1149.39V1297.19H1145.14z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1202.07 1265.03H1206.32V1297.19H1202.07z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M764.1 1282.16H768.35V1305.8500000000001H764.1z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M673.78 1282.16H678.03V1305.8500000000001H673.78z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M854.42 1282.16H858.67V1305.8500000000001H854.42z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M917.44 1264.71H921.69V1305.8500000000001H917.44z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M562.49 946.26H566.74V960.72H562.49z"
            transform="rotate(-45 564.614 953.48)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M616.5 892.31H620.75V906.5999999999999H616.5z"
            transform="rotate(-45 618.627 899.456)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M562.71 946.01H566.96V960.3H562.71z"
            transform="rotate(-45 564.831 953.16)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M831.69 677.52H835.94V691.81H831.69z"
            transform="rotate(-45 833.816 684.662)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
            transform="rotate(-45 1030.196 1067.049)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1099.94 983.73H1104.19V1006.36H1099.94z"
            transform="rotate(-45 1102.213 995.098)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M992.53 1091.32H996.78V1113.95H992.53z"
            transform="rotate(-45 994.655 1102.63)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
            transform="rotate(-45 1064.017 1027.29)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M951.78 1128.57H958.52V1144.78H951.78z"
            transform="rotate(-45 955.082 1136.642)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M670.3 838.61H674.55V852.9H670.3z"
            transform="rotate(-45 672.423 845.753)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M724.1 784.91H728.35V799.1999999999999H724.1z"
            transform="rotate(-45 726.23 792.056)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M777.9 731.22H782.15V745.51H777.9z"
            transform="rotate(-45 780.02 738.365)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1112.6 505.93H1116.85V520.39H1112.6z"
            transform="rotate(-45 1114.726 513.155)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1153.94 464.8H1158.19V479.26H1153.94z"
            transform="rotate(-45 1156.071 472.03)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1100.31 410.08H1104.56V433.06H1100.31z"
            transform="rotate(-45 1102.459 421.567)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 142.91H1223.89V147.16H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 176.22H1223.89V180.47H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 209.54H1223.89V213.79H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1209.43 242.85H1223.89V247.1H1209.43z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1758.55 489.61H1773.01V493.86H1758.55z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1487.17 686.98H1501.73V691.23H1487.17z"
            transform="rotate(-45 1494.448 689.11)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M537.47 1251.5H541.72V1257.45H537.47z"
            transform="rotate(-45 539.594 1254.483)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M583.47 1205.46H587.72V1211.41H583.47z"
            transform="rotate(-45 585.592 1208.44)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M632.16 1176.82H636.41V1182.77H632.16z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M659.77 627.96H664.02V633.9100000000001H659.77z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 604.4H1773.04V608.65H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 679.34H1773.04V683.59H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 641.87H1773.04V646.12H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.7 1447.45H780.6500000000001V1451.7H774.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.7 1491.07H780.6500000000001V1495.32H774.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1534.68H780.58V1538.93H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1578.29H780.58V1582.54H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1621.9H780.58V1626.15H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M774.63 1665.51H780.58V1669.76H774.63z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1767.09 566.93H1773.04V571.18H1767.09z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1936.21 586.7H1950.48V590.95H1936.21z"
            transform="rotate(-45 1943.35 588.828)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1989.31 639.8H2003.58V644.05H1989.31z"
            transform="rotate(-45 1996.448 641.934)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1300.01 389.74H1314.4V393.99H1300.01z"
            transform="rotate(-45 1307.207 391.867)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1333.8 423.53H1348.19V427.78H1333.8z"
            transform="rotate(-45 1340.925 425.66)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
            transform="rotate(-45 2049.55 695.028)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2095.52 746.01H2109.79V750.26H2095.52z"
            transform="rotate(-45 2102.648 748.135)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2148.62 799.11H2162.89V803.36H2148.62z"
            transform="rotate(-45 2155.75 801.23)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1147.81 78.74H1152.06V84.69H1147.81z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1281.69 78.74H1285.94V84.69H1281.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1395.74 78.74H1399.99V84.69H1395.74z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1530.56 78.74H1534.81V84.69H1530.56z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2204.69 297.79H2208.94V303.74H2204.69z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2111.7 298.64H2115.95V313.13H2111.7z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2018.71 298.64H2022.96V313.13H2018.71z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1925.72 298.64H1929.97V313.13H1925.72z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1832.73 298.64H1836.98V313.13H1832.73z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1522.96 184.78H1527.21V190.73H1522.96z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1799.38 459.31H1803.63V473.48H1799.38z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1742.35 327.67H1746.6V342.17H1742.35z"
            transform="rotate(-45.01 1744.453 334.931)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
            transform="rotate(-45 1615.166 230.136)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1575.42 264.64H1579.67V270.59H1575.42z"
            transform="rotate(-45 1577.718 267.588)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
            transform="rotate(-45 1540.103 305.068)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
            transform="rotate(-45 1502.829 342.478)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1432.76 190.31H1437.01V196.26H1432.76z"
            transform="rotate(-45 1435.028 193.252)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1380.41 242.65H1384.66V248.6H1380.41z"
            transform="rotate(-45 1382.688 245.592)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1328.07 295H1332.32V300.95H1328.07z"
            transform="rotate(-45 1330.313 297.946)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1463.09 376.97H1467.34V382.92H1463.09z"
            transform="rotate(-45 1465.382 379.929)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1425.65 414.42H1429.9V420.37H1425.65z"
            transform="rotate(-45 1427.935 417.38)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1683.77 386.24H1688.02V400.74H1683.77z"
            transform="rotate(-45.01 1685.99 393.483)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1665.39 78.74H1669.64V84.69H1665.39z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1800.21 78.74H1804.46V84.69H1800.21z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1935.04 78.74H1939.29V84.69H1935.04z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M2069.86 78.74H2074.11V84.69H2069.86z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M761.73 627.96H765.98V633.9100000000001H761.73z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1253.87 1228.9H1258.12V1234.8500000000001H1253.87z"
            transform="rotate(-45 1255.997 1231.87)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1506.97 866.87H1512.92V871.12H1506.97z"
            transform="rotate(-45 1509.95 868.998)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1102.65 1066.74H1108.6000000000001V1070.99H1102.65z"
            transform="rotate(-45 1105.628 1068.864)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1133.81 1097.9H1139.76V1102.15H1133.81z"
            transform="rotate(-45 1136.786 1100.028)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1164.97 1129.06H1170.92V1133.31H1164.97z"
            transform="rotate(-45 1167.945 1131.191)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1196.13 1160.22H1202.0800000000002V1164.47H1196.13z"
            transform="rotate(-45 1199.132 1162.353)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1227.29 1191.38H1233.24V1195.63H1227.29z"
            transform="rotate(-45 1230.267 1193.507)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1460.37 881.58H1466.32V885.83H1460.37z"
            transform="rotate(-45 1463.342 883.704)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1493.31 914.62H1499.26V918.87H1493.31z"
            transform="rotate(-45 1496.327 916.741)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1335.92 1008.79H1341.8700000000001V1013.04H1335.92z"
            transform="rotate(-45 1338.894 1010.912)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1365.32 1038.1H1371.27V1042.35H1365.32z"
            transform="rotate(-45 1368.262 1040.217)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1394.72 1067.4H1400.67V1071.65H1394.72z"
            transform="rotate(-45 1397.737 1069.538)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1424.13 1096.71H1430.0800000000002V1100.96H1424.13z"
            transform="rotate(-45 1427.106 1098.843)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1086.37 1379.64H1092.32V1383.89H1086.37z"
            transform="rotate(-45 1089.338 1381.771)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1139.08 1432.35H1145.03V1436.6H1139.08z"
            transform="rotate(-45 1142.05 1434.477)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1244.5 1537.78H1250.45V1542.03H1244.5z"
            transform="rotate(-45 1247.48 1539.907)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1191.79 1485.06H1197.74V1489.31H1191.79z"
            transform="rotate(-45 1194.774 1487.189)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1453.53 1126.02H1459.48V1130.27H1453.53z"
            transform="rotate(-45 1456.504 1128.146)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1482.93 1155.33H1488.88V1159.58H1482.93z"
            transform="rotate(-45 1485.913 1157.455)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1512.34 1184.64H1518.29V1188.89H1512.34z"
            transform="rotate(-45 1515.311 1186.758)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1526.26 947.65H1532.21V951.9H1526.26z"
            transform="rotate(-45 1529.229 949.773)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1543.36 903.14H1549.31V907.39H1543.36z"
            transform="rotate(-45 1546.34 905.255)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M321.59 78.74H325.84V84.69H321.59z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M486.83 78.74H491.08V84.69H486.83z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M652.08 78.74H656.33V84.69H652.08z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M817.32 78.74H821.57V84.69H817.32z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M982.57 78.74H986.82V84.69H982.57z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1147.81 78.74H1152.06V84.69H1147.81z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M975.02 628.16H979.27V667.93H975.02z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1569.87 467.81H1574.12V509.37H1569.87z"
            transform="rotate(-45.03 1571.841 488.6)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1145.18 749.99H1192.8V776.44H1145.18z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1783.35 717.73L1783.33 740.22 1740.94 740.23 1740.95 717.73 1783.35 717.73z"
          ></path>
          <g
            id="station_whites-3"
            fill="#fff"
            strokeWidth="0"
            data-name="station whites"
          >
            <path
              d="M1388.89 660.13H1393.14V692.29H1388.89z"
              transform="rotate(-45.02 1390.95 676.216)"
            ></path>
            <path
              d="M1351.31 697.35H1355.56V729.51H1351.31z"
              transform="rotate(-45.02 1353.404 713.43)"
            ></path>
            <path
              d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
              transform="rotate(-45.03 1420.864 639.565)"
            ></path>
            <path
              d="M1285.1 755.32H1289.35V804.1H1285.1z"
              transform="rotate(-45.03 1287.152 779.707)"
            ></path>
            <path
              d="M1314.76 725.58H1319.01V774.36H1314.76z"
              transform="rotate(-45.03 1316.81 749.964)"
            ></path>
            <path
              d="M1255.33 785.02H1259.58V834.1H1255.33z"
              transform="rotate(-45.03 1257.396 809.55)"
            ></path>
            <path
              d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
              transform="rotate(-45.02 1142.687 932.034)"
            ></path>
          </g>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M600.73 1560.09H624.65V1568.8799999999999H600.73z"
            transform="rotate(-45 612.555 1564.351)"
          ></path>
          <path
            fill="#fff"
            strokeWidth="0"
            d="M1264.28 351.67H1279.04V360.46000000000004H1264.28z"
            transform="rotate(-44.99 1271.72 356.064)"
          ></path>
        </g>
        <g id="U_Logos_Unchanged" data-name="U Logos Unchanged">
          <g strokeWidth="0">
            <path
              fill="#010000"
              d="M882 1715.65v2.31l10.67-4.33c.22 1.87.36 4.06.65 5.34l-2.7 2.66v2.2l3.4-1.75 3.4 1.75v-2.2l-2.67-2.62c.35-1.28.49-3.48.63-5.37l10.65 4.32v-2.31l-10.39-7.35c.07-2.07.49-8.5-1.62-8.5s-1.62 6.43-1.62 8.5l-10.39 7.35z"
            ></path>
            <g fill="#1d1d1b">
              <path d="M933.54 1717.94c1.03-7.04-4.56-13.84-12.21-14.59-3.57-.34-5.9.96-6.62 3.29-.47 1.5-.19 3.25.68 4.62.91 1.45 2.35 2.29 4.06 2.35 1.38.04 2.59.71 3.24 1.78.58.98.58 2.07.02 2.8-.81 1.06-2.56 1.16-4.71.38-3.9-1.41-6.64-5.14-7.77-8.7l-.86-.29c1.23 4 4.29 8.23 8.64 9.88 2.5.94 4.61.83 5.69-.47.86-1.03.9-2.6.04-4.06-.94-1.6-2.64-2.55-4.52-2.56-1.32 0-2.42-.61-3.08-1.67-.62-.98-.79-2.23-.42-3.28.62-1.78 2.56-2.69 5.52-2.32 6.35.79 11.07 6.34 10.63 12.26l1.66.57"></path>
              <path d="M923.56 1723.76c4.57-.22 7.81-3.91 6.31-9.19-1.98-6.98-8.77-8.73-11.91-7.68-1.15.39-1.45 1.59-1.18 2.51.23.8.97 1.68 2.37 1.61 3.62-.19 6.01 2.48 6.54 5 .54 2.55-.73 4.96-4.21 5-2.18.03-4.43-.82-6.51-2.35l-.4.51c2.3 1.76 4.81 2.77 7.28 2.79 4.16.04 5.79-2.93 5.21-6-.61-3.25-3.65-6.69-8.19-6.31-.54.04-.94-.13-1.03-.45-.08-.27.05-.73.58-.88 2.02-.59 8.01.21 9.93 6.52 1.34 4.41-1.25 7.66-5.15 7.99l.36.93"></path>
              <path d="M914.31 1699.98c-3.17 2.96-3.61 7.71-1.74 11.61 2.09 4.37 5.95 5.55 7.62 5.44.5-.03.64-.35.59-.57-.07-.27-.45-.45-.95-.49-3.48-.21-5.79-2.77-6.78-5.43-1.1-2.98-.92-7.4 2.95-9.79 3.23-2 8.03-1.92 12.65.64l-1.35 1.7c-3.86-2.07-7.97-2.24-10.71-.71-3.34 1.87-3.63 5.4-2.7 7.99.8 2.22 2.74 4.37 5.69 4.47 1.4.05 2.12.92 2.29 1.63.19.78-.23 1.6-1.32 1.64-2.44.09-6.49-1.74-8.69-6.24-2.13-4.37-1.76-10.03 1.8-13.55l.65 1.67"></path>
            </g>
          </g>
          <g id="U-Logo_Kopie" data-name="U-Logo Kopie">
            <g id="U19-2" strokeWidth="0" data-name="U19">
              <path
                fill="#fff"
                d="M1570.72 736.42H1616.95V770.4399999999999H1570.72z"
              ></path>
              <path
                fill="#fbba00"
                d="M1574.98 740.67H1612.68V766.18H1574.98z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1586.38 744.96v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1596.33 745.65c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1601.24 757.54c.04 3.35 2.15 4.42 3.99 4.42 1.59 0 2.4-.37 3.46-1.95.6-.89 1.36-3.25 1.41-5.45.1-4.81-.85-9.14-4.6-9.14-2.28 0-4.43 1.65-4.43 5.48 0 3.09 1.66 5.02 3.59 5.02.95 0 1.9-.53 2.49-1.65l.03.04c-.06 2.04 0 4.68-1.84 4.68-.31 0-.64-.09-.9-.32-.25-.23-.43-.6-.45-1.12h-2.75zm5.84-6.76c0 1.1-.54 2.38-1.62 2.38-.93 0-1.62-.73-1.62-2.38 0-1.44.61-2.38 1.62-2.38s1.62.85 1.62 2.38"
              ></path>
            </g>
            <g id="U19-3" strokeWidth="0" data-name="U19">
              <path
                fill="#fff"
                d="M2204.73 303.74H2250.96V336.08000000000004H2204.73z"
              ></path>
              <path
                fill="#fbba00"
                d="M2208.99 306.32H2246.6899999999996V331.83H2208.99z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M2220.27 311.4v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44V311.4h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42V311.4h-3.44zM2230.22 312.09c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM2235.12 323.98c.05 3.35 2.15 4.42 3.99 4.42 1.59 0 2.4-.37 3.46-1.95.6-.89 1.36-3.25 1.41-5.45.1-4.81-.85-9.14-4.6-9.14-2.28 0-4.43 1.65-4.43 5.48 0 3.09 1.66 5.02 3.59 5.02.95 0 1.9-.53 2.49-1.65l.03.04c-.06 2.04 0 4.68-1.84 4.68-.31 0-.64-.09-.9-.32-.25-.23-.43-.6-.45-1.12h-2.75zm5.84-6.76c0 1.1-.54 2.38-1.62 2.38-.93 0-1.62-.73-1.62-2.38 0-1.44.61-2.38 1.62-2.38s1.62.85 1.62 2.38"
              ></path>
            </g>
            <g id="U19-4" strokeWidth="0" data-name="U19">
              <path
                fill="#fff"
                d="M1529.35 410.97H1575.58V444.99H1529.35z"
              ></path>
              <path
                fill="#fbba00"
                d="M1533.61 415.22H1571.31V440.73H1533.61z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1544.89 419.51v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1554.84 420.2c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27V420.2h-2.73zM1559.74 432.09c.04 3.35 2.15 4.42 3.99 4.42 1.59 0 2.4-.37 3.46-1.95.6-.89 1.36-3.25 1.41-5.45.1-4.81-.85-9.14-4.6-9.14-2.28 0-4.43 1.65-4.43 5.48 0 3.09 1.66 5.02 3.59 5.02.95 0 1.9-.53 2.49-1.65l.03.04c-.06 2.04 0 4.68-1.84 4.68-.31 0-.64-.09-.9-.32-.25-.23-.43-.6-.45-1.12h-2.75zm5.84-6.76c0 1.1-.54 2.38-1.62 2.38-.93 0-1.62-.73-1.62-2.38 0-1.44.61-2.38 1.62-2.38s1.62.85 1.62 2.38"
              ></path>
            </g>
            <g id="U13" strokeWidth="0">
              <path fill="#fff" d="M271.7 602.69H317.93V636.71H271.7z"></path>
              <path
                fill="#ccc100"
                d="M275.97 606.93H313.67V632.4399999999999H275.97z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M310.52 616.7c-.04-3.26-2.09-4.3-3.89-4.3-1.54 0-2.33.36-3.36 1.9-.58.87-1.33 3.16-1.37 5.3-.1 4.68.83 8.9 4.47 8.9 2.21 0 4.31-1.61 4.31-5.33 0-3.01-1.62-4.88-3.49-4.88-.92 0-1.85.51-2.42 1.61l-.03-.05c.06-1.98 0-4.55 1.79-4.55.31 0 .62.09.87.31.24.22.42.58.43 1.09h2.68zm-5.68 6.58c0-1.07.52-2.32 1.57-2.32.9 0 1.57.71 1.57 2.32 0 1.41-.6 2.32-1.57 2.32s-1.57-.83-1.57-2.32M297.28 612.62c-.97 1.11-2.12 1.96-3.35 2.48v3.43c1-.44 1.94-1.16 2.83-1.91v11.44h3.18v-15.43h-2.66zM287.6 611.95v9.97c-.05 2.05-.85 3.34-2.43 3.34s-2.37-1.29-2.42-3.34v-9.97h-3.34v10.19c.03 4.48 2.73 6.25 5.77 6.25s5.74-1.76 5.77-6.25v-10.19h-3.34z"
              ></path>
            </g>
            <g id="U13-2" strokeWidth="0" data-name="U13">
              <path
                fill="#fff"
                d="M2204.75 818.69H2250.98V852.71H2204.75z"
              ></path>
              <path
                fill="#ccc100"
                d="M2209.02 822.94H2246.72V848.45H2209.02z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M2243.58 832.71c-.04-3.26-2.09-4.3-3.89-4.3-1.54 0-2.33.36-3.36 1.9-.58.87-1.33 3.16-1.37 5.3-.1 4.68.83 8.9 4.47 8.9 2.21 0 4.31-1.61 4.31-5.33 0-3.01-1.62-4.88-3.49-4.88-.92 0-1.85.51-2.42 1.61l-.03-.05c.06-1.98 0-4.55 1.79-4.55.31 0 .62.09.87.31.24.22.42.58.43 1.09h2.68zm-5.68 6.58c0-1.07.52-2.32 1.57-2.32.9 0 1.57.71 1.57 2.32 0 1.41-.6 2.32-1.57 2.32s-1.57-.83-1.57-2.32M2230.34 828.63c-.97 1.11-2.12 1.96-3.35 2.48v3.43c1-.44 1.94-1.16 2.83-1.91v11.44h3.18v-15.43h-2.66zM2220.65 827.96v9.97c-.05 2.05-.85 3.34-2.43 3.34s-2.37-1.29-2.42-3.34v-9.97h-3.34v10.19c.03 4.48 2.73 6.25 5.77 6.25s5.74-1.76 5.77-6.25v-10.19h-3.34z"
              ></path>
            </g>
            <g id="U15" strokeWidth="0">
              <path
                fill="#fff"
                d="M114.38 54.74H160.60999999999999V88.76H114.38z"
              ></path>
              <path
                fill="#004f9f"
                d="M118.65 58.99H156.35000000000002V84.5H118.65z"
              ></path>
              <path
                fill="#fff"
                d="M130.28 63.37v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44V63.37h-3.44v10.47c.03 4.6 2.8 6.42 5.93 6.42s5.89-1.81 5.93-6.42V63.37h-3.44zM139.71 64.06c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.75h3.27V64.05h-2.73zM144.32 75.38c.1 4.04 2.68 4.88 5.19 4.88 2.72 0 4.55-2.22 4.55-5.91 0-2.96-1.34-5.32-3.66-5.32-1.26 0-2.15.62-2.84 2.02l-.04-.04.2-3.96h5.61v-2.98h-8.6l-.24 9.35h3.3c.09-.83.67-1.4 1.27-1.4 1.17 0 1.63 1.01 1.63 2.48 0 1.35-.41 2.8-1.6 2.8-.86 0-1.5-.69-1.52-1.9h-3.28z"
              ></path>
            </g>
            <g id="U15-2" strokeWidth="0" data-name="U15">
              <path
                fill="#fff"
                d="M1736.59 1345.16H1778.56V1374.92H1736.59z"
              ></path>
              <path
                fill="#004f9f"
                d="M1740.86 1345.16H1778.56V1370.67H1740.86z"
              ></path>
              <path
                fill="#fff"
                d="M1752.07 1349.63v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.6 2.8 6.42 5.93 6.42s5.89-1.81 5.93-6.42v-10.47h-3.44zM1761.5 1350.32c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1766.11 1361.64c.1 4.04 2.68 4.88 5.19 4.88 2.72 0 4.55-2.22 4.55-5.91 0-2.96-1.34-5.32-3.66-5.32-1.26 0-2.15.62-2.84 2.02l-.04-.05.2-3.96h5.61v-2.98h-8.6l-.24 9.35h3.3c.09-.83.67-1.4 1.27-1.4 1.17 0 1.63 1.01 1.63 2.48 0 1.35-.41 2.8-1.6 2.8-.86 0-1.5-.69-1.52-1.9h-3.28z"
              ></path>
            </g>
            <g id="U15-3" strokeWidth="0" data-name="U15">
              <path
                fill="#004f9f"
                d="M1554.98 1193.87H1592.68V1219.3799999999999H1554.98z"
              ></path>
              <path
                fill="#fff"
                d="M1566.19 1198.35v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.6 2.8 6.42 5.93 6.42s5.89-1.81 5.93-6.42v-10.47h-3.44zM1575.62 1199.03c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1580.23 1210.35c.1 4.04 2.68 4.88 5.19 4.88 2.72 0 4.55-2.22 4.55-5.91 0-2.96-1.34-5.32-3.66-5.32-1.26 0-2.15.62-2.84 2.02l-.04-.05.2-3.96h5.61v-2.98h-8.6l-.24 9.35h3.3c.09-.83.67-1.4 1.27-1.4 1.17 0 1.63 1.01 1.63 2.48 0 1.35-.41 2.8-1.6 2.8-.86 0-1.5-.69-1.52-1.9h-3.28z"
              ></path>
            </g>
            <g id="U13-3" strokeWidth="0" data-name="U13">
              <path fill="#fff" d="M676.54 308.79H722.77V342.81H676.54z"></path>
              <path fill="#f3a4b9" d="M680.8 313.04H718.5V338.55H680.8z"></path>
              <path
                fill="#1d1d1b"
                d="M692.25 317.88v10.24c-.05 2.11-.88 3.44-2.5 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.04 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM701.68 318.57c-1 1.15-2.18 2.02-3.44 2.55v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM709.35 327.74c1.26 0 3.44-.37 3.44 2.08 0 1.4-.98 1.97-1.87 1.97-.45 0-.88-.16-1.19-.48-.31-.32-.52-.8-.52-1.47h-3.35c.33 3.89 2.49 4.93 5.19 4.93 2.13 0 5.09-1.08 5.09-4.58 0-2.45-1.27-3.78-3.01-4.08v-.07c1.43-.27 2.77-1.74 2.77-3.76 0-3.32-2.91-4.06-4.87-4.06-2.27 0-4.81 1.24-4.86 4.56h3.35c0-.94.62-1.58 1.45-1.58.69 0 1.58.43 1.58 1.35 0 2.48-1.84 2.2-3.2 2.2v2.98z"
              ></path>
            </g>
            <g id="U13-4" strokeWidth="0" data-name="U13">
              <path
                fill="#fff"
                d="M1936.39 1131.84H1982.6200000000001V1165.86H1936.39z"
              ></path>
              <path
                fill="#f3a4b9"
                d="M1940.66 1136.09H1978.3600000000001V1161.6H1940.66z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1952.11 1140.37v10.24c-.05 2.11-.88 3.44-2.5 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.04 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1961.54 1141.05c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1969.2 1150.22c1.26 0 3.44-.37 3.44 2.08 0 1.4-.98 1.97-1.87 1.97-.45 0-.88-.16-1.19-.48-.31-.32-.52-.8-.52-1.47h-3.35c.33 3.89 2.49 4.93 5.19 4.93 2.13 0 5.09-1.08 5.09-4.58 0-2.45-1.27-3.78-3.01-4.08v-.07c1.43-.27 2.77-1.74 2.77-3.76 0-3.32-2.91-4.06-4.87-4.06-2.27 0-4.81 1.24-4.86 4.56h3.35c0-.94.62-1.58 1.45-1.58.69 0 1.58.43 1.58 1.35 0 2.48-1.84 2.2-3.2 2.2v2.98z"
              ></path>
            </g>
            <g id="U12" strokeWidth="0">
              <path
                fill="#fff"
                d="M2204.73 162.1H2250.96V194.39999999999998H2204.73z"
              ></path>
              <path
                fill="#96c2e9"
                d="M2208.99 164.72H2246.6899999999996V190.23H2208.99z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M2220.31 169.15v10.25c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.25h-3.44v10.47c.04 4.61 2.81 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM2229.75 169.84c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 2-1.19 2.91-1.97v11.76h3.26v-15.86h-2.73zM2238.45 182.72v-.04c-.13.35 6.25-5.63 6.25-8.87s-2.61-4.31-5.01-4.31c-2.78 0-5.37 1.15-5.48 4.72h3.71c.02-.87.57-1.74 1.43-1.74 1.01 0 1.64.46 1.64 1.58 0 2.77-5.39 6.67-7.04 8.66v2.98h10.79v-2.98h-6.28z"
              ></path>
            </g>
            <g id="U12-2" strokeWidth="0" data-name="U12">
              <path
                fill="#fff"
                d="M587.95 1403.48H634.1800000000001V1437.33H587.95z"
              ></path>
              <path
                fill="#96c2e9"
                d="M592.22 1407.66H629.9200000000001V1433.17H592.22z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M603.28 1412.09v10.25c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.25h-3.44v10.47c.04 4.61 2.81 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM612.71 1412.78c-1 1.14-2.18 2.02-3.44 2.54v3.53c1.03-.46 2-1.19 2.91-1.97v11.76h3.26v-15.86h-2.73zM621.36 1425.66v-.04s6.25-5.23 6.25-8.87c0-3.25-2.61-4.31-5.01-4.31-2.78 0-5.37 1.14-5.48 4.72h3.71c.02-.87.57-1.74 1.43-1.74 1.01 0 1.64.46 1.64 1.58 0 2.77-5.39 6.67-7.04 8.66v2.98h10.79v-2.98h-6.28z"
              ></path>
            </g>
            <g id="U8" strokeWidth="0">
              <path
                fill="#fff"
                d="M408.28 1264.86H454.51V1298.8799999999999H408.28z"
              ></path>
              <path
                fill="#c6bd7f"
                d="M412.55 1269.11H450.25V1294.62H412.55z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M426.69 1273.59v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.41 7.11 6.41s7.08-1.81 7.12-6.41v-10.47h-4.12zM438.05 1281.78c-2.06.3-3.88 1.62-3.88 4.12 0 3.3 3.34 4.58 5.83 4.58 2.72 0 6.62-.82 6.62-4.58 0-2.47-1.69-3.83-3.71-4.05v-.12c1.57-.25 3.22-1.77 3.22-3.74 0-3.28-3.16-4.06-5.73-4.06-2.37 0-5.74.8-5.74 4.06 0 2.08 1.63 3.44 3.38 3.71v.07zm2.35-5.31c1.13 0 1.92.73 1.92 1.97s-.78 1.97-1.92 1.97-1.92-.73-1.92-1.97.79-1.97 1.92-1.97m0 11.04c-1.22 0-2.21-.66-2.21-2.18s.99-2.18 2.21-2.18 2.21.66 2.21 2.18-.99 2.18-2.21 2.18"
              ></path>
            </g>
            <g id="U8-2" strokeWidth="0" data-name="U8">
              <path
                fill="#fff"
                d="M1843.81 1577.76H1890.04V1611.78H1843.81z"
              ></path>
              <path
                fill="#c6bd7f"
                d="M1848.07 1582.02H1885.77V1607.53H1848.07z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1862.21 1586.5v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.41 7.11 6.41s7.08-1.81 7.12-6.41v-10.47h-4.12zM1873.57 1594.68c-2.06.3-3.88 1.62-3.88 4.12 0 3.3 3.34 4.58 5.83 4.58 2.72 0 6.62-.82 6.62-4.58 0-2.47-1.69-3.83-3.71-4.05v-.12c1.57-.25 3.22-1.77 3.22-3.74 0-3.28-3.16-4.06-5.73-4.06-2.37 0-5.74.8-5.74 4.06 0 2.08 1.63 3.44 3.38 3.71v.07zm2.35-5.31c1.13 0 1.92.73 1.92 1.97s-.78 1.97-1.92 1.97-1.92-.73-1.92-1.97.79-1.97 1.92-1.97m0 11.04c-1.22 0-2.21-.66-2.21-2.18s.99-2.18 2.21-2.18 2.21.66 2.21 2.18-.99 2.18-2.21 2.18"
              ></path>
            </g>
            <g id="U8-3" strokeWidth="0" data-name="U8">
              <path
                fill="#fff"
                d="M1694.63 1340.91H1740.8600000000001V1374.93H1694.63z"
              ></path>
              <path
                fill="#c6bd7f"
                d="M1698.89 1345.16H1736.5900000000001V1370.67H1698.89z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1713.03 1349.64v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.41 7.11 6.41s7.08-1.81 7.12-6.41v-10.47h-4.12zM1724.39 1357.82c-2.06.3-3.88 1.62-3.88 4.12 0 3.3 3.34 4.58 5.83 4.58 2.72 0 6.62-.82 6.62-4.58 0-2.47-1.69-3.83-3.71-4.05v-.12c1.57-.25 3.22-1.77 3.22-3.74 0-3.28-3.16-4.06-5.73-4.06-2.37 0-5.74.8-5.74 4.06 0 2.08 1.63 3.44 3.38 3.71v.07zm2.35-5.31c1.13 0 1.92.73 1.92 1.97s-.78 1.97-1.92 1.97-1.92-.73-1.92-1.97.79-1.97 1.92-1.97m0 11.04c-1.22 0-2.21-.66-2.21-2.18s.99-2.18 2.21-2.18 2.21.66 2.21 2.18-.99 2.18-2.21 2.18"
              ></path>
            </g>
            <g id="U7" strokeWidth="0">
              <path
                fill="#fff"
                d="M1885.78 1577.76H1932.01V1611.78H1885.78z"
              ></path>
              <path
                fill="#00a984"
                d="M1890.04 1582.02H1927.74V1607.53H1890.04z"
              ></path>
              <path
                fill="#fff"
                d="M1904.37 1586.34v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.12 6.42s7.07-1.81 7.11-6.42v-10.47h-4.12z"
              ></path>
              <path
                fill="#fff"
                d="M1920.02 1589.91L1914.51 1602.56 1918.28 1602.56 1923.67 1589.91 1923.67 1586.7 1912.3 1586.7 1912.3 1589.91 1920.02 1589.91z"
              ></path>
            </g>
            <g id="U7-2" strokeWidth="0" data-name="U7">
              <path
                fill="#fff"
                d="M2204.73 54.66H2250.96V88.68H2204.73z"
              ></path>
              <path
                fill="#00a984"
                d="M2208.99 58.91H2246.6899999999996V84.42H2208.99z"
              ></path>
              <path
                fill="#fff"
                d="M2223.32 63.23v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44V63.23h-4.12V73.7c.04 4.61 3.36 6.42 7.12 6.42s7.07-1.81 7.11-6.42V63.23h-4.12z"
              ></path>
              <path
                fill="#fff"
                d="M2238.97 66.8L2233.46 79.45 2237.24 79.45 2242.62 66.8 2242.62 63.59 2231.26 63.59 2231.26 66.8 2238.97 66.8z"
              ></path>
            </g>
            <g id="U6" strokeWidth="0">
              <path
                fill="#fff"
                d="M831.78 1694.93H878.01V1728.95H831.78z"
              ></path>
              <path
                fill="#e6007e"
                d="M836.04 1699.19H873.74V1724.7H836.04z"
              ></path>
              <path
                fill="#fff"
                d="M850.37 1703.5v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.6 3.36 6.41 7.12 6.41s7.07-1.81 7.12-6.41v-10.47h-4.12zM869.47 1708.09c-.12-3.14-2.56-4.24-5.16-4.24-4.72 0-6.43 3.9-6.43 8.43s1.98 8.11 6.33 8.11c3.22 0 6.08-1.92 6.08-5.8 0-3.25-2-5.25-4.82-5.25-1.55 0-2.85.55-3.53 1.97l-.04-.05c.06-1.72-.08-4.45 2.12-4.45.41 0 .82.12 1.13.34.31.21.52.53.54.92h3.78zm-5.22 4.01c1.34 0 2.23.94 2.23 2.66s-.88 2.66-2.23 2.66-2.21-.94-2.21-2.66.87-2.66 2.21-2.66"
              ></path>
            </g>
            <g id="U6-2" strokeWidth="0" data-name="U6">
              <path fill="#fff" d="M115.8 819.28H162.03V853.3H115.8z"></path>
              <path
                fill="#e6007e"
                d="M120.07 823.54H157.76999999999998V849.05H120.07z"
              ></path>
              <path
                fill="#fff"
                d="M134.4 827.85v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.6 3.36 6.41 7.12 6.41s7.07-1.81 7.12-6.41v-10.47h-4.12zM153.49 832.44c-.12-3.14-2.56-4.24-5.16-4.24-4.72 0-6.43 3.9-6.43 8.43s1.98 8.11 6.33 8.11c3.22 0 6.08-1.92 6.08-5.8 0-3.25-2-5.25-4.82-5.25-1.55 0-2.85.55-3.53 1.97l-.04-.05c.06-1.72-.08-4.45 2.12-4.45.41 0 .82.12 1.13.34.31.21.52.53.54.92h3.78zm-5.22 4.01c1.34 0 2.23.94 2.23 2.66s-.88 2.66-2.23 2.66-2.21-.94-2.21-2.66.87-2.66 2.21-2.66"
              ></path>
            </g>
            <g id="U5-2" strokeWidth="0" data-name="U5">
              <path
                fill="#fff"
                d="M640.61 1546.09H682.58V1571.6H640.61z"
              ></path>
              <path
                fill="#00b1eb"
                d="M640.61 1546.09H678.3100000000001V1571.6H640.61z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M654.86 1550.52v10.67c-.06 2.2-1.05 3.58-2.99 3.58s-2.93-1.38-2.99-3.58v-10.67h-4.12v10.91c.04 4.8 3.36 6.68 7.12 6.68s7.08-1.88 7.12-6.68v-10.91h-4.13zM662.69 1563.03c.12 4.2 3.22 5.08 6.23 5.08 3.26 0 5.46-2.31 5.46-6.16 0-3.08-1.61-5.54-4.39-5.54-1.51 0-2.58.65-3.4 2.1l-.04-.05.25-4.13h6.72v-3.1h-10.31l-.29 9.74h3.96c.1-.86.8-1.46 1.53-1.46 1.4 0 1.96 1.05 1.96 2.58 0 1.41-.5 2.91-1.92 2.91-1.03 0-1.79-.72-1.81-1.98h-3.94z"
              ></path>
            </g>
            <g id="U5-3" strokeWidth="0" data-name="U5">
              <path fill="#fff" d="M676.54 452.13H722.77V483.52H676.54z"></path>
              <path fill="#00b1eb" d="M680.8 456.39H718.5V481.9H680.8z"></path>
              <path
                fill="#1d1d1b"
                d="M695.05 460.82v10.67c-.06 2.2-1.05 3.58-2.99 3.58s-2.93-1.38-2.99-3.58v-10.67h-4.12v10.91c.04 4.8 3.36 6.68 7.12 6.68s7.08-1.88 7.12-6.68v-10.91h-4.13zM702.89 473.19c.12 4.2 3.22 5.08 6.23 5.08 3.26 0 5.46-2.31 5.46-6.16 0-3.08-1.61-5.54-4.39-5.54-1.51 0-2.58.65-3.4 2.1l-.04-.05.25-4.13h6.72v-3.1h-10.31l-.29 9.74h3.96c.1-.86.8-1.46 1.53-1.46 1.4 0 1.96 1.05 1.96 2.58 0 1.41-.5 2.91-1.92 2.91-1.03 0-1.79-.72-1.81-1.98h-3.94z"
              ></path>
            </g>
            <g id="U4" strokeWidth="0">
              <path
                fill="#fff"
                d="M1781.34 699.05H1827.57V733.0699999999999H1781.34z"
              ></path>
              <path
                fill="#8164a9"
                d="M1785.6 703.3H1823.3V728.81H1785.6z"
              ></path>
              <path
                fill="#fff"
                d="M1799.74 707.68v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.08-1.81 7.12-6.42v-10.47h-4.12zM1810.4 717.96l3.32-5.89h.04v5.89h-3.36zm-3.48 2.98h6.79v3.05h3.98v-3.05h2.17v-2.98h-2.17v-9.83h-4.72l-6.04 9.83v2.98z"
              ></path>
            </g>
            <g id="U4-2" strokeWidth="0" data-name="U4">
              <path
                fill="#fff"
                d="M515.82 604.09H562.0500000000001V638.11H515.82z"
              ></path>
              <path
                fill="#8164a9"
                d="M520.09 608.34H557.7900000000001V633.85H520.09z"
              ></path>
              <path
                fill="#fff"
                d="M534.22 612.73v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.08-1.81 7.12-6.42v-10.47h-4.12zM544.88 623l3.32-5.89h.04V623h-3.36zm-3.48 2.98h6.79v3.05h3.98v-3.05h2.17V623h-2.17v-9.83h-4.72l-6.04 9.83v2.98z"
              ></path>
            </g>
            <g id="U3-2" strokeWidth="0" data-name="U3">
              <path
                fill="#fff"
                d="M450.25 1264.86H496.48V1298.8799999999999H450.25z"
              ></path>
              <path
                fill="#955c36"
                d="M454.51 1269.11H492.21V1294.62H454.51z"
              ></path>
              <path
                fill="#fff"
                d="M468.75 1273.48v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12zM480.25 1283.33c1.5 0 4.12-.37 4.12 2.09 0 1.4-1.18 1.97-2.25 1.97-.54 0-1.05-.16-1.42-.48-.37-.32-.62-.8-.62-1.47h-4.02c.39 3.9 2.99 4.93 6.23 4.93 2.56 0 6.11-1.07 6.11-4.58 0-2.45-1.53-3.78-3.61-4.08v-.07c1.71-.27 3.32-1.74 3.32-3.76 0-3.32-3.48-4.06-5.84-4.06-2.72 0-5.77 1.24-5.84 4.56h4.02c0-.94.74-1.58 1.73-1.58.82 0 1.9.44 1.9 1.35 0 2.48-2.21 2.2-3.84 2.2v2.98z"
              ></path>
            </g>
            <g id="U3-3" strokeWidth="0" data-name="U3">
              <path
                fill="#fff"
                d="M1282.03 1578.57H1328.27V1612.59H1282.03z"
              ></path>
              <path
                fill="#955c36"
                d="M1286.3 1582.82H1324.01V1608.33H1286.3z"
              ></path>
              <path
                fill="#fff"
                d="M1300.54 1587.19v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.13v10.47c.04 4.61 3.37 6.42 7.12 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12zM1312.04 1597.04c1.5 0 4.12-.37 4.12 2.09 0 1.4-1.18 1.97-2.25 1.97-.54 0-1.05-.16-1.42-.48s-.62-.8-.62-1.47h-4.02c.39 3.9 2.99 4.93 6.23 4.93 2.56 0 6.11-1.07 6.11-4.58 0-2.45-1.53-3.78-3.61-4.08v-.07c1.71-.27 3.32-1.74 3.32-3.76 0-3.32-3.48-4.06-5.84-4.06-2.72 0-5.77 1.24-5.84 4.56h4.02c0-.94.74-1.58 1.73-1.58.82 0 1.9.44 1.9 1.35 0 2.48-2.21 2.2-3.84 2.2v2.98z"
              ></path>
            </g>
            <g id="U2" strokeWidth="0">
              <path
                fill="#fff"
                d="M114.38 958.76H160.60999999999999V992.72H114.38z"
              ></path>
              <path
                fill="#ef7d00"
                d="M118.65 961.71H156.35000000000002V987.22H118.65z"
              ></path>
              <path
                fill="#fff"
                d="M132.88 966.03v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.12 6.42s7.07-1.81 7.11-6.42v-10.47h-4.12zM145.31 979.59v-.04s6.77-5.22 6.77-8.87c0-3.25-2.83-4.31-5.42-4.31-3.01 0-5.82 1.15-5.94 4.72h4.02c.02-.87.62-1.74 1.54-1.74 1.1 0 1.78.46 1.78 1.58 0 2.77-5.84 6.67-7.63 8.66v2.98h11.69v-2.98h-6.81z"
              ></path>
            </g>
            <g id="U2-2" strokeWidth="0" data-name="U2">
              <path
                fill="#fff"
                d="M2204.73 273.87H2250.96V307.89H2204.73z"
              ></path>
              <path
                fill="#ef7d00"
                d="M2208.99 278.12H2246.6899999999996V303.63H2208.99z"
              ></path>
              <path
                fill="#fff"
                d="M2223.22 282.44v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.12 6.42s7.07-1.81 7.11-6.42v-10.47h-4.12zM2235.65 296.01v-.04s6.77-5.22 6.77-8.87c0-3.25-2.83-4.31-5.42-4.31-3.01 0-5.82 1.15-5.94 4.72h4.02c.02-.87.62-1.74 1.55-1.74 1.1 0 1.78.46 1.78 1.58 0 2.77-5.84 6.67-7.63 8.66v2.98h11.69v-2.98h-6.81z"
              ></path>
            </g>
            <g id="Seilbahn-2" strokeWidth="0" data-name="Seilbahn">
              <path
                fill="#fff"
                d="M1003.13 1216.4L1041.11 1216.4 1041.11 1178.13 1002.84 1178.13 1003.13 1216.4z"
              ></path>
              <path
                fill="#fbba00"
                d="M1010.9 1207.45c-.46.25-.47.78-.28 1.22l1.38-.76c-.23-.43-.63-.72-1.1-.45zM1017.58 1196.44c-.23-.43-.63-.72-1.1-.45-.46.25-.47.78-.28 1.22l1.38-.76zM1025.35 1195.2c.7-.39.2-1.49-.07-2s-.88-1.43-1.56-1.06c-.67.37-.21 1.4.05 1.89.29.54.82 1.58 1.58 1.17zM1018.14 1203.6c-.67.37-.21 1.4.05 1.89.29.54.82 1.58 1.58 1.17.7-.39.2-1.49-.07-2s-.88-1.43-1.56-1.06zM1023.07 1202.93c-.45.29-1.09.8-.77 1.42.14.27.43.47.73.3.1-.05.19-.14.25-.24.22-.33.2-.72.02-1.06l-.23-.43z"
              ></path>
              <path
                fill="#fbba00"
                d="M1036.13 1186.58c-.17-.32-.48-.87-.92-.62-.71.39-.39 1.62-.08 2.19l.81 1.51-.76.42-1.95-3.66.76-.42.46.87h.01c-.04-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l.29.55v-3.94h-29.76v29.76h2.19c.2-.17.33-.41.19-.67-.31-.58-1.69-.03-2.38-.64v-1.67c.14-.14.3-.26.48-.36.29-.16.6-.25.92-.32l.35.66c-.38-.04-.75-.05-1.1.14-.23.13-.46.38-.31.67.35.66 2.03-.19 2.65.98.25.47.19.88-.03 1.22h26.79v-23.97l-.85-1.59zm-9.07 3.14c1-.55 1.5-.25 2 .68l1.26 2.36-.76.42-.27-.51h-.01c-.02.49-.27.92-.7 1.16-.51.28-1.17.18-1.47-.37-.55-1.03.62-1.86 1.36-2.32l-.17-.32c-.2-.37-.56-1.06-1.07-.78-.48.27-.35.71-.16 1.12l-.8.44c-.39-.89-.02-1.44.78-1.89zm-5.17.84l1.15 2.15h.02c.05-.53.21-.89.69-1.16 1.08-.6 1.89.27 2.38 1.18.58 1.1.57 2.14-.59 2.78-1.28.71-1.94.09-2.54-1.05l-1.86-3.49.76-.42zm-1.69.94l2.82 5.3-.76.42-2.83-5.3.76-.42zm1.02 6.3l-.76.42-1.95-3.66.76-.42 1.95 3.66zm-2.79-5.32l.41.77-.82.45-.41-.77.82-.45zm-2.07 3.17c.97-.54 1.68-.2 2.18.73l-2.15 1.19c.46.87 1.42 1.7 2.42 1.15.23-.13.44-.31.6-.53l.19.35c-.28.35-.55.57-.94.79-1.24.69-2.27.11-2.9-1.08-.56-1.04-.5-1.99.6-2.6zm-3.07 1.7c.29-.16.6-.25.92-.32l.35.66c-.38-.04-.75-.05-1.1.14-.23.13-.46.38-.31.67.35.66 2.03-.19 2.65.98.44.82-.07 1.47-.78 1.86-.33.18-.67.3-1.04.37l-.38-.71c.4.04.83.04 1.2-.17.28-.15.55-.46.37-.8-.34-.64-2.03.12-2.59-.92-.4-.74.03-1.38.7-1.75zm-.44 6.6l.41.77-.82.46-.41-.77.82-.45zm.23 6.84c-1.24.69-2.27.11-2.9-1.08-.56-1.04-.5-1.99.6-2.6.97-.54 1.68-.2 2.18.73l-2.15 1.19c.46.87 1.42 1.7 2.42 1.15.23-.13.44-.31.6-.53l.19.35c-.28.35-.54.57-.94.79zm1.8-1.11l-1.95-3.66.76-.42 1.95 3.66-.76.42zm1.81-1l-2.83-5.3.76-.42 2.83 5.3-.76.42zm3.27-1.7c-1.28.71-1.94.09-2.54-1.05l-1.86-3.49.76-.42 1.15 2.15h.02c.05-.53.21-.89.69-1.16 1.08-.6 1.89.27 2.38 1.18.59 1.1.57 2.14-.59 2.78zm4.03-2.34l-.27-.51h-.01c-.01.49-.27.92-.7 1.16-.51.28-1.17.18-1.47-.37-.55-1.03.62-1.86 1.36-2.32l-.17-.32c-.2-.37-.56-1.06-1.07-.78-.48.27-.35.71-.15 1.12l-.8.44c-.39-.89-.02-1.44.78-1.88 1-.55 1.5-.25 2 .68l1.26 2.36-.76.42zm3.89-2.15l-1.22-2.29c-.17-.32-.48-.87-.92-.63-.71.39-.39 1.62-.09 2.19l.81 1.51-.76.42-2.83-5.3.76-.42 1.34 2.51h.01c-.05-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l1.42 2.67-.76.42zm3.9-2.16l-1.22-2.29c-.17-.32-.48-.87-.92-.62-.71.39-.39 1.62-.09 2.19l.81 1.51-.76.42-1.95-3.66.76-.42.46.87h.02c-.05-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l1.42 2.67-.76.42zm1.67-9.3l-1.22-2.29c-.17-.32-.48-.87-.92-.62-.71.39-.39 1.62-.08 2.19l.81 1.51-.76.42-2.83-5.3.76-.42 1.34 2.51h.01c-.05-.68.13-1.32.75-1.66.6-.33 1.17 0 1.47.57l1.42 2.67-.76.42z"
              ></path>
              <path
                fill="#fbba00"
                d="M1027.87 1192.89c.14.27.43.47.73.3.1-.05.19-.14.25-.24.22-.33.2-.72.02-1.06l-.23-.43c-.45.29-1.09.8-.77 1.42z"
              ></path>
              <path
                fill="#004f9f"
                d="M1015.17 1200.02c.18.34-.09.65-.37.8-.37.2-.8.21-1.2.17l.38.71c.37-.07.71-.18 1.04-.37.71-.39 1.21-1.04.78-1.86-.62-1.17-2.3-.32-2.65-.98-.15-.28.07-.54.31-.67.35-.19.72-.18 1.1-.14l-.35-.66c-.32.07-.64.16-.92.32-.66.37-1.1 1-.7 1.75.56 1.05 2.25.28 2.59.92zM1018.64 1199.33c.39-.22.66-.43.94-.79l-.19-.35c-.17.22-.37.4-.6.53-1 .55-1.96-.28-2.42-1.15l2.15-1.19c-.5-.94-1.21-1.27-2.18-.73-1.1.61-1.15 1.55-.6 2.6.63 1.19 1.66 1.77 2.9 1.08zm-2.16-3.34c.48-.26.87.03 1.1.45l-1.38.76c-.19-.44-.18-.96.28-1.22z"
              ></path>
              <path
                fill="#004f9f"
                d="M1020.44 1198.22L1021.2 1197.8 1019.25 1194.14 1018.49 1194.57 1020.44 1198.22z"
              ></path>
              <path
                fill="#004f9f"
                d="M1018.82 1193.25L1018.41 1192.48 1017.59 1192.94 1018 1193.71 1018.82 1193.25z"
              ></path>
              <path
                fill="#004f9f"
                d="M1023.01 1196.8L1020.19 1191.5 1019.42 1191.92 1022.25 1197.22 1023.01 1196.8z"
              ></path>
              <path
                fill="#004f9f"
                d="M1025.52 1195.52c1.16-.64 1.17-1.68.59-2.78-.49-.91-1.3-1.78-2.38-1.18-.48.26-.64.62-.69 1.15h-.02l-1.15-2.14-.76.42 1.86 3.49c.61 1.14 1.26 1.76 2.54 1.05zm-1.8-3.38c.68-.38 1.29.55 1.56 1.06s.77 1.61.07 2c-.75.42-1.29-.63-1.58-1.17-.26-.49-.72-1.52-.05-1.89zM1027.07 1191.16c-.19-.41-.33-.85.16-1.12.51-.28.87.41 1.07.78l.17.32c-.74.46-1.91 1.29-1.36 2.32.29.55.95.66 1.47.37.42-.23.68-.67.7-1.15h.01l.27.5.76-.42-1.26-2.36c-.5-.94-1.01-1.23-2-.68-.8.44-1.18 1-.78 1.89l.8-.44zm1.57.31l.23.43c.18.34.19.73-.02 1.06a.82.82 0 01-.25.24c-.29.16-.58-.04-.73-.3-.33-.62.32-1.13.77-1.42zM1031.31 1187.37c-.62.34-.8.98-.75 1.65h-.01l-1.34-2.5-.76.42 2.83 5.3.76-.42-.81-1.51c-.3-.57-.62-1.79.08-2.19.44-.24.75.3.92.62l1.22 2.29.76-.42-1.42-2.67c-.3-.57-.87-.9-1.47-.57zM1035.21 1185.21c-.62.34-.8.98-.75 1.65h-.01l-.46-.86-.76.42 1.95 3.66.76-.42-.81-1.51c-.3-.57-.62-1.79.08-2.19.44-.24.75.3.92.62l.85 1.59v-1.85l-.29-.55c-.3-.57-.87-.9-1.47-.57zM1010.22 1210.93c-.62-1.17-2.3-.32-2.65-.98-.15-.28.07-.54.31-.67.35-.19.72-.18 1.1-.14l-.35-.66c-.32.07-.64.16-.92.32-.18.1-.35.22-.48.36v1.67c.69.62 2.07.07 2.38.64.14.26 0 .51-.19.67h.78c.23-.34.28-.75.03-1.22zM1013.21 1210.18c-1 .55-1.96-.28-2.42-1.15l2.15-1.19c-.5-.94-1.21-1.27-2.18-.73-1.1.61-1.15 1.55-.6 2.6.63 1.19 1.66 1.77 2.9 1.08.39-.22.66-.43.94-.79l-.19-.35c-.17.22-.37.4-.6.53zm-2.58-1.51c-.19-.44-.18-.96.28-1.22.48-.26.87.03 1.1.45l-1.38.76z"
              ></path>
              <path
                fill="#004f9f"
                d="M1013.24 1204.71L1012.83 1203.94 1012.01 1204.4 1012.42 1205.16 1013.24 1204.71z"
              ></path>
              <path
                fill="#004f9f"
                d="M1012.92 1206.02L1014.87 1209.68 1015.63 1209.26 1013.68 1205.6 1012.92 1206.02z"
              ></path>
              <path
                fill="#004f9f"
                d="M1013.85 1203.38L1016.68 1208.68 1017.44 1208.26 1014.61 1202.96 1013.85 1203.38z"
              ></path>
              <path
                fill="#004f9f"
                d="M1018.16 1203.02c-.48.26-.64.62-.69 1.15h-.02l-1.15-2.14-.76.42 1.86 3.49c.61 1.14 1.26 1.76 2.54 1.05 1.16-.64 1.17-1.68.59-2.78-.49-.91-1.3-1.78-2.38-1.18zm1.62 3.64c-.75.42-1.29-.63-1.58-1.17-.26-.49-.72-1.52-.05-1.89.68-.38 1.29.55 1.56 1.06s.77 1.61.07 2zM1021.48 1201.18c-.8.44-1.18 1-.78 1.88l.8-.44c-.19-.41-.33-.85.15-1.12.51-.28.87.41 1.07.78l.17.32c-.74.46-1.91 1.29-1.36 2.32.29.55.95.66 1.47.37.42-.23.68-.66.7-1.15h.01l.27.5.76-.42-1.26-2.36c-.5-.94-1.01-1.23-2-.68zm1.79 3.24a.82.82 0 01-.25.24c-.29.16-.58-.03-.73-.3-.33-.62.32-1.13.77-1.42l.23.43c.18.34.19.73-.02 1.06zM1025.73 1198.83c-.62.34-.8.98-.75 1.65h-.01l-1.34-2.5-.76.42 2.83 5.3.76-.42-.81-1.51c-.3-.57-.62-1.79.09-2.19.44-.24.75.3.92.63l1.22 2.29.76-.42-1.42-2.67c-.3-.57-.87-.9-1.47-.57zM1029.63 1196.67c-.62.34-.8.98-.75 1.65h-.02l-.46-.86-.76.42 1.95 3.66.76-.42-.81-1.51c-.3-.57-.62-1.79.09-2.19.44-.24.75.3.92.62l1.22 2.29.76-.42-1.42-2.67c-.3-.57-.87-.9-1.47-.57z"
              ></path>
            </g>
            <use
              width="38.27"
              height="38.27"
              transform="translate(918.09 1057.88)"
              xlinkHref="#Seilbahn"
            ></use>
            <g id="Zacke-2" data-name="Zacke">
              <path
                fill="#fff"
                strokeWidth="0"
                d="M1024.07 964.19H1062.34V1002.46H1024.07z"
              ></path>
              <use
                width="29.76"
                height="29.76"
                transform="translate(1028.16 968.71)"
                xlinkHref="#Zacke"
              ></use>
            </g>
            <g id="Zacke-3" strokeWidth="0" data-name="Zacke">
              <path
                fill="#fff"
                d="M1260.32 1301.14H1298.59V1339.41H1260.32z"
              ></path>
              <path
                fill="#fbba00"
                d="M1264.59 1304.52H1294.35V1334.28H1264.59z"
              ></path>
              <g fill="#004f9f">
                <path d="M1270.12 1324.21l-4.03.89.23 1.05 1.94-.43c.21-.05.3-.08.52-.18-.1.26-.14.38-.17.56l-1.29 6.1 4.24-.94-.24-1.07-2.08.46c-.24.05-.32.08-.54.17.09-.28.12-.4.16-.61l1.25-6.01z"></path>
                <path d="M1290.76 1319.64L1287.32 1320.4 1288.88 1327.43 1292.52 1326.63 1292.3 1325.62 1289.77 1326.18 1289.3 1324.07 1291.49 1323.59 1291.28 1322.64 1289.09 1323.13 1288.65 1321.14 1290.98 1320.63 1290.76 1319.64z"></path>
                <path d="M1279.61 1323.03c.4-.09.75-.06 1.31.12l-.25-1.13c-.55-.1-1.01-.1-1.47 0-1.61.36-2.3 1.99-1.79 4.25.52 2.36 1.81 3.47 3.59 3.07.55-.12.99-.34 1.37-.68l-.27-1.23c-.53.54-.85.74-1.32.85-1.08.24-1.87-.55-2.25-2.26-.37-1.68.02-2.76 1.08-3z"></path>
                <path d="M1286.29 1320.63L1285.22 1320.87 1283.7 1324.55 1286.88 1327.88 1287.87 1327.66 1288.07 1327.62 1284.91 1324.28 1286.42 1320.6 1286.29 1320.63z"></path>
                <path d="M1272.68 1323.64l-.35 7.46 1.17-.26.04-1.66 2.03-.45.75 1.49 1.21-.27-3.48-6.61-1.38.3zm2.49 4.21l-1.63.36.06-1.7c.02-.52 0-1-.05-2.02h.04c.39.96.58 1.41.81 1.85l.78 1.51z"></path>
                <path d="M1281.99 1321.58L1281.84 1321.62 1283.4 1328.65 1283.54 1328.62 1284.5 1328.41 1282.94 1321.37 1281.99 1321.58z"></path>
              </g>
            </g>
          </g>
          <g strokeWidth="0">
            <path
              fill="#1d1d1b"
              d="M1510.37 1232.45L1506.81 1232.45 1506.81 1233.45 1510.25 1233.45 1509.85 1236.46 1506.81 1236.46 1506.81 1265.56 1503.8 1265.56 1503.8 1236.46 1500.75 1236.46 1500.36 1233.45 1503.8 1233.45 1503.8 1232.45 1500.23 1232.45 1499.84 1229.44 1503.8 1229.44 1503.8 1228.44 1499.71 1228.44 1499.31 1225.43 1503.8 1225.43 1503.8 1221.91 1504.8 1221.91 1504.8 1211.38 1505.8 1211.38 1505.8 1221.91 1506.81 1221.91 1506.81 1225.43 1511.3 1225.43 1510.9 1228.44 1506.81 1228.44 1506.81 1229.44 1510.78 1229.44 1510.37 1232.45z"
            ></path>
            <path
              fill="#fff"
              d="M1498.84 1228.36H1511.6699999999998V1229.55H1498.84z"
            ></path>
            <path
              fill="#fff"
              d="M1498.63 1232.4H1511.46V1233.5900000000001H1498.63z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M1503.8 1226.41H1506.81V1237.3300000000002H1503.8z"
            ></path>
          </g>
        </g>
        <g id="U_New_Stations" data-name="U New Stations">
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1665.21 444.76)"
          >
            <tspan x="0" y="0">
              Uff-Kirchh.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1783.1 434.09)"
          >
            <tspan x="0" y="0">
              Augsburger{" "}
            </tspan>
            <tspan x="0" y="19">
              Platz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 2171.76 803.05)"
          >
            <tspan x="0" y="0">
              Schwabenlandhalle
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1955.47 585.08)"
          >
            <tspan x="0" y="0">
              Antwerpener Straße
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 2119.26 748.59)"
          >
            <tspan x="0" y="0">
              Esslinger Str.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 2009.7 639.53)"
          >
            <tspan x="0" y="0">
              Beskidenstr.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 2064.03 694.14)"
          >
            <tspan x="0" y="0">
              Höhenstr.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1464.51 644.77)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Mercedes-
              </tspan>
            </tspan>
            <tspan x="0" y="19" letterSpacing="0em"></tspan>
            <tspan x="17.83" y="19" letterSpacing="-.03em"></tspan>
            <tspan x="22.93" y="19" letterSpacing="0em">
              str.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 919.18 671.91)"
          >
            <tspan x="0" y="0">
              Börsenplatz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 711.19 681.03)"
          >
            <tspan x="0" y="0" letterSpacing="0em">
              Berliner Plat
            </tspan>
            <tspan x="122.74" y="0" letterSpacing=".22em">
              z
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 2207.54 899.88)"
          >
            <tspan x="0" y="0">
              Fellbach
            </tspan>
            <tspan x="0" y="20">
              Lutherkirche
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            transform="matrix(.83 0 0 1 1451.74 457.89)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Bad Cannstatt
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="0.96" y="20">
                Wilhelmspl.{" "}
              </tspan>
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            transform="matrix(.85 .00119 -.0014 1 858.08 1107.2)"
          >
            <tspan x="0" y="0" letterSpacing="0em">
              Südheime
            </tspan>
            <tspan x="102.35" y="0" letterSpacing="-.11em">
              r
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="58.57" y="20">
                Platz
              </tspan>
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 955.74 1018.29)"
          >
            <tspan x="0" y="0">
              Marienplatz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1115.32 1004.47)"
          >
            <tspan x="0" y="0">
              Österreich.
            </tspan>
            <tspan x="0" y="19">
              Platz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 996.99 1122.92)"
          >
            <tspan x="0" y="0">
              Bihlplatz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1308.33 808.52)"
          >
            <tspan x="0" y="0">
              Neckar-
            </tspan>
            <tspan x="0" y="19">
              tor
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1270.04 848.57)"
          >
            <tspan x="0" y="0">
              Staatsgalerie
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1211.93 741.03)"
          >
            <tspan x="0" y="0">
              Stöckach
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1276.76 701.47)"
          >
            <tspan x="0" y="0" letterSpacing="0em">
              Metzst
            </tspan>
            <tspan x="65.94" y="0" letterSpacing="-.13em">
              r
            </tspan>
            <tspan x="71.27" y="0" letterSpacing="0em">
              .{" "}
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1291.19 646.07)"
          >
            <tspan x="0" y="0">
              Mineral-
            </tspan>
            <tspan x="25.98" y="19">
              bäder
            </tspan>
          </text>
          <g id="Hauptbahnhof">
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1073.02 729.12)"
            >
              <tspan x="0" y="0">
                Haupt-
              </tspan>
              <tspan x="0" y="19">
                bahnhof
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.75 0 0 1 1073.02 769.12)"
            >
              <tspan x="0" y="0">
                (Arnulf-Klett-P
              </tspan>
              <tspan x="141.14" y="0" letterSpacing="-.06em">
                l.
              </tspan>
              <tspan x="150.29" y="0">
                )
              </tspan>
            </text>
            <g strokeWidth="0">
              <path
                fill="#1d1d1b"
                fillRule="evenodd"
                d="M1092.22 685.51L1092.22 687.7 1107.9 681.08 1123.4 687.7 1123.4 685.51 1107.9 678.9 1092.22 685.51"
              ></path>
              <path
                fill="#1d1d1b"
                fillRule="evenodd"
                d="M1095.06 710.08L1123.4 710.08 1123.4 703.28 1113.92 703.28 1113.92 708.38 1109.73 708.38 1109.73 707.24 1106.73 707.24 1106.73 708.38 1100.23 708.38 1100.23 707.24 1097.23 707.24 1097.23 708.38 1095.06 708.38 1095.06 710.08"
              ></path>
              <path
                fill="#1d1d1b"
                fillRule="evenodd"
                d="M1110.09 691.75c-.83-2.08-2.61-2.65-6.62-2.65s-5.78.57-6.62 2.65c-.67 1.51-1.81 4.72-1.81 6.61v5.1c0 1.7 1.33 3.21 2.67 3.21h11.51c1.33 0 2.67-1.51 2.67-3.21v-5.1c0-1.89-1.14-5.1-1.81-6.61z"
              ></path>
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M1104.62 699.44a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1099.33 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1109.93 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001z"
              ></path>
              <path
                fill="#fff"
                d="M1109.44 694.31l-.67-1.92c-.28-.75-.8-1.11-1.37-1.29-.57-.18-1.64-.43-3.91-.43-2.27 0-3.35.25-3.91.43-.57.18-1.09.55-1.37 1.29l-.67 1.92c-.28.85-.19 1.74 1.09 1.62 1.28-.11 2.32-.4 4.88-.4s3.6.29 4.88.4c1.28.11 1.37-.77 1.09-1.62z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1103.47 686.34h-5.31v.65c2.48 0 4.99.96 4.99 3.11h.65c0-2.15 2.5-3.11 4.99-3.11v-.65h-5.31zm0 2.36c-.38-.75-1.08-1.32-1.94-1.71h3.87c-.86.39-1.55.95-1.94 1.71z"
              ></path>
            </g>
          </g>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.83 0 0 1 1394.56 564.06)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Wil-
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="0" y="19">
                helma
              </tspan>
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1637.78 160.18)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Wagrain-
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="0" y="19">
                äcker
              </tspan>
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1770.13 178.76)"
          >
            <tspan x="0" y="0">
              Hofen
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1817.93 219.27)"
          >
            <tspan x="0" y="0">
              Auwiesen
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 996.99 1122.92)"
          >
            <tspan x="0" y="0">
              Bihlplatz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1237.53 879.57)"
          >
            <tspan x="0" y="0">
              Charlottenpl.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1156.96 962.34)"
          >
            <tspan x="0" y="0">
              Rathaus
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1291.19 646.07)"
          >
            <tspan x="0" y="0">
              Mineral-
            </tspan>
            <tspan x="25.98" y="19">
              bäder
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1394.7 505.05)"
          >
            <tspan x="0" y="0">
              Rosensteinbr.{" "}
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 410.48 1315.61)"
          >
            <tspan x="0" y="0">
              Vaihingen
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1933.97 237.56)"
          >
            <tspan x="0" y="0">
              Mühlhausen
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 528.65 837.53)"
          >
            <tspan x="0" y="0">
              Arndt-/Spittastr.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 514.7 928.49)"
          >
            <tspan x="0" y="0">
              Herder-
            </tspan>
            <tspan x="0" y="19">
              platz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 456.53 988.03)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Lind-
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="-32.46" y="19">
                paintnerstr.
              </tspan>
            </tspan>
          </text>
          <g fill="#1d1d1b" strokeWidth="0">
            <path d="M377.75 913.33h4.61c1.57 0 2.45.19 3.25 1.11.55.63.91 1.51.91 2.71 0 2.5-1.55 3.15-2.18 3.42.75.25 2.57.88 2.57 3.78 0 2.06-1.12 3.11-1.55 3.44-.89.69-1.89.69-2.91.69h-4.7v-15.16zm1.73 6.4h2.5c.61 0 2.68 0 2.68-2.39s-1.62-2.29-2.61-2.29h-2.57v4.68zm0 7.05h3.05c1.41 0 2.54-.88 2.54-2.62 0-1.51-.89-2.62-2.46-2.62h-3.12v5.25zM390.64 923.58c-.04 2.18.73 3.8 2.57 3.8 1.09 0 1.96-.67 2.11-2.18H397c-.05.52-.12 1.38-.77 2.2-.39.52-1.29 1.41-3.09 1.41-2.82 0-4.16-2.06-4.16-5.4 0-2.08.36-3.8 1.77-4.96.86-.71 1.93-.78 2.45-.78 4.02 0 3.93 4.18 3.89 5.9h-6.44zm4.73-1.39c.02-1.01-.14-3.11-2.21-3.11-1.09 0-2.41.78-2.45 3.11h4.66zM400.66 923.58c-.04 2.18.73 3.8 2.57 3.8 1.09 0 1.96-.67 2.11-2.18h1.68c-.05.52-.12 1.38-.77 2.2-.39.52-1.29 1.41-3.09 1.41-2.82 0-4.16-2.06-4.16-5.4 0-2.08.36-3.8 1.77-4.96.86-.71 1.93-.78 2.45-.78 4.02 0 3.93 4.18 3.89 5.9h-6.44zm4.73-1.39c.02-1.01-.14-3.11-2.21-3.11-1.09 0-2.41.78-2.45 3.11h4.66zM408.28 917.91h1.59v-2.2l1.66-.63v2.83h2v1.45h-2v6.32c0 .53 0 1.41 1.2 1.41.34 0 .66-.06.8-.1v1.53c-.3.06-.79.13-1.39.13-1.54 0-2.27-.53-2.27-2.25v-7.03h-1.59v-1.45zM414.86 922.17h4.48v1.6h-4.48v-1.6zM359.6 932.35h1.7v6.15c.55-1.11 1.66-1.74 2.91-1.74.95 0 2.3.4 2.82 1.68.18.42.3.92.3 2.46v6.59h-1.71v-6.24c0-.95 0-2.98-1.93-2.98-1.25 0-1.87.9-2.11 1.41-.29.59-.29 1.58-.29 2.23v5.58h-1.7v-15.14zM374.49 936.68c3.59 0 4.39 3.32 4.39 5.52 0 3.09-1.48 5.65-4.53 5.65s-4.41-2.41-4.41-5.5c0-2.6 1.04-5.67 4.55-5.67zm-.11 9.7c1.27 0 2.71-1.07 2.71-4.24 0-2.62-1.04-4.01-2.61-4.01-1.07 0-2.8.8-2.8 4.09 0 2.16.79 4.16 2.7 4.16zM380.23 936.95h1.87l2.86 8.36 2.79-8.36h1.86l-3.93 10.54h-1.7l-3.75-10.54zM392.62 942.58c-.04 2.18.73 3.8 2.57 3.8 1.09 0 1.96-.67 2.11-2.18h1.68c-.05.52-.12 1.38-.77 2.2-.39.52-1.29 1.41-3.09 1.41-2.82 0-4.16-2.06-4.16-5.4 0-2.08.36-3.8 1.77-4.96.86-.71 1.93-.78 2.45-.78 4.02 0 3.93 4.18 3.89 5.9h-6.44zm4.73-1.39c.02-1.01-.14-3.11-2.21-3.11-1.09 0-2.41.78-2.45 3.11h4.66zM401.67 938.17l-.02-1.22h1.68l.02 1.7c.2-.44.84-1.91 2.87-1.91.8 0 3.25.36 3.25 3.59v7.16h-1.71v-6.7c0-.69-.07-1.32-.48-1.8-.43-.48-1.02-.71-1.59-.71-1.21 0-2.34 1.03-2.34 3.15v6.07h-1.68v-9.32zM413.58 944.36c-.02.8.34 1.91 1.96 1.91.7 0 1.21-.15 1.57-.67.18-.27.29-.63.29-.99 0-1.03-.62-1.22-1.96-1.58-1.87-.5-3.45-.94-3.45-3.15 0-1.93 1.43-3.19 3.5-3.19 1.12 0 2.7.38 3.23 1.64.23.59.23 1.09.23 1.53h-1.71c.05-1.6-1.12-1.72-1.73-1.72-.25 0-1.82 0-1.82 1.51 0 .96.8 1.2 1.27 1.34 2.48.69 3.02.86 3.55 1.45.5.55.68 1.28.68 1.95 0 1.18-.55 2.18-1.21 2.67-.79.57-1.73.71-2.66.71-1.82 0-3.52-.88-3.5-3.42h1.77zM420.25 936.91h1.59v-2.2l1.66-.63v2.83h2v1.45h-2v6.32c0 .53 0 1.41 1.2 1.41.34 0 .66-.06.8-.1v1.53c-.3.06-.79.13-1.39.13-1.54 0-2.27-.53-2.27-2.25v-7.03h-1.59v-1.45zM427.75 939.09c0-.71-.04-1.45-.09-2.14h1.7l.04 2.04c.32-1.47 1.39-1.95 2.14-2.08.5-.08.87-.06 1.16-.04v1.93c-.09-.04-.2-.06-.32-.08s-.29-.02-.48-.02c-1.98 0-2.45 1.39-2.45 3.19v5.61h-1.7v-8.4zM434.57 944.97h1.98v2.52h-1.98v-2.52z"></path>
          </g>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 276.03 987.93)"
          >
            <tspan x="0" y="0">
              Millöcker-
            </tspan>
            <tspan x="33.57" y="19">
              str.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 205.07 928.49)"
          >
            <tspan x="0" y="0">
              Eltinger
            </tspan>
            <tspan x="21.21" y="19">
              Str.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 564.01 784.8)"
          >
            <tspan x="0" y="0">
              Schwab-/Bebelstr.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1834.99 1017.6)"
          >
            <tspan x="0" y="0">
              Wangen Marktplatz
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1895.94 1075.57)"
          >
            <tspan x="0" y="0">
              Hedelfinger Str.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1699.88 927.64)"
          >
            <tspan x="0" y="0">
              Insel-
            </tspan>
            <tspan x="11.19" y="19">
              str.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1675.51 988.13)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Im
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="-19.41" y="19">
                Degen
              </tspan>
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1620.45 909.51)"
          >
            <tspan x="0" y="0">
              Brendle
            </tspan>
            <tspan x="5.9" y="19">
              (Groß-
            </tspan>
            <tspan x="6.49" y="38">
              markt)
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1539.86 891.46)"
          >
            <tspan x="0" y="0">
              Schlacht-
            </tspan>
            <tspan x="24.21" y="19">
              hof
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1515.46 866.02)"
          >
            <tspan x="0" y="0">
              Raitelsberg
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1389.42 783.81)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Karl-Olga-
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="-6.42" y="19">
                {" "}
                Krankenhaus
              </tspan>
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1434.47 834.43)"
          >
            <tspan x="0" y="0">
              Bergfriedhof
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 583.66 732.06)"
          >
            <tspan x="0" y="0">
              Schloss-/Johannesstr.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1777.39 959.64)"
          >
            <tspan x="0" y="0">
              Wasenstr.
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1897.36 1183.26)"
          >
            <tspan x="0" y="0">
              Hedelfingen
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 511.21 898.45)"
          >
            <tspan x="0" y="0">
              Vogelsang
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1427.78 694.08)"
          >
            <tspan letterSpacing="0em">
              <tspan x="0" y="0">
                Cann-
              </tspan>
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="0" y="19">
                {" "}
                statter
              </tspan>
            </tspan>
            <tspan x="0" y="38" letterSpacing="0em"></tspan>
            <tspan x="23.77" y="38" letterSpacing=".11em"></tspan>
            <tspan x="31.82" y="38" letterSpacing="0em">
              Wasen
            </tspan>
          </text>
          <g fill="#1d1d1b" strokeWidth="0">
            <path d="M1532.94 772.58h4l4.84 11.95v-11.95h2.57v15.18h-3.8l-5-12.6v12.6h-2.61v-15.18zM1548.91 783.24c0 .69 0 2.83 1.84 2.83.66 0 1.32-.29 1.57-1.47h2.41c-.04.5-.12 1.41-.86 2.31-.66.82-1.84 1.24-3.16 1.24-.77 0-2.23-.17-3.18-1.32-.82-1.01-1.16-2.44-1.16-4.14s.36-3.78 1.87-5.02c.7-.55 1.55-.88 2.54-.88 1.29 0 2.82.59 3.64 2.56.61 1.45.57 3 .54 3.88h-6.05zm3.36-1.95c0-.48-.04-2.37-1.57-2.37-1.16 0-1.64 1.13-1.7 2.37h3.27zM1561.57 780.91c-.04-.38-.14-1.95-1.16-1.95-1.25 0-1.39 2.23-1.39 3.38 0 .59.05 2.48.66 3.25.25.32.52.36.71.36.29 0 1.11-.15 1.21-2.04h2.61c-.04.82-.12 2.1-1.16 3.13-.64.65-1.45.99-2.57.99-1.2 0-2.25-.31-3.07-1.41-.79-1.07-1.14-2.48-1.14-4.18 0-4.83 3.02-5.5 4.21-5.5 1.68 0 3.66 1.09 3.68 3.97h-2.59zM1565.85 772.58h2.62v8.94l2.73-4.43h2.98l-3.09 4.62 3.28 6.05h-3.12l-2.79-5.77v5.77h-2.62v-15.18zM1581.24 787.76c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.95h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM1585.84 779.76c0-.5-.07-2.04-.12-2.65h2.48l.05 2.04c.34-.9.93-2.18 3.07-2.06v2.79c-2.68-.29-2.84 1.32-2.84 2.65v5.23h-2.64v-8zM1592.88 772.62h3.98c1.86 0 3.41.15 4.48 1.66.68.97.79 2.06.79 2.83 0 1.76-.62 3.25-1.64 4.03-.95.71-2.25.71-2.93.71h-1.88v5.9h-2.8v-15.14zm2.73 6.82h1.11c.89 0 2.55 0 2.55-2.31 0-2.06-1.48-2.06-2.27-2.06h-1.39v4.37zM1609.28 787.76c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.95h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM1613.89 779.76c0-.5-.07-2.04-.12-2.65h2.48l.05 2.04c.34-.9.93-2.18 3.07-2.06v2.79c-2.68-.29-2.84 1.32-2.84 2.65v5.23h-2.64v-8zM1620.96 772.58h2.62v8.94l2.73-4.43h2.98l-3.09 4.62 3.28 6.05h-3.12l-2.79-5.77v5.77h-2.62v-15.18zM1637.5 771.86c-.59 2.1-1.57 5.5-1.57 9.26 0 2.81.5 4.91 1.55 9.22h-1.95c-1.02-2.92-1.8-5.96-1.8-9.11s.82-6.36 1.82-9.36h1.95zM1642.11 782.91c0 .71-.04 2.88 2.34 2.88 1.5 0 2.45-.84 2.45-2.12s-.8-1.57-2.45-2.04c-3.07-.9-4.75-1.97-4.75-4.6s1.52-4.7 5.11-4.7c1.34 0 2.93.36 3.89 1.79.73 1.09.73 2.31.73 2.81h-2.66c-.04-.53-.18-2.31-2.09-2.31-1.29 0-2.12.82-2.12 2.06 0 1.41.95 1.66 2.8 2.2 2.23.63 4.43 1.34 4.43 4.3 0 2.73-1.93 4.93-5.5 4.93-4.95 0-4.98-3.74-5-5.21h2.82zM1657.12 787.61c-.86.27-1.62.34-2.05.34-2.66 0-2.66-1.97-2.66-2.86v-5.82h-1.73v-2.06h1.73v-2.08l2.62-1.13v3.21h2.14v2.06h-2.14v4.79c.02.97.02 1.57 1.2 1.57.39 0 .57-.02.89-.06v2.04zM1664.26 787.76c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.95h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM1674.83 772.6h2.66v13.44c0 .63.04 1.32.07 1.72h-2.68l-.07-1.53c-.18.38-.36.78-.91 1.2-.66.5-1.36.55-1.75.55-2.41 0-3.84-1.95-3.84-5.27 0-3.51 1.62-5.69 3.98-5.69 1.62 0 2.3 1.07 2.54 1.45v-5.86zm-2.02 13.35c.77 0 1.39-.55 1.68-1.2.39-.88.43-1.97.43-2.5 0-2.08-.77-3.21-1.96-3.21-1.77 0-1.96 2.5-1.96 3.57 0 1.76.5 3.34 1.82 3.34zM1679.77 772.6h2.82v2.71h-2.82v-2.71zm.09 4.54h2.64v10.62h-2.64v-10.62zM1689.16 776.9c3.27 0 4.68 2.6 4.68 5.56s-1.46 5.67-4.73 5.67c-2.57 0-4.61-1.87-4.61-5.58 0-2.56 1.11-5.65 4.66-5.65zm.04 9.07c1.16 0 1.95-.82 1.95-3.63 0-1.41-.23-3.36-1.98-3.36-1.93 0-1.95 2.62-1.95 3.59 0 2.37.68 3.4 1.98 3.4zM1695.94 779.04s0-1.2-.05-1.93h2.54l.07 1.6c.25-.48.96-1.85 2.93-1.85 1.77 0 2.52 1.26 2.75 2 .2.65.25 1.2.25 3.17v5.73h-2.7v-6.59c0-.44 0-.82-.14-1.16-.2-.46-.61-.9-1.29-.9-.57 0-1.09.31-1.37.82-.16.27-.32.8-.32 1.62v6.21h-2.66v-8.71zM1706.81 790.34c.59-2.1 1.57-5.5 1.57-9.26 0-2.83-.5-4.91-1.55-9.22h1.95c1.02 2.9 1.8 5.96 1.8 9.09s-.82 6.36-1.82 9.38h-1.95z"></path>
          </g>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.85 0 0 1 1874.93 467.05)"
          >
            <tspan x="0" y="0" letterSpacing="0em">
              Nü
            </tspan>
            <tspan x="29.38" y="0" letterSpacing=".02em">
              r
            </tspan>
            <tspan x="38.03" y="0" letterSpacing="0em">
              n-
            </tspan>
            <tspan letterSpacing="0em">
              <tspan x="0" y="19">
                berger{" "}
              </tspan>
            </tspan>
            <tspan x="0" y="38" letterSpacing="0em">
              St
            </tspan>
            <tspan x="21.21" y="38" letterSpacing="-.09em">
              r
            </tspan>
            <tspan x="27.55" y="38" letterSpacing="0em">
              .
            </tspan>
          </text>
          <text
            id="Stadtmitte_Rotebühlpl._"
            fill="#1d1d1b"
            data-name="Stadtmitte (Rotebühlpl.)"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 814.25 795.01)"
          >
            <tspan x="0" y="0">
              Stadtmitte{" "}
            </tspan>
            <tspan x="0" y="19">
              (Rotebühlplatz)
            </tspan>
          </text>
        </g>
        <g id="U_Station_Names_Unchanged" data-name="U Station Names Unchanged">
          <g
            id="U-Beschriftung_Kopie"
            fill="#1d1d1b"
            data-name="U-Beschriftung Kopie"
          >
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1251.58 1536.78)"
            >
              <tspan x="0" y="0">
                Landhaus
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1891.65 105.14)"
            >
              <tspan x="0" y="0">
                Suttnerstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1622.8 105.14)"
            >
              <tspan x="0" y="0">
                Tapachstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1476.59 73.14)"
            >
              <tspan x="0" y="0">
                Fürfelder Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1227.88 153.04)"
            >
              <tspan x="0" y="0">
                Hohensteinstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1228.02 186.68)"
            >
              <tspan x="0" y="0">
                Friedrichswahl
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1289.22 361)"
            >
              <tspan x="0" y="0">
                Löwentor
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1336.86 314.45)"
            >
              <tspan x="0" y="0">
                Züricher Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1386.19 264.2)"
            >
              <tspan x="0" y="0">
                Riethmüllerhaus
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 497.39 341.85)"
            >
              <tspan x="0" y="0">
                Landauer Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 406.37 436.08)"
            >
              <tspan x="0" y="0">
                Rastatter Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 380.16 483.19)"
            >
              <tspan x="0" y="0">
                Wolfbusch
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 288.82 530.31)"
            >
              <tspan x="0" y="0">
                Bergheimer Hof
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 905.11 262)"
            >
              <tspan x="0" y="0">
                Wilhelm-
              </tspan>
              <tspan x="-15.38" y="19">
                Geiger-Platz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 819.8 329.31)"
            >
              <tspan x="0" y="0">
                Föhrich
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 719.25 262.05)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Sportpark
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-4.41" y="19">
                  Feuerbach
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 954.88 412.03)"
            >
              <tspan x="0" y="0">
                Löwentorbrücke
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 .00104 -.00122 1 890.21 580.02)"
            >
              <tspan x="0" y="0">
                Stadtbibliothek
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1342.19 416.59)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Glocken
              </tspan>
              <tspan x="81.25" y="0" letterSpacing=".86em">
                -
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="24.71" y="19">
                  str.
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1160.05 491.54)"
            >
              <tspan x="0" y="0">
                Mitt-
              </tspan>
              <tspan x="0" y="19">
                nachtstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1077.81 491.79)"
            >
              <tspan x="0" y="0">
                Milch-
              </tspan>
              <tspan x="0" y="19">
                hof
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1113.39 550.63)"
            >
              <tspan x="0" y="0">
                Budapester
              </tspan>
              <tspan x="0" y="19">
                Platz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1525.46 159.76)"
            >
              <tspan x="0" y="0">
                Bottroper
              </tspan>
              <tspan x="30.01" y="19">
                Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 2100.77 159.96)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Brücken-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="28.21" y="19">
                  str.
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1959.74 178.76)"
            >
              <tspan x="0" y="0">
                Hornbach
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1901.87 274.06)"
            >
              <tspan x="0" y="0">
                Obere
              </tspan>
              <tspan x="-8.91" y="19">
                Ziegelei
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1793.6 334.09)"
            >
              <tspan x="0" y="0">
                Gnesener
              </tspan>
              <tspan x="30.55" y="19">
                Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1697.48 300.98)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Kur-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="1.15" y="19">
                  saal
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1702.26 408.7)"
            >
              <tspan x="0" y="0">
                Daimlerplatz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1282.23 924.1)"
            >
              <tspan x="0" y="0">
                Olgaeck
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1341.12 1004.47)"
            >
              <tspan x="0" y="0">
                Eugenspl.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1370.69 1034.04)"
            >
              <tspan x="0" y="0">
                Heidehofstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1398.94 1063.61)"
            >
              <tspan x="0" y="0">
                Stafflenbergstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1429.96 1093.17)"
            >
              <tspan x="0" y="0">
                Bubenbad
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1459.06 1122.74)"
            >
              <tspan x="0" y="0">
                Payerstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1488.1 1154.58)"
            >
              <tspan x="0" y="0">
                Geroksruhe
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1519.25 1183.86)"
            >
              <tspan x="0" y="0">
                Stelle
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1580.52 1244.33)"
            >
              <tspan x="0" y="0">
                Silberwald
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1642.04 1304.9)"
            >
              <tspan x="0" y="0">
                Schemppstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1611.65 1274.61)"
            >
              <tspan x="0" y="0">
                Sillenbuch
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1672.17 1335.19)"
            >
              <tspan x="0" y="0">
                Bockelstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1723.23 1395.47)"
            >
              <tspan x="0" y="0">
                Ruit
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1780.87 1456.05)"
            >
              <tspan x="0" y="0">
                Parksiedlung
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1752.07 1425.76)"
            >
              <tspan x="0" y="0">
                Zinsholz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1840.25 1516.62)"
            >
              <tspan x="0" y="0">
                Kreuzbrunnen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1868.19 1546.91)"
            >
              <tspan x="0" y="0">
                Techn. Akademie
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1810.27 1486.33)"
            >
              <tspan x="0" y="0">
                Scharnhauser Park
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 643.31 1285.54)"
            >
              <tspan x="0" y="0">
                Jurastr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 744.22 1257.95)"
            >
              <tspan x="0" y="0">
                Wall-
              </tspan>
              <tspan x="-9.39" y="19">
                graben
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 817.7 1257.81)"
            >
              <tspan x="0" y="0">
                {" "}
                SSB-
              </tspan>
              <tspan x="-12.28" y="19">
                Zentrum
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 904.04 1240.8)"
            >
              <tspan x="0" y="0">
                Vaihinger
              </tspan>
              <tspan x="0" y="19">
                Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 836.41 1371.05)"
            >
              <tspan x="0" y="0" letterSpacing="-.04em"></tspan>
              <tspan x="5.1" y="0" letterSpacing="0em">
                Rohrer Weg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 796.14 1416.6)"
            >
              <tspan x="0" y="0">
                Möhringen Freibad
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 652.58 1429.01)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Leinfelde
              </tspan>
              <tspan x="91.98" y="0" letterSpacing="-.1em">
                n
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="23.72" y="19">
                  Frank
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 609.43 1484.57)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Unter-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0.8" y="19">
                  aichen
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1138.44 1093.21)"
            >
              <tspan x="0" y="0">
                Pfaffenweg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1133.67 1199.74)"
            >
              <tspan x="0" y="0">
                Nägelestr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1153.55 1230.05)"
            >
              <tspan x="0" y="0">
                Zahnradbf.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1216.12 1026.15)"
            >
              <tspan x="0" y="0">
                Dobelstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1331 1112.02)"
            >
              <tspan x="0" y="0">
                Bopser
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1092.77 1259.8)"
            >
              <tspan x="0" y="0">
                Peregrinastr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1057.63 1317.68)"
            >
              <tspan x="0" y="0">
                Sonnen
              </tspan>
              <tspan x="15.85" y="19">
                berg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 922.25 1326.43)"
            >
              <tspan x="0" y="0">
                Möhringen
              </tspan>
              <tspan x="38.76" y="19">
                {" "}
                Bf
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1092.83 1378.29)"
            >
              <tspan x="0" y="0">
                Sigmaringer Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1199.74 1484.95)"
            >
              <tspan x="0" y="0">
                Salzäcker
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.8 0 0 1 1170.08 1126.26)"
            >
              <tspan x="0" y="0">
                Wielandshöhe
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1119.27 261.96)"
            >
              <tspan x="0" y="0">
                Maybach-
              </tspan>
              <tspan x="33.46" y="19">
                str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1160.7 1317.59)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Degerloch
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="20.17" y="21">
                  Albstr.
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1407.41 917.54)"
            >
              <tspan x="0" y="0">
                Ostheim{" "}
              </tspan>
              <tspan x="-47.1" y="19">
                Leo-Vetter-Bad
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1369.07 889.64)"
            >
              <tspan x="0" y="0">
                Ostendpl.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1530.14 988.04)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Wangener-/
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-6.52" y="19">
                  Landhausstr.
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 604.27 603.73)"
            >
              <tspan x="0" y="0">
                Russische
              </tspan>
              <tspan x="36.48" y="19">
                Kirche
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 723.84 603.31)"
            >
              <tspan x="0" y="0">
                Rosenberg-/
              </tspan>
              <tspan x="0" y="19">
                Seidenstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 231.3 577.42)"
            >
              <tspan x="0" y="0">
                {" "}
                Salamanderweg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 132.77 756.06)"
            >
              <tspan x="0" y="0">
                Siedlung
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 353.09 388.97)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Weilimdorf Löwen-Markt{" "}
              </tspan>
              <tspan x="255.59" y="0" letterSpacing=".12em"></tspan>
              <tspan x="264.05" y="0" letterSpacing="0em"></tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1388.51 1187.45)"
            >
              <tspan x="0" y="0">
                Waldau
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1105.47 1060.17)"
            >
              <tspan x="0" y="0">
                Liststr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1316.49 388.31)"
            >
              <tspan x="0" y="0">
                Rosensteinpark
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1343.65 105.14)"
            >
              <tspan x="0" y="0">
                Schozacher{" "}
              </tspan>
              <tspan x="42.95" y="19">
                Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1067.27 850.44)"
            >
              <tspan x="0" y="0">
                Schloss-{" "}
              </tspan>
              <tspan x="55.48" y="19">
                platz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 685.35 1371.05)"
            >
              <tspan x="0" y="0">
                Lapp Kabel
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 998.27 1259.8)"
            >
              <tspan x="0" y="0">
                Riedsee
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1776.91 612.55)"
            >
              <tspan x="0" y="0">
                Blick
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1776.91 649.48)"
            >
              <tspan x="0" y="0">
                Eszet
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1776.91 686.41)"
            >
              <tspan x="0" y="0">
                Schlotterbeckstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1776.91 575.63)"
            >
              <tspan x="0" y="0">
                Kienbachstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2036.59 73.14)"
            >
              <tspan x="0" y="0">
                Freiberg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1743.19 73.14)"
            >
              <tspan x="0" y="0">
                Himmelsleiter
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 913.73 503)"
            >
              <tspan x="0" y="0">
                Pragfriedhof
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1227.6 220.33)"
            >
              <tspan x="0" y="0">
                Borsigstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1228.02 253.97)"
            >
              <tspan x="0" y="0">
                Sieglestr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2086.68 274.06)"
            >
              <tspan x="0" y="0">
                Stein-
              </tspan>
              <tspan x="-23.55" y="19">
                haldenfeld
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1989.83 333.83)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  {" "}
                  Haupt-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-2.97" y="19">
                  friedhof
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2042.91 210.64)"
            >
              <tspan x="0" y="0">
                Mühle
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 169.49 696.89)"
            >
              <tspan x="0" y="0">
                Breitwiesen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1147.3 1431.55)"
            >
              <tspan x="0" y="0">
                Plieninger Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1204.52 1159.31)"
            >
              <tspan x="0" y="0">
                Haigst
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1447.64 965.45)"
            >
              <tspan x="0" y="0">
                Gaisburg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1211.7 304.59)"
            >
              <tspan x="0" y="0">
                Pragsattel
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1314.18 1247.23)"
            >
              <tspan x="0" y="0">
                Weinsteige
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 785.18 1459.61)"
            >
              <tspan x="0" y="0">
                Fasanenhof
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 785.18 1502.63)"
            >
              <tspan x="0" y="0">
                Europaplatz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 785.18 1545.65)"
            >
              <tspan x="0" y="0">
                EnBW City
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1690.93 259.75)"
            >
              <tspan x="0" y="0"></tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 943.5 105.14)"
            >
              <tspan x="0" y="0">
                Kirchtalstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 758.37 105.14)"
            >
              <tspan x="0" y="0">
                Salzwiesenstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 604.22 54.14)"
            >
              <tspan x="0" y="0">
                Wimpfener{" "}
              </tspan>
              <tspan x="35.21" y="19">
                Str.{" "}
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 448.26 105.37)"
            >
              <tspan x="0" y="0">
                Heutings-{" "}
              </tspan>
              <tspan x="-4.74" y="19">
                heimer Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 281.65 54.14)"
            >
              <tspan x="0" y="0">
                Korntaler{" "}
              </tspan>
              <tspan x="31.83" y="19">
                Str.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1066.77 54.14)"
            >
              <tspan x="0" y="0">
                Zuffenhausen
              </tspan>
              <tspan x="28.26" y="19">
                Rathaus
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1257.34 54.14)"
            >
              <tspan x="0" y="0">
                Zuffenhausen
              </tspan>
              <tspan x="15.79" y="19">
                Kelterplatz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1390.84 178.45)"
            >
              <tspan x="0" y="0">
                Hallschlag
              </tspan>
            </text>
            <text
              fontFamily="MyriadPro-Regular, 'Myriad Pro'"
              fontSize="12"
              transform="translate(1420.95 1378.93)"
            >
              <tspan x="0" y="0"></tspan>
            </text>
            <text
              fontFamily="MyriadPro-Regular, 'Myriad Pro'"
              fontSize="12"
              transform="translate(1455.05 988.67)"
            >
              <tspan x="0" y="0"></tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 786.52 1586.67)"
            >
              <tspan x="0" y="0">
                Schelmenwasen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 786.52 1629.87)"
            >
              <tspan x="0" y="0">
                Stadionstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 786.52 1674.96)"
            >
              <tspan x="0" y="0">
                Messe West
              </tspan>
            </text>
            <g id="U-Endpunkte_Kopie" data-name="U-Endpunkte Kopie">
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 2207.83 103.28)"
              >
                <tspan x="0" y="0">
                  Mönchfeld
                </tspan>
              </text>
              <g strokeWidth="0">
                <path d="M2209.02 193.65h4l4.84 11.95v-11.95h2.57v15.18h-3.8l-5-12.6v12.6h-2.61v-15.18zM2225 204.31c0 .69 0 2.83 1.84 2.83.66 0 1.32-.29 1.57-1.47h2.41c-.04.5-.12 1.41-.86 2.31-.66.82-1.84 1.24-3.16 1.24-.77 0-2.23-.17-3.18-1.32-.82-1.01-1.16-2.44-1.16-4.14s.36-3.78 1.87-5.02c.7-.55 1.55-.88 2.54-.88 1.29 0 2.82.59 3.64 2.56.61 1.45.57 3 .54 3.88H2225zm3.36-1.95c0-.48-.04-2.37-1.57-2.37-1.16 0-1.64 1.13-1.7 2.37h3.27zM2237.65 201.98c-.04-.38-.14-1.95-1.16-1.95-1.25 0-1.39 2.23-1.39 3.38 0 .59.05 2.48.66 3.25.25.31.52.36.71.36.29 0 1.11-.15 1.21-2.04h2.61c-.04.82-.12 2.1-1.16 3.13-.64.65-1.45.99-2.57.99-1.2 0-2.25-.31-3.07-1.41-.79-1.07-1.14-2.48-1.14-4.18 0-4.83 3.02-5.5 4.21-5.5 1.68 0 3.66 1.09 3.68 3.97h-2.59zM2241.94 193.65h2.62v8.94l2.73-4.43h2.98l-3.09 4.62 3.28 6.05h-3.12l-2.79-5.77v5.77h-2.62v-15.18zM2257.32 208.83c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.94h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM2261.93 200.83c0-.5-.07-2.04-.12-2.65h2.48l.05 2.04c.34-.9.93-2.18 3.07-2.06v2.79c-2.68-.29-2.84 1.32-2.84 2.65v5.23h-2.64v-8zM2277.51 198.26c-.07.84-.12 1.55-.12 2.62v7.83c0 3.91-2.77 4.28-4.5 4.28-1.29 0-3.8-.19-3.96-3.4h2.54c.04.31.16 1.47 1.57 1.47.79 0 1.46-.44 1.64-1.39.11-.52.11-.9.12-2.52-.84 1.3-1.79 1.45-2.43 1.45-2.59 0-3.8-2.65-3.8-5.21 0-2.69 1.27-5.25 3.86-5.25 1.64 0 2.25 1.05 2.52 1.51l.09-1.41h2.48zm-4.53 8.23c1.86 0 1.86-2.56 1.86-3.02 0-1.2-.2-3.23-1.8-3.23-1 0-1.82.9-1.82 3.17 0 .52 0 3.09 1.77 3.09zM2279.95 200.83c0-.5-.07-2.04-.12-2.65h2.48l.05 2.04c.34-.9.93-2.18 3.07-2.06v2.79c-2.68-.29-2.84 1.32-2.84 2.65v5.23h-2.64v-8zM2291.24 197.97c3.27 0 4.68 2.6 4.68 5.56s-1.46 5.67-4.73 5.67c-2.57 0-4.61-1.87-4.61-5.58 0-2.56 1.11-5.65 4.66-5.65zm-2.43-4.2h1.82v2.48h-1.82v-2.48zm2.46 13.27c1.16 0 1.95-.82 1.95-3.63 0-1.41-.23-3.36-1.98-3.36-1.93 0-1.95 2.62-1.95 3.59 0 2.37.68 3.4 1.98 3.4zm.61-13.27h1.82v2.48h-1.82v-2.48zM2298.02 200.11s0-1.2-.05-1.93h2.54l.07 1.6c.25-.48.96-1.85 2.93-1.85 1.77 0 2.52 1.26 2.75 1.99.2.65.25 1.2.25 3.17v5.73h-2.7v-6.59c0-.44 0-.82-.14-1.15-.2-.46-.61-.9-1.29-.9-.57 0-1.09.31-1.37.82-.16.27-.32.8-.32 1.62v6.21h-2.66v-8.71zM2308.89 193.67h2.82v2.71h-2.82v-2.71zm.09 4.54h2.64v10.62h-2.64v-10.62zM2314.07 200.11s0-1.2-.05-1.93h2.54l.07 1.6c.25-.48.96-1.85 2.93-1.85 1.77 0 2.52 1.26 2.75 1.99.2.65.25 1.2.25 3.17v5.73h-2.7v-6.59c0-.44 0-.82-.14-1.15-.2-.46-.61-.9-1.29-.9-.57 0-1.09.31-1.37.82-.16.27-.32.8-.32 1.62v6.21h-2.66v-8.71zM2333.58 198.26c-.07.84-.12 1.55-.12 2.62v7.83c0 3.91-2.77 4.28-4.5 4.28-1.29 0-3.8-.19-3.96-3.4h2.54c.04.31.16 1.47 1.57 1.47.79 0 1.46-.44 1.64-1.39.11-.52.11-.9.12-2.52-.84 1.3-1.79 1.45-2.43 1.45-2.59 0-3.8-2.65-3.8-5.21 0-2.69 1.27-5.25 3.86-5.25 1.64 0 2.25 1.05 2.52 1.51l.09-1.41h2.48zm-4.53 8.23c1.86 0 1.86-2.56 1.86-3.02 0-1.2-.2-3.23-1.8-3.23-1 0-1.82.9-1.82 3.17 0 .52 0 3.09 1.77 3.09zM2338.15 204.31c0 .69 0 2.83 1.84 2.83.66 0 1.32-.29 1.57-1.47h2.41c-.04.5-.12 1.41-.86 2.31-.66.82-1.84 1.24-3.16 1.24-.77 0-2.23-.17-3.18-1.32-.82-1.01-1.16-2.44-1.16-4.14s.36-3.78 1.87-5.02c.7-.55 1.55-.88 2.54-.88 1.29 0 2.82.59 3.64 2.56.61 1.45.57 3 .54 3.88h-6.05zm3.36-1.95c0-.48-.04-2.37-1.57-2.37-1.16 0-1.64 1.13-1.7 2.37h3.27zM2346.07 200.11s0-1.2-.05-1.93h2.54l.07 1.6c.25-.48.96-1.85 2.93-1.85 1.77 0 2.52 1.26 2.75 1.99.2.65.25 1.2.25 3.17v5.73h-2.7v-6.59c0-.44 0-.82-.14-1.15-.2-.46-.61-.9-1.29-.9-.57 0-1.09.31-1.37.82-.16.27-.32.8-.32 1.62v6.21h-2.66v-8.71zM2208.81 213.65h4.95c1.43-.02 2.87-.02 3.91 1.03.8.82 1.12 1.93 1.12 2.92 0 2.83-2.07 3.51-2.7 3.72 1.95.21 2.09 1.51 2.32 3.49.2 1.78.3 2.52.39 2.94.14.67.25.84.39 1.09h-3.05c-.12-.84-.52-4.68-.7-5.27-.25-.86-.93-.86-1.39-.86h-2.43v6.13h-2.82v-15.18zm2.73 6.63h2.23c.32 0 .96 0 1.41-.42.2-.17.71-.69.71-1.76s-.43-1.51-.68-1.7c-.43-.36-.95-.36-1.82-.36h-1.86v4.24zM2223.01 224.31c0 .69 0 2.83 1.84 2.83.66 0 1.32-.29 1.57-1.47h2.41c-.04.5-.12 1.41-.86 2.31-.66.82-1.84 1.24-3.16 1.24-.77 0-2.23-.17-3.18-1.32-.82-1.01-1.16-2.44-1.16-4.14s.36-3.78 1.87-5.02c.7-.55 1.55-.88 2.54-.88 1.29 0 2.82.59 3.64 2.56.61 1.45.57 3 .54 3.88h-6.05zm3.36-1.95c0-.48-.04-2.37-1.57-2.37-1.16 0-1.64 1.13-1.7 2.37h3.27zM2230.96 220.22c0-.67-.04-1.32-.09-1.99h2.55l.09 1.36c.29-.46.98-1.6 2.79-1.6 2.07 0 2.66 1.49 2.84 1.99.75-1.7 1.96-1.97 2.89-1.97 1.82 0 2.55 1.28 2.75 1.7.48.92.45 2.2.45 3.13v5.98h-2.66v-6.24c0-1.13-.14-2.39-1.52-2.39-1.59 0-1.62 1.74-1.62 3.32v5.31h-2.66v-6.3c0-.82-.02-2.33-1.48-2.33-1.66 0-1.66 1.68-1.66 2.39v6.24h-2.66v-8.61zM2249.68 225.76c.04.67.39 1.45 1.5 1.45.95 0 1.39-.63 1.39-1.26 0-.48-.21-.86-1.25-1.2l-1.64-.52c-.73-.25-2.29-.78-2.29-2.94s1.61-3.32 3.95-3.32c1.86 0 3.36 1.01 3.43 3.13h-2.41c-.07-1.18-.87-1.26-1.29-1.26-.71 0-1.25.4-1.25 1.05 0 .71.45.86 1.23 1.11l1.62.52c1.64.52 2.41 1.51 2.41 2.96 0 1.83-1.34 3.65-4.14 3.65-1.16 0-2.27-.29-3.09-1.3-.59-.73-.64-1.57-.66-2.08h2.48zM2258.98 224.31c0 .69 0 2.83 1.84 2.83.66 0 1.32-.29 1.57-1.47h2.41c-.04.5-.12 1.41-.86 2.31-.66.82-1.84 1.24-3.16 1.24-.77 0-2.23-.17-3.18-1.32-.82-1.01-1.16-2.44-1.16-4.14s.36-3.78 1.87-5.02c.7-.55 1.55-.88 2.54-.88 1.29 0 2.82.59 3.64 2.56.61 1.45.57 3 .54 3.88h-6.05zm3.36-1.95c0-.48-.04-2.37-1.57-2.37-1.16 0-1.64 1.13-1.7 2.37h3.27zM2271.64 221.98c-.04-.38-.14-1.95-1.16-1.95-1.25 0-1.39 2.23-1.39 3.38 0 .59.05 2.48.66 3.25.25.31.52.36.71.36.29 0 1.11-.15 1.21-2.04h2.61c-.04.82-.12 2.1-1.16 3.13-.64.65-1.45.99-2.57.99-1.2 0-2.25-.31-3.07-1.41-.79-1.07-1.14-2.48-1.14-4.18 0-4.83 3.02-5.5 4.21-5.5 1.68 0 3.66 1.09 3.68 3.97h-2.59zM2275.92 213.65h2.62v8.94l2.73-4.43h2.98l-3.09 4.62 3.28 6.05h-3.12l-2.79-5.77v5.77h-2.62v-15.18z"></path>
              </g>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 2207.66 350.57)"
              >
                <tspan x="0" y="0">
                  Neugereut
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1782.72 1365.48)"
              >
                <tspan x="0" y="0">
                  Heumaden
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1004.33 1177.73)"
              >
                <tspan x="0" y="0">
                  Waldfriedhof
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 438.29 655.35)"
              >
                <tspan x="0" y="0">
                  Hölderlinplatz
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 634.02 502.86)"
              >
                <tspan x="0" y="0">
                  Killesberg
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 529.79 1451.32)"
              >
                <tspan x="0" y="0">
                  Dürrlewang
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1263.57 1296.62)"
              >
                <tspan x="0" y="0">
                  Degerloch
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 74.68 870.74)"
              >
                <tspan x="0" y="0">
                  Gerlingen
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 257.16 653.94)"
              >
                <tspan x="0" y="0">
                  Giebel
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 84.37 1008.65)"
              >
                <tspan x="0" y="0">
                  Botnang
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1757.58 1629.06)"
              >
                <tspan x="0" y="0">
                  Nellingen Ostfildern
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1279.48 1633.24)"
              >
                <tspan x="0" y="0">
                  Plieningen
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 714.15 1743.39)"
              >
                <tspan x="0" y="0">
                  Flughafen/Messe
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 513.16 1582.68)"
              >
                <tspan x="0" y="0">
                  Leinfelden
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 51.7 106.25)"
              >
                <tspan x="0" y="0">
                  Stammheim
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1596.9 1214.33)"
              >
                <tspan x="0" y="0">
                  Ruhbank (Fernsehturm){" "}
                </tspan>
              </text>
              <text
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                transform="matrix(.85 0 0 1 679.69 358.53)"
              >
                <tspan letterSpacing="0em">
                  <tspan x="0" y="0">
                    Feuerbach{" "}
                  </tspan>
                </tspan>
                <tspan letterSpacing="0em">
                  <tspan x="0" y="20">
                    Pfostenwäldle
                  </tspan>
                </tspan>
              </text>
            </g>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1874.93 467.05)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Nü
              </tspan>
              <tspan x="29.38" y="0" letterSpacing=".02em">
                r
              </tspan>
              <tspan x="38.03" y="0" letterSpacing="0em">
                n-
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0" y="19">
                  berger{" "}
                </tspan>
              </tspan>
              <tspan x="0" y="38" letterSpacing="0em">
                St
              </tspan>
              <tspan x="21.21" y="38" letterSpacing="-.09em">
                r
              </tspan>
              <tspan x="27.55" y="38" letterSpacing="0em">
                .
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 988.82 329.31)"
            >
              <tspan x="0" y="0">
                Feuerbach
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1245.41 411.63)"
            >
              <tspan x="0" y="0">
                Nord-
              </tspan>
              <tspan x="22.24" y="19">
                bahn-
              </tspan>
              <tspan x="44.47" y="38">
                hof
              </tspan>
            </text>
          </g>
        </g>
      </g>
      <g ref={newTracks} id="U_Changed" data-name="U Changed">
        <g id="U1.1">
          <g id="U1_2023" data-name="U1 2023" ref={demoU1}>
            <g id="U1_Line" data-name="U1 Line">
              <path
                id="U1_2023_Lines"
                fill="none"
                stroke="#d2a070"
                strokeDasharray="0 0 0 0 0 0 10 10 10 10 10 10"
                strokeMiterlimit="10"
                strokeWidth="5.39"
                d="M2227.87 860.49L1825.39 457.88 1585.53 458.24 1241.61 790.71 1257.83 812.94 902.58 1168.49 613.28 1166.88 484.43 1294.62"
                data-name="U1 2023 Lines"
              ></path>
            </g>
          </g>
          <g
            id="U1_Line-2"
            fill="none"
            strokeMiterlimit="10"
            data-name="U1 Line"
          >
            <path
              stroke="#fff"
              strokeWidth="8.5"
              d="M1120.9 964.23L1120.9 943.65"
            ></path>
            <path
              stroke="#d3a170"
              strokeWidth="5.39"
              d="M915 1170.11L1120.9 964.23 1120.9 943.65 859.08 681.84"
            ></path>
            <path
              stroke="#d3a170"
              strokeWidth="5.39"
              d="M838.17 686.22L884.7 639.69 1061.57 639.64 1235.9 813.07 1358.46 690.51 1370.71 690.51 1590.78 470.49 1819.17 470.49 2210.53 861.84"
            ></path>
          </g>
          <g id="U_White_Kopie_3" data-name="U White Kopie 3">
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1936.21 586.7H1950.48V590.95H1936.21z"
              transform="rotate(-45 1943.35 588.828)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1989.31 639.8H2003.58V644.05H1989.31z"
              transform="rotate(-45 1996.448 641.934)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
              transform="rotate(-45 2049.55 695.028)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2095.52 746.01H2109.79V750.26H2095.52z"
              transform="rotate(-45 2102.648 748.135)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2148.62 799.11H2162.89V803.36H2148.62z"
              transform="rotate(-45 2155.75 801.23)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1799.38 459.31H1803.63V473.48H1799.38z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1569.87 467.81H1574.12V509.37H1569.87z"
              transform="rotate(-45.03 1571.841 488.6)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-4"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <g
              id="Haltepunkte_Standart_Kopie_2_Kopie"
              data-name="Haltepunkte Standart Kopie 2 Kopie"
            >
              <g
                id="S-Haltepunkte_Kopie_2_Kopie_2_Kopie"
                strokeWidth="0"
                data-name="S-Haltepunkte Kopie 2 Kopie 2 Kopie"
              >
                <path
                  fill="#fff"
                  d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
                ></path>
                <path
                  fill="#ededec"
                  d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
                ></path>
                <path
                  fill="#fff"
                  d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
                ></path>
              </g>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1936.21 586.7H1950.48V590.95H1936.21z"
              transform="rotate(-45 1943.35 588.828)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1989.31 639.8H2003.58V644.05H1989.31z"
              transform="rotate(-45 1996.448 641.934)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
              transform="rotate(-45 2049.55 695.028)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2095.52 746.01H2109.79V750.26H2095.52z"
              transform="rotate(-45 2102.648 748.135)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2148.62 799.11H2162.89V803.36H2148.62z"
              transform="rotate(-45 2155.75 801.23)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1799.38 459.31H1803.63V473.48H1799.38z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1569.87 467.81H1574.12V509.37H1569.87z"
              transform="rotate(-45.03 1571.841 488.6)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-5"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1936.21 586.7H1950.48V590.95H1936.21z"
              transform="rotate(-45 1943.35 588.828)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1989.31 639.8H2003.58V644.05H1989.31z"
              transform="rotate(-45 1996.448 641.934)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
              transform="rotate(-45 2049.55 695.028)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2095.52 746.01H2109.79V750.26H2095.52z"
              transform="rotate(-45 2102.648 748.135)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2148.62 799.11H2162.89V803.36H2148.62z"
              transform="rotate(-45 2155.75 801.23)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1799.38 459.31H1803.63V473.48H1799.38z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1569.87 467.81H1574.12V509.37H1569.87z"
              transform="rotate(-45.03 1571.841 488.6)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-6"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
          </g>
          <g id="U1_Stations" data-name="U1 Stations">
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1665.21 444.76)"
            >
              <tspan x="0" y="0">
                Uff-Kirchh.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1783.1 434.09)"
            >
              <tspan x="0" y="0">
                Augsburger{" "}
              </tspan>
              <tspan x="0" y="19">
                Platz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2171.76 803.05)"
            >
              <tspan x="0" y="0">
                Schwabenlandhalle
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1955.47 585.08)"
            >
              <tspan x="0" y="0">
                Antwerpener Straße
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2119.26 748.59)"
            >
              <tspan x="0" y="0">
                Esslinger Str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2009.7 639.53)"
            >
              <tspan x="0" y="0">
                Beskidenstr.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2064.03 694.14)"
            >
              <tspan x="0" y="0">
                Höhenstr.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1464.51 644.77)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Mercedes-
                </tspan>
              </tspan>
              <tspan x="0" y="19" letterSpacing="0em"></tspan>
              <tspan x="17.83" y="19" letterSpacing="-.03em"></tspan>
              <tspan x="22.93" y="19" letterSpacing="0em">
                str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 919.18 671.91)"
            >
              <tspan x="0" y="0">
                Börsenplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 711.19 681.03)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Berliner Plat
              </tspan>
              <tspan x="122.74" y="0" letterSpacing=".22em">
                z
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 2207.54 899.88)"
            >
              <tspan x="0" y="0">
                Fellbach
              </tspan>
              <tspan x="0" y="20">
                Lutherkirche
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              transform="matrix(.83 0 0 1 1451.74 457.89)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Bad Cannstatt
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0.96" y="20">
                  Wilhelmspl.{" "}
                </tspan>
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 845.19 1151.36)"
            >
              <tspan x="0" y="0">
                Heslach
              </tspan>
              <tspan x="-18.88" y="20">
                Vogelrain
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              transform="matrix(.85 .00119 -.0014 1 858.08 1107.2)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Südheime
              </tspan>
              <tspan x="102.35" y="0" letterSpacing="-.11em">
                r
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="58.57" y="20">
                  Platz
                </tspan>
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 955.74 1018.29)"
            >
              <tspan x="0" y="0">
                Marienplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1115.32 1004.47)"
            >
              <tspan x="0" y="0">
                Österreich.
              </tspan>
              <tspan x="0" y="19">
                Platz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.83 0 0 1 893.82 1045.95)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Erwin-Schoettle-
                </tspan>
              </tspan>
              <tspan x="93.28" y="19" letterSpacing="0em">
                Plat
              </tspan>
              <tspan x="131.04" y="19" letterSpacing="-.16em">
                z
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1007.62 1064.95)"
            >
              <tspan x="0" y="0" letterSpacing="0em"></tspan>
              <tspan x="17.82" y="0" letterSpacing=".22em"></tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 996.99 1122.92)"
            >
              <tspan x="0" y="0">
                Bihlplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1308.33 808.52)"
            >
              <tspan x="0" y="0">
                Neckar-
              </tspan>
              <tspan x="0" y="19">
                tor
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1270.04 848.57)"
            >
              <tspan x="0" y="0">
                Staatsgalerie
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1211.93 741.03)"
            >
              <tspan x="0" y="0">
                Stöckach
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1276.76 701.47)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Metzst
              </tspan>
              <tspan x="65.94" y="0" letterSpacing="-.13em">
                r
              </tspan>
              <tspan x="71.27" y="0" letterSpacing="0em">
                .{" "}
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1291.19 646.07)"
            >
              <tspan x="0" y="0">
                Mineral-
              </tspan>
              <tspan x="25.98" y="19">
                bäder
              </tspan>
            </text>
            <g id="Hauptbahnhof-2" data-name="Hauptbahnhof">
              <text
                fill="#1d1d1b"
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1073.02 729.12)"
              >
                <tspan x="0" y="0">
                  Haupt-
                </tspan>
                <tspan x="0" y="19">
                  bahnhof
                </tspan>
              </text>
              <text
                fill="#1d1d1b"
                fontFamily="UniversLTStd, 'Univers LT Std'"
                fontSize="21"
                transform="matrix(.75 0 0 1 1073.02 769.12)"
              >
                <tspan x="0" y="0">
                  (Arnulf-Klett-P
                </tspan>
                <tspan x="141.14" y="0" letterSpacing="-.06em">
                  l.
                </tspan>
                <tspan x="150.29" y="0">
                  )
                </tspan>
              </text>
              <g strokeWidth="0">
                <path
                  fill="#1d1d1b"
                  fillRule="evenodd"
                  d="M1092.22 685.51L1092.22 687.7 1107.9 681.08 1123.4 687.7 1123.4 685.51 1107.9 678.9 1092.22 685.51"
                ></path>
                <path
                  fill="#1d1d1b"
                  fillRule="evenodd"
                  d="M1095.06 710.08L1123.4 710.08 1123.4 703.28 1113.92 703.28 1113.92 708.38 1109.73 708.38 1109.73 707.24 1106.73 707.24 1106.73 708.38 1100.23 708.38 1100.23 707.24 1097.23 707.24 1097.23 708.38 1095.06 708.38 1095.06 710.08"
                ></path>
                <path
                  fill="#1d1d1b"
                  fillRule="evenodd"
                  d="M1110.09 691.75c-.83-2.08-2.61-2.65-6.62-2.65s-5.78.57-6.62 2.65c-.67 1.51-1.81 4.72-1.81 6.61v5.1c0 1.7 1.33 3.21 2.67 3.21h11.51c1.33 0 2.67-1.51 2.67-3.21v-5.1c0-1.89-1.14-5.1-1.81-6.61z"
                ></path>
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M1104.62 699.44a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1099.33 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1109.93 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001z"
                ></path>
                <path
                  fill="#fff"
                  d="M1109.44 694.31l-.67-1.92c-.28-.75-.8-1.11-1.37-1.29-.57-.18-1.64-.43-3.91-.43-2.27 0-3.35.25-3.91.43-.57.18-1.09.55-1.37 1.29l-.67 1.92c-.28.85-.19 1.74 1.09 1.62 1.28-.11 2.32-.4 4.88-.4s3.6.29 4.88.4c1.28.11 1.37-.77 1.09-1.62z"
                ></path>
                <path
                  fill="#1d1d1b"
                  d="M1103.47 686.34h-5.31v.65c2.48 0 4.99.96 4.99 3.11h.65c0-2.15 2.5-3.11 4.99-3.11v-.65h-5.31zm0 2.36c-.38-.75-1.08-1.32-1.94-1.71h3.87c-.86.39-1.55.95-1.94 1.71z"
                ></path>
              </g>
            </g>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1874.93 467.05)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Nü
              </tspan>
              <tspan x="29.38" y="0" letterSpacing=".02em">
                r
              </tspan>
              <tspan x="38.03" y="0" letterSpacing="0em">
                n-
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0" y="19">
                  berger{" "}
                </tspan>
              </tspan>
              <tspan x="0" y="38" letterSpacing="0em">
                St
              </tspan>
              <tspan x="21.21" y="38" letterSpacing="-.09em">
                r
              </tspan>
              <tspan x="27.55" y="38" letterSpacing="0em">
                .
              </tspan>
            </text>
            <text
              id="Stadtmitte_Rotebühlpl._-2"
              fill="#1d1d1b"
              data-name="Stadtmitte (Rotebühlpl.)"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 814.05 795.01)"
            >
              <tspan x="0" y="0">
                Stadtmitte{" "}
              </tspan>
              <tspan x="0" y="19">
                (Rotebühlplatz)
              </tspan>
            </text>
          </g>
          <g id="U1_StartandEnd" strokeWidth="0" data-name="U1 StartandEnd">
            <g id="U1-2" data-name="U1">
              <path
                fill="#fff"
                d="M2204.73 848.49H2250.96V882.51H2204.73z"
              ></path>
              <path
                fill="#d3a170"
                d="M2208.99 852.74H2246.6899999999996V878.25H2208.99z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M2223.23 857.16v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.08-1.81 7.12-6.42v-10.47h-4.12zM2237.02 857.84c-1.2 1.15-2.62 2.02-4.12 2.54v3.53c1.24-.46 2.39-1.19 3.49-1.97v11.76h3.92v-15.86h-3.28z"
              ></path>
            </g>
            <g id="U1-3" data-name="U1">
              <path
                fill="#fff"
                d="M921.72 1177.35H967.95V1211.37H921.72z"
              ></path>
              <path
                fill="#d3a170"
                d="M925.98 1181.6H963.6800000000001V1207.11H925.98z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M940.22 1186.01v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.08-1.81 7.12-6.42v-10.47h-4.12zM954.01 1186.7c-1.2 1.15-2.62 2.02-4.12 2.54v3.53c1.24-.46 2.39-1.19 3.49-1.97v11.76h3.92v-15.86h-3.28z"
              ></path>
            </g>
          </g>
        </g>
        <g id="U9.1">
          <g id="U9_2023" data-name="U9 2023" ref={demoU9}>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 956.05 1018.35)"
            >
              <tspan x="0" y="0">
                Marienplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1115.64 1004.53)"
            >
              <tspan x="0" y="0">
                Österreich.
              </tspan>
              <tspan x="0" y="19">
                Platz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 997.3 1122.98)"
            >
              <tspan x="0" y="0">
                Bihlplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1237.84 879.63)"
            >
              <tspan x="0" y="0">
                Charlottenpl.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1157.27 962.4)"
            >
              <tspan x="0" y="0">
                Rathaus
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              transform="matrix(.85 .00119 -.0014 1 858.39 1107.26)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Südheime
              </tspan>
              <tspan x="102.35" y="0" letterSpacing="-.11em">
                r
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="58.57" y="20">
                  Platz
                </tspan>
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 845.5 1151.42)"
            >
              <tspan x="0" y="0">
                Heslach
              </tspan>
              <tspan x="-18.88" y="20">
                Vogelrain
              </tspan>
            </text>
            <path
              id="U9_2023-2"
              fill="none"
              stroke="#ffd400"
              strokeDasharray="0 0 0 0 0 0 10 10 10 10 10 10"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1926.3 1143.85L1762.15 979.78 1595.17 979.5 1490.19 872.6 1444.37 872.6 1311.93 744.67 894.96 1152.83"
              data-name="U9 2023"
            ></path>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.83 0 0 1 893.39 1046.31)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Erwin-Schoettle-
                </tspan>
              </tspan>
              <tspan x="93.28" y="19" letterSpacing="0em">
                Plat
              </tspan>
              <tspan x="131.04" y="19" letterSpacing="-.16em">
                z
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1007.19 1065.31)"
            >
              <tspan x="0" y="0" letterSpacing="0em"></tspan>
              <tspan x="17.82" y="0" letterSpacing=".22em"></tspan>
            </text>
          </g>
          <g id="U9_Line" fill="none" strokeMiterlimit="10" data-name="U9 Line">
            <path
              stroke="#fff"
              strokeWidth="8.5"
              d="M1942 1142.03L1763.96 964.57 1605.59 964.57 1491.36 850.34 1442.44 850.34 1314.32 722.38 1314.32 722.38 1235.87 800.83 1065.46 631.23 880.82 631.19 556.09 955.92 158.14 955.92"
            ></path>
            <path
              stroke="#ffd500"
              strokeWidth="5.39"
              d="M1942 1142.03L1763.96 964.57 1605.59 964.57 1491.36 850.34 1442.44 850.34 1314.32 722.38 1314.32 722.38 1235.87 800.83 1065.46 631.23 880.82 631.19 556.09 955.92 158.14 955.92"
            ></path>
          </g>
          <g id="U_White_Kopie_4" data-name="U White Kopie 4">
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.84"
              d="M1758.66 953.28H1772.8200000000002V967.4H1758.66z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M235.99 952.87H240.24V967.33H235.99z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M315.96 952.87H320.21V967.33H315.96z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M395.93 952.87H400.18V967.33H395.93z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M475.9 952.87H480.15V967.33H475.9z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1611.43 953.12H1615.68V967.58H1611.43z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1647.88 953.12H1652.13V967.58H1647.88z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1720.79 953.12H1725.04V967.58H1720.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1821.49 1021.11H1835.95V1025.3600000000001H1821.49z"
              transform="rotate(-45 1828.708 1023.235)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1420.77 839.83H1435.23V844.08H1420.77z"
              transform="rotate(-45 1427.999 841.954)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1380.71 799.78H1395.17V804.03H1380.71z"
              transform="rotate(-45 1387.908 801.9)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1878.7 1078.32H1893.16V1082.57H1878.7z"
              transform="rotate(-45 1885.921 1080.436)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1684.33 953.12H1688.58V967.58H1684.33z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M562.49 946.26H566.74V960.72H562.49z"
              transform="rotate(-45 564.614 953.48)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M616.5 892.31H620.75V906.5999999999999H616.5z"
              transform="rotate(-45 618.627 899.456)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M562.71 946.01H566.96V960.3H562.71z"
              transform="rotate(-45 564.831 953.16)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M670.3 838.61H674.55V852.9H670.3z"
              transform="rotate(-45 672.423 845.753)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M724.1 784.91H728.35V799.1999999999999H724.1z"
              transform="rotate(-45 726.23 792.056)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M777.9 731.22H782.15V745.51H777.9z"
              transform="rotate(-45 780.02 738.365)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1506.97 866.87H1512.92V871.12H1506.97z"
              transform="rotate(-45 1509.95 868.998)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1543.36 903.14H1549.31V907.39H1543.36z"
              transform="rotate(-45 1546.34 905.255)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="Haltepunkte_Standart_Kopie_4_Kopie_2"
              data-name="Haltepunkte Standart Kopie 4 Kopie 2"
            >
              <g
                id="S-Haltepunkte_Kopie_2_Kopie_4_Kopie_2"
                strokeWidth="0"
                data-name="S-Haltepunkte Kopie 2 Kopie 4 Kopie 2"
              >
                <path
                  fill="#ededec"
                  d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
                ></path>
                <path
                  fill="#fff"
                  d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
                ></path>
              </g>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.84"
              d="M1758.66 953.28H1772.8200000000002V967.4H1758.66z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M235.99 952.87H240.24V967.33H235.99z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M315.96 952.87H320.21V967.33H315.96z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M395.93 952.87H400.18V967.33H395.93z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M475.9 952.87H480.15V967.33H475.9z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1611.43 953.12H1615.68V967.58H1611.43z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1647.88 953.12H1652.13V967.58H1647.88z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1720.79 953.12H1725.04V967.58H1720.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1821.49 1021.11H1835.95V1025.3600000000001H1821.49z"
              transform="rotate(-45 1828.708 1023.235)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1420.77 839.83H1435.23V844.08H1420.77z"
              transform="rotate(-45 1427.999 841.954)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1380.71 799.78H1395.17V804.03H1380.71z"
              transform="rotate(-45 1387.908 801.9)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1878.7 1078.32H1893.16V1082.57H1878.7z"
              transform="rotate(-45 1885.921 1080.436)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1684.33 953.12H1688.58V967.58H1684.33z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M562.49 946.26H566.74V960.72H562.49z"
              transform="rotate(-45 564.614 953.48)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M616.5 892.31H620.75V906.5999999999999H616.5z"
              transform="rotate(-45 618.627 899.456)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M562.71 946.01H566.96V960.3H562.71z"
              transform="rotate(-45 564.831 953.16)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M670.3 838.61H674.55V852.9H670.3z"
              transform="rotate(-45 672.423 845.753)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M724.1 784.91H728.35V799.1999999999999H724.1z"
              transform="rotate(-45 726.23 792.056)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M777.9 731.22H782.15V745.51H777.9z"
              transform="rotate(-45 780.02 738.365)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1506.97 866.87H1512.92V871.12H1506.97z"
              transform="rotate(-45 1509.95 868.998)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1543.36 903.14H1549.31V907.39H1543.36z"
              transform="rotate(-45 1546.34 905.255)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.84"
              d="M1758.66 953.28H1772.8200000000002V967.4H1758.66z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M235.99 952.87H240.24V967.33H235.99z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M315.96 952.87H320.21V967.33H315.96z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M395.93 952.87H400.18V967.33H395.93z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M475.9 952.87H480.15V967.33H475.9z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1611.43 953.12H1615.68V967.58H1611.43z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1647.88 953.12H1652.13V967.58H1647.88z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1720.79 953.12H1725.04V967.58H1720.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1821.49 1021.11H1835.95V1025.3600000000001H1821.49z"
              transform="rotate(-45 1828.708 1023.235)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1420.77 839.83H1435.23V844.08H1420.77z"
              transform="rotate(-45 1427.999 841.954)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1380.71 799.78H1395.17V804.03H1380.71z"
              transform="rotate(-45 1387.908 801.9)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1878.7 1078.32H1893.16V1082.57H1878.7z"
              transform="rotate(-45 1885.921 1080.436)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1684.33 953.12H1688.58V967.58H1684.33z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M562.49 946.26H566.74V960.72H562.49z"
              transform="rotate(-45 564.614 953.48)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M616.5 892.31H620.75V906.5999999999999H616.5z"
              transform="rotate(-45 618.627 899.456)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M562.71 946.01H566.96V960.3H562.71z"
              transform="rotate(-45 564.831 953.16)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M670.3 838.61H674.55V852.9H670.3z"
              transform="rotate(-45 672.423 845.753)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M724.1 784.91H728.35V799.1999999999999H724.1z"
              transform="rotate(-45 726.23 792.056)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M777.9 731.22H782.15V745.51H777.9z"
              transform="rotate(-45 780.02 738.365)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1506.97 866.87H1512.92V871.12H1506.97z"
              transform="rotate(-45 1509.95 868.998)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1543.36 903.14H1549.31V907.39H1543.36z"
              transform="rotate(-45 1546.34 905.255)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
          </g>
          <g id="U9_Stations" data-name="U9 Stations">
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 528.65 837.53)"
            >
              <tspan x="0" y="0">
                Arndt-/Spittastr.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 514.7 928.49)"
            >
              <tspan x="0" y="0">
                Herder-
              </tspan>
              <tspan x="0" y="19">
                platz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 456.53 988.03)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Lind-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-32.46" y="19">
                  paintnerstr.
                </tspan>
              </tspan>
            </text>
            <g fill="#1d1d1b" strokeWidth="0">
              <path d="M377.75 913.33h4.61c1.57 0 2.45.19 3.25 1.11.55.63.91 1.51.91 2.71 0 2.5-1.55 3.15-2.18 3.42.75.25 2.57.88 2.57 3.78 0 2.06-1.12 3.11-1.55 3.44-.89.69-1.89.69-2.91.69h-4.7v-15.16zm1.73 6.4h2.5c.61 0 2.68 0 2.68-2.39s-1.62-2.29-2.61-2.29h-2.57v4.68zm0 7.05h3.05c1.41 0 2.54-.88 2.54-2.62 0-1.51-.89-2.62-2.46-2.62h-3.12v5.25zM390.64 923.58c-.04 2.18.73 3.8 2.57 3.8 1.09 0 1.96-.67 2.11-2.18H397c-.05.52-.12 1.38-.77 2.2-.39.52-1.29 1.41-3.09 1.41-2.82 0-4.16-2.06-4.16-5.4 0-2.08.36-3.8 1.77-4.96.86-.71 1.93-.78 2.45-.78 4.02 0 3.93 4.18 3.89 5.9h-6.44zm4.73-1.39c.02-1.01-.14-3.11-2.21-3.11-1.09 0-2.41.78-2.45 3.11h4.66zM400.66 923.58c-.04 2.18.73 3.8 2.57 3.8 1.09 0 1.96-.67 2.11-2.18h1.68c-.05.52-.12 1.38-.77 2.2-.39.52-1.29 1.41-3.09 1.41-2.82 0-4.16-2.06-4.16-5.4 0-2.08.36-3.8 1.77-4.96.86-.71 1.93-.78 2.45-.78 4.02 0 3.93 4.18 3.89 5.9h-6.44zm4.73-1.39c.02-1.01-.14-3.11-2.21-3.11-1.09 0-2.41.78-2.45 3.11h4.66zM408.28 917.91h1.59v-2.2l1.66-.63v2.83h2v1.45h-2v6.32c0 .53 0 1.41 1.2 1.41.34 0 .66-.06.8-.1v1.53c-.3.06-.79.13-1.39.13-1.54 0-2.27-.53-2.27-2.25v-7.03h-1.59v-1.45zM414.86 922.17h4.48v1.6h-4.48v-1.6zM359.6 932.35h1.7v6.15c.55-1.11 1.66-1.74 2.91-1.74.95 0 2.3.4 2.82 1.68.18.42.3.92.3 2.46v6.59h-1.71v-6.24c0-.95 0-2.98-1.93-2.98-1.25 0-1.87.9-2.11 1.41-.29.59-.29 1.58-.29 2.23v5.58h-1.7v-15.14zM374.49 936.68c3.59 0 4.39 3.32 4.39 5.52 0 3.09-1.48 5.65-4.53 5.65s-4.41-2.41-4.41-5.5c0-2.6 1.04-5.67 4.55-5.67zm-.11 9.7c1.27 0 2.71-1.07 2.71-4.24 0-2.62-1.04-4.01-2.61-4.01-1.07 0-2.8.8-2.8 4.09 0 2.16.79 4.16 2.7 4.16zM380.23 936.95h1.87l2.86 8.36 2.79-8.36h1.86l-3.93 10.54h-1.7l-3.75-10.54zM392.62 942.58c-.04 2.18.73 3.8 2.57 3.8 1.09 0 1.96-.67 2.11-2.18h1.68c-.05.52-.12 1.38-.77 2.2-.39.52-1.29 1.41-3.09 1.41-2.82 0-4.16-2.06-4.16-5.4 0-2.08.36-3.8 1.77-4.96.86-.71 1.93-.78 2.45-.78 4.02 0 3.93 4.18 3.89 5.9h-6.44zm4.73-1.39c.02-1.01-.14-3.11-2.21-3.11-1.09 0-2.41.78-2.45 3.11h4.66zM401.67 938.17l-.02-1.22h1.68l.02 1.7c.2-.44.84-1.91 2.87-1.91.8 0 3.25.36 3.25 3.59v7.16h-1.71v-6.7c0-.69-.07-1.32-.48-1.8-.43-.48-1.02-.71-1.59-.71-1.21 0-2.34 1.03-2.34 3.15v6.07h-1.68v-9.32zM413.58 944.36c-.02.8.34 1.91 1.96 1.91.7 0 1.21-.15 1.57-.67.18-.27.29-.63.29-.99 0-1.03-.62-1.22-1.96-1.58-1.87-.5-3.45-.94-3.45-3.15 0-1.93 1.43-3.19 3.5-3.19 1.12 0 2.7.38 3.23 1.64.23.59.23 1.09.23 1.53h-1.71c.05-1.6-1.12-1.72-1.73-1.72-.25 0-1.82 0-1.82 1.51 0 .96.8 1.2 1.27 1.34 2.48.69 3.02.86 3.55 1.45.5.55.68 1.28.68 1.95 0 1.18-.55 2.18-1.21 2.67-.79.57-1.73.71-2.66.71-1.82 0-3.52-.88-3.5-3.42h1.77zM420.25 936.91h1.59v-2.2l1.66-.63v2.83h2v1.45h-2v6.32c0 .53 0 1.41 1.2 1.41.34 0 .66-.06.8-.1v1.53c-.3.06-.79.13-1.39.13-1.54 0-2.27-.53-2.27-2.25v-7.03h-1.59v-1.45zM427.75 939.09c0-.71-.04-1.45-.09-2.14h1.7l.04 2.04c.32-1.47 1.39-1.95 2.14-2.08.5-.08.87-.06 1.16-.04v1.93c-.09-.04-.2-.06-.32-.08s-.29-.02-.48-.02c-1.98 0-2.45 1.39-2.45 3.19v5.61h-1.7v-8.4zM434.57 944.97h1.98v2.52h-1.98v-2.52z"></path>
            </g>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 276.03 987.93)"
            >
              <tspan x="0" y="0">
                Millöcker-
              </tspan>
              <tspan x="33.57" y="19">
                str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 205.07 928.49)"
            >
              <tspan x="0" y="0">
                Eltinger
              </tspan>
              <tspan x="21.21" y="19">
                Str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 564.01 784.8)"
            >
              <tspan x="0" y="0">
                Schwab-/Bebelstr.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1834.99 1017.6)"
            >
              <tspan x="0" y="0">
                Wangen Marktplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1895.94 1075.57)"
            >
              <tspan x="0" y="0">
                Hedelfinger Str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1699.88 927.64)"
            >
              <tspan x="0" y="0">
                Insel-
              </tspan>
              <tspan x="11.19" y="19">
                str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1675.51 988.13)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Im
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-19.41" y="19">
                  Degen
                </tspan>
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1620.45 909.51)"
            >
              <tspan x="0" y="0">
                Brendle
              </tspan>
              <tspan x="5.9" y="19">
                (Groß-
              </tspan>
              <tspan x="6.49" y="38">
                markt)
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1539.86 891.46)"
            >
              <tspan x="0" y="0">
                Schlacht-
              </tspan>
              <tspan x="24.21" y="19">
                hof
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1515.46 866.02)"
            >
              <tspan x="0" y="0">
                Raitelsberg
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1389.42 783.81)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Karl-Olga-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-6.42" y="19">
                  {" "}
                  Krankenhaus
                </tspan>
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1434.47 834.43)"
            >
              <tspan x="0" y="0">
                Bergfriedhof
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 583.66 732.06)"
            >
              <tspan x="0" y="0">
                Schloss-/Johannesstr.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1777.39 959.64)"
            >
              <tspan x="0" y="0">
                Wasenstr.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1897.36 1183.26)"
            >
              <tspan x="0" y="0">
                Hedelfingen
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 511.21 898.45)"
            >
              <tspan x="0" y="0">
                Vogelsang
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 919.18 671.91)"
            >
              <tspan x="0" y="0">
                Börsenplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 711.19 681.03)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Berliner Plat
              </tspan>
              <tspan x="122.74" y="0" letterSpacing=".22em">
                z
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1308.33 808.52)"
            >
              <tspan x="0" y="0">
                Neckar-
              </tspan>
              <tspan x="0" y="19">
                tor
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1270.04 848.57)"
            >
              <tspan x="0" y="0">
                Staatsgalerie
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1211.93 741.03)"
            >
              <tspan x="0" y="0">
                Stöckach
              </tspan>
            </text>
            <g id="Hauptbahnhof-3" data-name="Hauptbahnhof">
              <text
                fill="#1d1d1b"
                fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
                fontSize="21"
                fontWeight="700"
                letterSpacing="0em"
                transform="matrix(.85 0 0 1 1073.02 729.12)"
              >
                <tspan x="0" y="0">
                  Haupt-
                </tspan>
                <tspan x="0" y="19">
                  bahnhof
                </tspan>
              </text>
              <text
                fill="#1d1d1b"
                fontFamily="UniversLTStd, 'Univers LT Std'"
                fontSize="21"
                transform="matrix(.75 0 0 1 1073.02 769.12)"
              >
                <tspan x="0" y="0">
                  (Arnulf-Klett-P
                </tspan>
                <tspan x="141.14" y="0" letterSpacing="-.06em">
                  l.
                </tspan>
                <tspan x="150.29" y="0">
                  )
                </tspan>
              </text>
              <g strokeWidth="0">
                <path
                  fill="#1d1d1b"
                  fillRule="evenodd"
                  d="M1092.22 685.51L1092.22 687.7 1107.9 681.08 1123.4 687.7 1123.4 685.51 1107.9 678.9 1092.22 685.51"
                ></path>
                <path
                  fill="#1d1d1b"
                  fillRule="evenodd"
                  d="M1095.06 710.08L1123.4 710.08 1123.4 703.28 1113.92 703.28 1113.92 708.38 1109.73 708.38 1109.73 707.24 1106.73 707.24 1106.73 708.38 1100.23 708.38 1100.23 707.24 1097.23 707.24 1097.23 708.38 1095.06 708.38 1095.06 710.08"
                ></path>
                <path
                  fill="#1d1d1b"
                  fillRule="evenodd"
                  d="M1110.09 691.75c-.83-2.08-2.61-2.65-6.62-2.65s-5.78.57-6.62 2.65c-.67 1.51-1.81 4.72-1.81 6.61v5.1c0 1.7 1.33 3.21 2.67 3.21h11.51c1.33 0 2.67-1.51 2.67-3.21v-5.1c0-1.89-1.14-5.1-1.81-6.61z"
                ></path>
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M1104.62 699.44a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1099.33 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1109.93 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001z"
                ></path>
                <path
                  fill="#fff"
                  d="M1109.44 694.31l-.67-1.92c-.28-.75-.8-1.11-1.37-1.29-.57-.18-1.64-.43-3.91-.43-2.27 0-3.35.25-3.91.43-.57.18-1.09.55-1.37 1.29l-.67 1.92c-.28.85-.19 1.74 1.09 1.62 1.28-.11 2.32-.4 4.88-.4s3.6.29 4.88.4c1.28.11 1.37-.77 1.09-1.62z"
                ></path>
                <path
                  fill="#1d1d1b"
                  d="M1103.47 686.34h-5.31v.65c2.48 0 4.99.96 4.99 3.11h.65c0-2.15 2.5-3.11 4.99-3.11v-.65h-5.31zm0 2.36c-.38-.75-1.08-1.32-1.94-1.71h3.87c-.86.39-1.55.95-1.94 1.71z"
                ></path>
              </g>
            </g>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontSize="21"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 84.37 1008.65)"
            >
              <tspan x="0" y="0">
                Botnang
              </tspan>
            </text>
          </g>
          <g id="U9_StartandEnd" strokeWidth="0" data-name="U9 StartandEnd">
            <g id="U9">
              <path
                fill="#fff"
                d="M1894.37 1131.86H1940.6V1165.8799999999999H1894.37z"
              ></path>
              <path
                fill="#ffd500"
                d="M1898.64 1136.11H1936.3400000000001V1161.62H1898.64z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1912.78 1140.52v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12zM1920.49 1152.99c.06 3.35 2.97 4.42 5.51 4.42 2.18 0 3.3-.37 4.76-1.95.82-.89 1.88-3.25 1.94-5.45.14-4.81-1.18-9.14-6.33-9.14-3.14 0-6.1 1.65-6.1 5.48 0 3.09 2.29 5.02 4.95 5.02 1.3 0 2.62-.53 3.43-1.65l.04.04c-.08 2.04 0 4.67-2.54 4.67-.43 0-.88-.09-1.23-.32s-.6-.6-.62-1.12h-3.79zm8.04-6.76c0 1.1-.74 2.38-2.23 2.38-1.28 0-2.23-.73-2.23-2.38 0-1.44.85-2.38 2.23-2.38s2.23.85 2.23 2.38"
              ></path>
            </g>
            <g id="U9-2" data-name="U9">
              <path
                fill="#fff"
                d="M559.3 848.17H605.53V882.1899999999999H559.3z"
              ></path>
              <path
                fill="#ffd500"
                d="M563.57 852.42H601.2700000000001V877.93H563.57z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M577.7 856.84v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12zM585.41 869.3c.06 3.35 2.97 4.42 5.51 4.42 2.18 0 3.3-.37 4.76-1.95.82-.89 1.88-3.25 1.94-5.45.14-4.81-1.18-9.14-6.33-9.14-3.14 0-6.1 1.65-6.1 5.48 0 3.09 2.29 5.02 4.95 5.02 1.3 0 2.62-.53 3.43-1.65l.04.04c-.08 2.04 0 4.67-2.54 4.67-.43 0-.88-.09-1.23-.32s-.6-.6-.62-1.12h-3.79zm8.04-6.76c0 1.1-.74 2.38-2.23 2.38-1.28 0-2.23-.73-2.23-2.38 0-1.44.85-2.38 2.23-2.38s2.23.85 2.23 2.38"
              ></path>
            </g>
            <g id="U9-3" data-name="U9">
              <path fill="#fff" d="M113.89 929.27H160.12V963.29H113.89z"></path>
              <path
                fill="#ffd500"
                d="M118.15 933.52H155.85000000000002V959.03H118.15z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M132.29 937.93v10.24c-.06 2.11-1.05 3.44-2.99 3.44s-2.93-1.33-2.99-3.44v-10.24h-4.12v10.47c.04 4.61 3.36 6.42 7.11 6.42s7.07-1.81 7.12-6.42v-10.47h-4.12zM140 950.4c.06 3.35 2.97 4.42 5.51 4.42 2.18 0 3.3-.37 4.76-1.95.82-.89 1.88-3.25 1.94-5.45.14-4.81-1.18-9.14-6.33-9.14-3.14 0-6.1 1.65-6.1 5.48 0 3.09 2.29 5.02 4.95 5.02 1.3 0 2.62-.53 3.43-1.65l.04.04c-.08 2.04 0 4.67-2.54 4.67-.43 0-.88-.09-1.23-.32s-.6-.6-.62-1.12h-3.79zm8.04-6.76c0 1.1-.74 2.38-2.23 2.38-1.28 0-2.23-.73-2.23-2.38 0-1.44.85-2.38 2.23-2.38s2.23.85 2.23 2.38"
              ></path>
            </g>
          </g>
        </g>
        <g id="U14.1">
          <g id="U_14_2023" data-name="U 14 2023" ref={demoU14}>
            <path
              fill="none"
              stroke="#6eb53e"
              strokeDasharray="0 0 0 0 0 0 10 10 10 10 10 10"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1941.54 208.03L1625.16 207.83 1361 471.92 1361.89 656.38 1086.21 950.03 813.33 673.15"
            ></path>
            <path
              fill="none"
              stroke="#6eb53e"
              strokeDasharray="0 0 0 0 0 0 10 10 10 10 10 10"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1185.15 731.22L1092.22 619.49 876.97 621.15 814.78 675.38"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M948.58 639.97H952.83V679.74H948.58z"
            ></path>
          </g>
          <g
            id="U14_Line"
            fill="none"
            strokeMiterlimit="10"
            data-name="U14 Line"
          >
            <path
              stroke="#6eb63e"
              strokeWidth="5.39"
              d="M493.24 1301.01L614.51 1179.87 917.5 1179.87 1129.54 967.88 1129.54 943.67 1188.57 884.64"
            ></path>
            <path
              stroke="#6eb63e"
              strokeWidth="5.39"
              d="M1932.67 196.02L1648.88 196.02 1387.45 457.4 1387.45 661.49 1368.5 680.47 1368.5 704.81 1214.54 858.77"
            ></path>
          </g>
          <g id="U_White_Kopie_5" data-name="U White Kopie 5">
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1660.79 184.67H1665.04V199.13H1660.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1724.94 184.67H1729.19V199.13H1724.94z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1793.47 184.67H1797.72V199.13H1793.47z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1862.01 184.67H1866.26V199.13H1862.01z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1930.54 184.67H1934.79V199.13H1930.54z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
              transform="rotate(-45 1615.166 230.136)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.42 264.64H1579.67V270.59H1575.42z"
              transform="rotate(-45 1577.718 267.588)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
              transform="rotate(-45 1540.103 305.068)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
              transform="rotate(-45 1502.829 342.478)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1463.09 376.97H1467.34V382.92H1463.09z"
              transform="rotate(-45 1465.382 379.929)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.65 414.42H1429.9V420.37H1425.65z"
              transform="rotate(-45 1427.935 417.38)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-7"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <g
              id="Haltepunkte_Standart_Kopie_5"
              data-name="Haltepunkte Standart Kopie 5"
            >
              <g
                id="S-Haltepunkte_Kopie_2_Kopie_5"
                strokeWidth="0"
                data-name="S-Haltepunkte Kopie 2 Kopie 5"
              >
                <path
                  fill="#fff"
                  d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
                ></path>
                <path
                  fill="#ededec"
                  d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
                ></path>
                <path
                  fill="#fff"
                  d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
                ></path>
              </g>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1660.79 184.67H1665.04V199.13H1660.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1724.94 184.67H1729.19V199.13H1724.94z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1793.47 184.67H1797.72V199.13H1793.47z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1862.01 184.67H1866.26V199.13H1862.01z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1930.54 184.67H1934.79V199.13H1930.54z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
              transform="rotate(-45 1615.166 230.136)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.42 264.64H1579.67V270.59H1575.42z"
              transform="rotate(-45 1577.718 267.588)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
              transform="rotate(-45 1540.103 305.068)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
              transform="rotate(-45 1502.829 342.478)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1463.09 376.97H1467.34V382.92H1463.09z"
              transform="rotate(-45 1465.382 379.929)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.65 414.42H1429.9V420.37H1425.65z"
              transform="rotate(-45 1427.935 417.38)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-8"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1660.79 184.67H1665.04V199.13H1660.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1724.94 184.67H1729.19V199.13H1724.94z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1793.47 184.67H1797.72V199.13H1793.47z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1862.01 184.67H1866.26V199.13H1862.01z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1930.54 184.67H1934.79V199.13H1930.54z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
              transform="rotate(-45 1615.166 230.136)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.42 264.64H1579.67V270.59H1575.42z"
              transform="rotate(-45 1577.718 267.588)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
              transform="rotate(-45 1540.103 305.068)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
              transform="rotate(-45 1502.829 342.478)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1463.09 376.97H1467.34V382.92H1463.09z"
              transform="rotate(-45 1465.382 379.929)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.65 414.42H1429.9V420.37H1425.65z"
              transform="rotate(-45 1427.935 417.38)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-9"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
          </g>
          <g
            id="U14_Stations"
            fill="#1d1d1b"
            data-name="U14 Stations"
            fontSize="21"
          >
            <text
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 955.74 1018.29)"
            >
              <tspan x="0" y="0">
                Marienplatz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.83 0 0 1 1394.56 564.06)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Wil-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0" y="19">
                  helma
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1437.34 429.67)"
            >
              <tspan x="0" y="0">
                Mühlsteg
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1469.75 396.78)"
            >
              <tspan x="0" y="0">
                Kraftwerk Münster
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1504.27 363.88)"
            >
              <tspan x="0" y="0">
                Münster Viadukt
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1556.39 311.99)"
            >
              <tspan x="0" y="0">
                Münster{" "}
              </tspan>
              <tspan x="-22.24" y="19">
                Rathaus
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1589.54 279.1)"
            >
              <tspan x="0" y="0">
                Freibergstr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1620.1 247.33)"
            >
              <tspan x="0" y="0">
                Elbestr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1680.49 219.27)"
            >
              <tspan x="0" y="0">
                Max-Eyth-
              </tspan>
              <tspan x="32.38" y="19">
                See
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.85 0 0 1 1637.78 160.18)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Wagrain-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0" y="19">
                  äcker
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1770.13 178.76)"
            >
              <tspan x="0" y="0">
                Hofen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1817.93 219.27)"
            >
              <tspan x="0" y="0">
                Auwiesen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1115.32 1004.47)"
            >
              <tspan x="0" y="0">
                Österreich.
              </tspan>
              <tspan x="0" y="19">
                Platz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.83 0 0 1 893.82 1045.95)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Erwin-Schoettle-
                </tspan>
              </tspan>
              <tspan x="93.28" y="19" letterSpacing="0em">
                Plat
              </tspan>
              <tspan x="131.04" y="19" letterSpacing="-.16em">
                z
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.85 0 0 1 1007.62 1064.95)"
            >
              <tspan x="0" y="0" letterSpacing="0em"></tspan>
              <tspan x="17.82" y="0" letterSpacing=".22em"></tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 996.99 1122.92)"
            >
              <tspan x="0" y="0">
                Bihlplatz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1270.04 848.57)"
            >
              <tspan x="0" y="0">
                Staatsgalerie
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1237.53 879.57)"
            >
              <tspan x="0" y="0">
                Charlottenpl.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1156.96 962.34)"
            >
              <tspan x="0" y="0">
                Rathaus
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.85 0 0 1 850.14 1203.33)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Wald-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="12.94" y="19">
                  eck
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 780.58 1203.15)"
            >
              <tspan x="0" y="0">
                Kalten-
              </tspan>
              <tspan x="22.96" y="19">
                tal
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.85 0 0 1 712.79 1203.15)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Engel
              </tspan>
              <tspan x="56.53" y="0" letterSpacing=".22em">
                -
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="-4.21" y="19">
                  boldstr.
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 505.87 1207)"
            >
              <tspan x="0" y="0">
                Fauststr.
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 341.08 1248.48)"
            >
              <tspan x="0" y="0">
                Vaihingen Schillerplatz
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1291.19 646.07)"
            >
              <tspan x="0" y="0">
                Mineral-
              </tspan>
              <tspan x="25.98" y="19">
                bäder
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              transform="matrix(.85 0 0 1 1276.76 701.47)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Metzst
              </tspan>
              <tspan x="65.94" y="0" letterSpacing="-.13em">
                r
              </tspan>
              <tspan x="71.27" y="0" letterSpacing="0em">
                .{" "}
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1308.33 808.52)"
            >
              <tspan x="0" y="0">
                Neckar-
              </tspan>
              <tspan x="0" y="19">
                tor
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1394.7 505.05)"
            >
              <tspan x="0" y="0">
                Rosensteinbr.{" "}
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 591.28 1153.1)"
            >
              <tspan x="0" y="0">
                Vaihingen
              </tspan>
              <tspan x="12.95" y="19">
                Viadukt
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 410.14 1315.61)"
            >
              <tspan x="0" y="0">
                Vaihingen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontWeight="700"
              transform="matrix(.85 .00119 -.0014 1 858.08 1107.2)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Südheime
              </tspan>
              <tspan x="102.35" y="0" letterSpacing="-.11em">
                r
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="58.57" y="20">
                  Platz
                </tspan>
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 845.19 1151.36)"
            >
              <tspan x="0" y="0">
                Heslach
              </tspan>
              <tspan x="-18.88" y="20">
                Vogelrain
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
              fontWeight="700"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1933.97 237.56)"
            >
              <tspan x="0" y="0">
                Mühlhausen
              </tspan>
            </text>
            <text
              fontFamily="UniversLTStd, 'Univers LT Std'"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1211.93 740.67)"
            >
              <tspan x="0" y="0">
                Stöckach
              </tspan>
            </text>
          </g>
          <g id="U14_StartandEnd" strokeWidth="0" data-name="U14 StartandEnd">
            <g id="U14">
              <path
                fill="#fff"
                d="M1930.69 191.47H1975.22V220.5H1930.69z"
              ></path>
              <path
                fill="#6eb63e"
                d="M1934.95 193.36H1972.65V218.87H1934.95z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M1946.52 197.79v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.04 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1955.96 198.48c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 2-1.19 2.91-1.97v11.76h3.27v-15.86h-2.73zM1962.92 208.02l2.77-5.89h.04v5.89h-2.8zm-2.9 2.98h5.65v3.05h3.32V211h1.8v-2.98h-1.8v-9.83h-3.94l-5.04 9.83V211z"
              ></path>
            </g>
            <g id="U14-2" data-name="U14">
              <path
                fill="#fff"
                d="M366.35 1267.35H410.88V1296.3799999999999H366.35z"
              ></path>
              <path
                fill="#6eb63e"
                d="M370.62 1269.24H408.32V1294.75H370.62z"
              ></path>
              <path
                fill="#1d1d1b"
                d="M382.19 1273.67v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.04 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM391.63 1274.36c-1 1.15-2.18 2.02-3.44 2.54v3.53c1.03-.46 2-1.19 2.91-1.97v11.76h3.27v-15.86h-2.73zM398.59 1283.9l2.77-5.89h.04v5.89h-2.8zm-2.9 2.98h5.65v3.05h3.32v-3.05h1.8v-2.98h-1.8v-9.83h-3.94l-5.04 9.83v2.98z"
              ></path>
            </g>
          </g>
        </g>
        <g id="U11.1">
          <g id="U_11_2023" data-name="U 11 2023" ref={demoU11}>
            <path
              id="U_11_2023-2"
              fill="none"
              stroke="#bcbcbb"
              strokeDasharray="0 0 0 0 0 0 10 10 10 10 10 10"
              strokeMiterlimit="10"
              strokeWidth="5.39"
              d="M1115.22 677.34L1068.27 625.89 878.91 624.59 824.72 675.35 1124.45 983.66 1444.63 661.16 1536.46 749.97"
              data-name="U 11 2023"
            ></path>
          </g>
          <g
            id="U11_Line"
            fill="none"
            strokeMiterlimit="10"
            data-name="U11 Line"
          >
            <path
              stroke="#bdbcbc"
              strokeWidth="5.39"
              d="M1182.39 878.53L1125.21 935.72 866.3 676.81"
            ></path>
            <path
              stroke="#bdbcbc"
              strokeWidth="5.39"
              d="M1543.13 743.78L1442.38 643.03 1386.58 698.88 1362.23 698.88 1208.49 852.62"
            ></path>
            <path
              stroke="#bdbcbc"
              strokeWidth="5.39"
              d="M863.01 673.53L888.36 648.17 1058.01 648.16 1235.93 825.18"
            ></path>
          </g>
          <g id="U_White" data-name="U White">
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1660.79 184.67H1665.04V199.13H1660.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1724.94 184.67H1729.19V199.13H1724.94z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1793.47 184.67H1797.72V199.13H1793.47z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1862.01 184.67H1866.26V199.13H1862.01z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1930.54 184.67H1934.79V199.13H1930.54z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1684.33 953.12H1688.58V967.58H1684.33z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1758.55 489.61H1773.01V493.86H1758.55z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1487.17 686.98H1501.73V691.23H1487.17z"
              transform="rotate(-45 1494.448 689.11)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1936.21 586.7H1950.48V590.95H1936.21z"
              transform="rotate(-45 1943.35 588.828)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1989.31 639.8H2003.58V644.05H1989.31z"
              transform="rotate(-45 1996.448 641.934)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
              transform="rotate(-45 2049.55 695.028)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2095.52 746.01H2109.79V750.26H2095.52z"
              transform="rotate(-45 2102.648 748.135)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2148.62 799.11H2162.89V803.36H2148.62z"
              transform="rotate(-45 2155.75 801.23)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1799.38 459.31H1803.63V473.48H1799.38z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
              transform="rotate(-45 1615.166 230.136)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.42 264.64H1579.67V270.59H1575.42z"
              transform="rotate(-45 1577.718 267.588)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
              transform="rotate(-45 1540.103 305.068)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
              transform="rotate(-45 1502.829 342.478)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1463.09 376.97H1467.34V382.92H1463.09z"
              transform="rotate(-45 1465.382 379.929)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.65 414.42H1429.9V420.37H1425.65z"
              transform="rotate(-45 1427.935 417.38)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1569.87 467.81H1574.12V509.37H1569.87z"
              transform="rotate(-45.03 1571.841 488.6)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-10"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <g
              id="Haltepunkte_Standart_Kopie_4_Kopie_Kopie_2"
              data-name="Haltepunkte Standart Kopie 4 Kopie Kopie 2"
            >
              <g
                id="S-Haltepunkte_Kopie_2_Kopie_4_Kopie_Kopie_2"
                strokeWidth="0"
                data-name="S-Haltepunkte Kopie 2 Kopie 4 Kopie Kopie 2"
              >
                <path
                  fill="#fff"
                  d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
                ></path>
                <path
                  fill="#ededec"
                  d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
                ></path>
                <path
                  fill="#fff"
                  d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
                ></path>
              </g>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1660.79 184.67H1665.04V199.13H1660.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1724.94 184.67H1729.19V199.13H1724.94z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1793.47 184.67H1797.72V199.13H1793.47z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1862.01 184.67H1866.26V199.13H1862.01z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1930.54 184.67H1934.79V199.13H1930.54z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1684.33 953.12H1688.58V967.58H1684.33z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1758.55 489.61H1773.01V493.86H1758.55z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1487.17 686.98H1501.73V691.23H1487.17z"
              transform="rotate(-45 1494.448 689.11)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1936.21 586.7H1950.48V590.95H1936.21z"
              transform="rotate(-45 1943.35 588.828)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1989.31 639.8H2003.58V644.05H1989.31z"
              transform="rotate(-45 1996.448 641.934)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
              transform="rotate(-45 2049.55 695.028)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2095.52 746.01H2109.79V750.26H2095.52z"
              transform="rotate(-45 2102.648 748.135)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2148.62 799.11H2162.89V803.36H2148.62z"
              transform="rotate(-45 2155.75 801.23)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1799.38 459.31H1803.63V473.48H1799.38z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
              transform="rotate(-45 1615.166 230.136)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.42 264.64H1579.67V270.59H1575.42z"
              transform="rotate(-45 1577.718 267.588)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
              transform="rotate(-45 1540.103 305.068)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
              transform="rotate(-45 1502.829 342.478)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1463.09 376.97H1467.34V382.92H1463.09z"
              transform="rotate(-45 1465.382 379.929)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.65 414.42H1429.9V420.37H1425.65z"
              transform="rotate(-45 1427.935 417.38)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1569.87 467.81H1574.12V509.37H1569.87z"
              transform="rotate(-45.03 1571.841 488.6)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-11"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
            <path
              fill="#fff"
              stroke="#fff"
              strokeWidth="2.83"
              d="M1183.75 860.22H1223.27V891.15H1183.75z"
              transform="rotate(-45.02 1203.577 875.71)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1690.45 450.78H1694.7V473.48999999999995H1690.45z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1660.79 184.67H1665.04V199.13H1660.79z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1724.94 184.67H1729.19V199.13H1724.94z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1793.47 184.67H1797.72V199.13H1793.47z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1862.01 184.67H1866.26V199.13H1862.01z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1930.54 184.67H1934.79V199.13H1930.54z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1684.33 953.12H1688.58V967.58H1684.33z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M831.69 677.52H835.94V691.81H831.69z"
              transform="rotate(-45 833.816 684.662)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1028.1 1055.75H1032.35V1078.38H1028.1z"
              transform="rotate(-45 1030.196 1067.049)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1099.94 983.73H1104.19V1006.36H1099.94z"
              transform="rotate(-45 1102.213 995.098)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M992.53 1091.32H996.78V1113.95H992.53z"
              transform="rotate(-45 994.655 1102.63)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M918.98 1164.1H923.23V1188.35H918.98z"
              transform="rotate(-45 921.108 1176.225)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1060.7 1019.46H1067.44V1035.16H1060.7z"
              transform="rotate(-45 1064.017 1027.29)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M951.78 1128.57H958.52V1144.78H951.78z"
              transform="rotate(-45 955.082 1136.642)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1758.55 489.61H1773.01V493.86H1758.55z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.23 488.94H1390.3600000000001V493.19H1367.23z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1487.17 686.98H1501.73V691.23H1487.17z"
              transform="rotate(-45 1494.448 689.11)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M537.47 1251.5H541.72V1257.45H537.47z"
              transform="rotate(-45 539.594 1254.483)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M583.47 1205.46H587.72V1211.41H583.47z"
              transform="rotate(-45 585.592 1208.44)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M632.16 1176.82H636.41V1182.77H632.16z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M741.75 1176.82H746V1182.77H741.75z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1367.15 562.76H1390.3600000000001V567.01H1367.15z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1936.21 586.7H1950.48V590.95H1936.21z"
              transform="rotate(-45 1943.35 588.828)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1989.31 639.8H2003.58V644.05H1989.31z"
              transform="rotate(-45 1996.448 641.934)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2042.41 692.91H2056.6800000000003V697.16H2042.41z"
              transform="rotate(-45 2049.55 695.028)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2095.52 746.01H2109.79V750.26H2095.52z"
              transform="rotate(-45 2102.648 748.135)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M2148.62 799.11H2162.89V803.36H2148.62z"
              transform="rotate(-45 2155.75 801.23)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1799.38 459.31H1803.63V473.48H1799.38z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1612.87 227.2H1617.12V233.14999999999998H1612.87z"
              transform="rotate(-45 1615.166 230.136)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1575.42 264.64H1579.67V270.59H1575.42z"
              transform="rotate(-45 1577.718 267.588)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1537.98 302.09H1542.23V308.03999999999996H1537.98z"
              transform="rotate(-45 1540.103 305.068)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1500.54 339.53H1504.79V345.47999999999996H1500.54z"
              transform="rotate(-45 1502.829 342.478)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1463.09 376.97H1467.34V382.92H1463.09z"
              transform="rotate(-45 1465.382 379.929)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1425.65 414.42H1429.9V420.37H1425.65z"
              transform="rotate(-45 1427.935 417.38)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M873.22 1176.82H877.47V1182.77H873.22z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M807.48 1176.82H811.73V1182.77H807.48z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M975.02 628.16H979.27V667.93H975.02z"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1569.87 467.81H1574.12V509.37H1569.87z"
              transform="rotate(-45.03 1571.841 488.6)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M1145.18 749.99H1192.8V776.44H1145.18z"
            ></path>
            <g
              id="station_whites-12"
              fill="#fff"
              strokeWidth="0"
              data-name="station whites"
            >
              <path
                d="M1388.89 660.13H1393.14V692.29H1388.89z"
                transform="rotate(-45.02 1390.95 676.216)"
              ></path>
              <path
                d="M1351.31 697.35H1355.56V729.51H1351.31z"
                transform="rotate(-45.02 1353.404 713.43)"
              ></path>
              <path
                d="M1418.89 618.79H1423.14V660.3499999999999H1418.89z"
                transform="rotate(-45.03 1420.864 639.565)"
              ></path>
              <path
                d="M1285.1 755.32H1289.35V804.1H1285.1z"
                transform="rotate(-45.03 1287.152 779.707)"
              ></path>
              <path
                d="M1314.76 725.58H1319.01V774.36H1314.76z"
                transform="rotate(-45.03 1316.81 749.964)"
              ></path>
              <path
                d="M1255.33 785.02H1259.58V834.1H1255.33z"
                transform="rotate(-45.03 1257.396 809.55)"
              ></path>
              <path
                d="M1140.44 910.94H1144.69V953.0600000000001H1140.44z"
                transform="rotate(-45.02 1142.687 932.034)"
              ></path>
            </g>
            <path
              fill="#fff"
              strokeWidth="0"
              d="M551.64 1347.38L545.63 1353.4 491.08 1298.85 497.09 1292.84 551.64 1347.38z"
            ></path>
            <g strokeWidth="0">
              <path
                fill="#ededec"
                d="M1036.62 739.18L1098.63 677.12 1098.64 677.14 1107.81 667.94 1169.96 730.03 1135.51 764.52 1135.5 764.51 1098.76 801.27 1036.62 739.18z"
              ></path>
              <path
                fill="#fff"
                d="M1107.81 669.95l60.14 60.09-32.42 32.46h-.01l-36.76 36.77-60.14-60.09 59.99-60.04.02.02 9.18-9.21m0-4.01l-2 2.01-7.46 7.48-1.74 1.72-59.99 60.04-2 2.01 2.01 2 60.14 60.09 2.01 2 2-2 34.71-34.74 2.06-2.03 32.42-32.46 2-2.01-2.01-2-60.14-60.09-2.01-2.01z"
              ></path>
            </g>
          </g>
          <g id="U11_Stations" data-name="U11 Stations">
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1464.51 644.77)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Mercedes-
                </tspan>
              </tspan>
              <tspan x="0" y="19" letterSpacing="0em"></tspan>
              <tspan x="17.83" y="19" letterSpacing="-.03em"></tspan>
              <tspan x="22.93" y="19" letterSpacing="0em">
                str.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 919.18 671.91)"
            >
              <tspan x="0" y="0">
                Börsenplatz
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 711.19 681.03)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Berliner Plat
              </tspan>
              <tspan x="122.74" y="0" letterSpacing=".22em">
                z
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1270.04 848.57)"
            >
              <tspan x="0" y="0">
                Staatsgalerie
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1211.93 741.03)"
            >
              <tspan x="0" y="0">
                Stöckach
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1276.76 701.47)"
            >
              <tspan x="0" y="0" letterSpacing="0em">
                Metzst
              </tspan>
              <tspan x="65.94" y="0" letterSpacing="-.13em">
                r
              </tspan>
              <tspan x="71.27" y="0" letterSpacing="0em">
                .{" "}
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1237.53 879.57)"
            >
              <tspan x="0" y="0">
                Charlottenpl.
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1156.96 962.34)"
            >
              <tspan x="0" y="0">
                Rathaus
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 1291.19 646.07)"
            >
              <tspan x="0" y="0">
                Mineral-
              </tspan>
              <tspan x="25.98" y="19">
                bäder
              </tspan>
            </text>
            <text
              fill="#1d1d1b"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              transform="matrix(.85 0 0 1 1427.78 694.08)"
            >
              <tspan letterSpacing="0em">
                <tspan x="0" y="0">
                  Cann-
                </tspan>
              </tspan>
              <tspan letterSpacing="0em">
                <tspan x="0" y="19">
                  {" "}
                  statter
                </tspan>
              </tspan>
              <tspan x="0" y="38" letterSpacing="0em"></tspan>
              <tspan x="23.77" y="38" letterSpacing=".11em"></tspan>
              <tspan x="31.82" y="38" letterSpacing="0em">
                Wasen
              </tspan>
            </text>
            <g fill="#1d1d1b" strokeWidth="0">
              <path d="M1532.94 772.58h4l4.84 11.95v-11.95h2.57v15.18h-3.8l-5-12.6v12.6h-2.61v-15.18zM1548.91 783.24c0 .69 0 2.83 1.84 2.83.66 0 1.32-.29 1.57-1.47h2.41c-.04.5-.12 1.41-.86 2.31-.66.82-1.84 1.24-3.16 1.24-.77 0-2.23-.17-3.18-1.32-.82-1.01-1.16-2.44-1.16-4.14s.36-3.78 1.87-5.02c.7-.55 1.55-.88 2.54-.88 1.29 0 2.82.59 3.64 2.56.61 1.45.57 3 .54 3.88h-6.05zm3.36-1.95c0-.48-.04-2.37-1.57-2.37-1.16 0-1.64 1.13-1.7 2.37h3.27zM1561.57 780.91c-.04-.38-.14-1.95-1.16-1.95-1.25 0-1.39 2.23-1.39 3.38 0 .59.05 2.48.66 3.25.25.32.52.36.71.36.29 0 1.11-.15 1.21-2.04h2.61c-.04.82-.12 2.1-1.16 3.13-.64.65-1.45.99-2.57.99-1.2 0-2.25-.31-3.07-1.41-.79-1.07-1.14-2.48-1.14-4.18 0-4.83 3.02-5.5 4.21-5.5 1.68 0 3.66 1.09 3.68 3.97h-2.59zM1565.85 772.58h2.62v8.94l2.73-4.43h2.98l-3.09 4.62 3.28 6.05h-3.12l-2.79-5.77v5.77h-2.62v-15.18zM1581.24 787.76c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.95h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM1585.84 779.76c0-.5-.07-2.04-.12-2.65h2.48l.05 2.04c.34-.9.93-2.18 3.07-2.06v2.79c-2.68-.29-2.84 1.32-2.84 2.65v5.23h-2.64v-8zM1592.88 772.62h3.98c1.86 0 3.41.15 4.48 1.66.68.97.79 2.06.79 2.83 0 1.76-.62 3.25-1.64 4.03-.95.71-2.25.71-2.93.71h-1.88v5.9h-2.8v-15.14zm2.73 6.82h1.11c.89 0 2.55 0 2.55-2.31 0-2.06-1.48-2.06-2.27-2.06h-1.39v4.37zM1609.28 787.76c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.95h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM1613.89 779.76c0-.5-.07-2.04-.12-2.65h2.48l.05 2.04c.34-.9.93-2.18 3.07-2.06v2.79c-2.68-.29-2.84 1.32-2.84 2.65v5.23h-2.64v-8zM1620.96 772.58h2.62v8.94l2.73-4.43h2.98l-3.09 4.62 3.28 6.05h-3.12l-2.79-5.77v5.77h-2.62v-15.18zM1637.5 771.86c-.59 2.1-1.57 5.5-1.57 9.26 0 2.81.5 4.91 1.55 9.22h-1.95c-1.02-2.92-1.8-5.96-1.8-9.11s.82-6.36 1.82-9.36h1.95zM1642.11 782.91c0 .71-.04 2.88 2.34 2.88 1.5 0 2.45-.84 2.45-2.12s-.8-1.57-2.45-2.04c-3.07-.9-4.75-1.97-4.75-4.6s1.52-4.7 5.11-4.7c1.34 0 2.93.36 3.89 1.79.73 1.09.73 2.31.73 2.81h-2.66c-.04-.53-.18-2.31-2.09-2.31-1.29 0-2.12.82-2.12 2.06 0 1.41.95 1.66 2.8 2.2 2.23.63 4.43 1.34 4.43 4.3 0 2.73-1.93 4.93-5.5 4.93-4.95 0-4.98-3.74-5-5.21h2.82zM1657.12 787.61c-.86.27-1.62.34-2.05.34-2.66 0-2.66-1.97-2.66-2.86v-5.82h-1.73v-2.06h1.73v-2.08l2.62-1.13v3.21h2.14v2.06h-2.14v4.79c.02.97.02 1.57 1.2 1.57.39 0 .57-.02.89-.06v2.04zM1664.26 787.76c-.09-.65-.09-1.13-.09-1.45-1 1.7-2.2 1.7-2.7 1.7-1.3 0-1.89-.44-2.25-.84-.54-.63-.79-1.49-.79-2.33s.25-2.39 1.91-3.3c1.11-.59 2.7-.59 3.57-.59 0-.69-.02-1.03-.12-1.41-.23-.78-.93-.88-1.18-.88-.38 0-.77.19-1 .59-.2.36-.2.69-.2.95h-2.59c.02-.57.07-1.7 1.02-2.5.82-.69 1.88-.86 2.73-.86.75 0 2.32.15 3.21 1.36.61.86.62 2.12.62 2.6l.02 4.26c0 .9.05 1.81.21 2.69h-2.39zm-3.25-3.28c0 .71.41 1.51 1.29 1.51.48 0 .87-.27 1.12-.61.46-.67.5-1.49.5-2.62-1.7-.17-2.91.46-2.91 1.72zM1674.83 772.6h2.66v13.44c0 .63.04 1.32.07 1.72h-2.68l-.07-1.53c-.18.38-.36.78-.91 1.2-.66.5-1.36.55-1.75.55-2.41 0-3.84-1.95-3.84-5.27 0-3.51 1.62-5.69 3.98-5.69 1.62 0 2.3 1.07 2.54 1.45v-5.86zm-2.02 13.35c.77 0 1.39-.55 1.68-1.2.39-.88.43-1.97.43-2.5 0-2.08-.77-3.21-1.96-3.21-1.77 0-1.96 2.5-1.96 3.57 0 1.76.5 3.34 1.82 3.34zM1679.77 772.6h2.82v2.71h-2.82v-2.71zm.09 4.54h2.64v10.62h-2.64v-10.62zM1689.16 776.9c3.27 0 4.68 2.6 4.68 5.56s-1.46 5.67-4.73 5.67c-2.57 0-4.61-1.87-4.61-5.58 0-2.56 1.11-5.65 4.66-5.65zm.04 9.07c1.16 0 1.95-.82 1.95-3.63 0-1.41-.23-3.36-1.98-3.36-1.93 0-1.95 2.62-1.95 3.59 0 2.37.68 3.4 1.98 3.4zM1695.94 779.04s0-1.2-.05-1.93h2.54l.07 1.6c.25-.48.96-1.85 2.93-1.85 1.77 0 2.52 1.26 2.75 2 .2.65.25 1.2.25 3.17v5.73h-2.7v-6.59c0-.44 0-.82-.14-1.16-.2-.46-.61-.9-1.29-.9-.57 0-1.09.31-1.37.82-.16.27-.32.8-.32 1.62v6.21h-2.66v-8.71zM1706.81 790.34c.59-2.1 1.57-5.5 1.57-9.26 0-2.83-.5-4.91-1.55-9.22h1.95c1.02 2.9 1.8 5.96 1.8 9.09s-.82 6.36-1.82 9.38h-1.95z"></path>
            </g>
            <text
              id="Stadtmitte_Rotebühlpl._-3"
              fill="#1d1d1b"
              data-name="Stadtmitte (Rotebühlpl.)"
              fontFamily="UniversLTStd, 'Univers LT Std'"
              fontSize="21"
              letterSpacing="0em"
              transform="matrix(.85 0 0 1 814.14 795.01)"
            >
              <tspan x="0" y="0">
                Stadtmitte{" "}
              </tspan>
              <tspan x="0" y="19">
                (Rotebühlplatz)
              </tspan>
            </text>
          </g>
          <g id="U11_StartandEnd" strokeWidth="0" data-name="U11 StartandEnd">
            <g id="U11-2" data-name="U11">
              <path
                fill="#fff"
                d="M1528.63 736.42H1574.8600000000001V770.4399999999999H1528.63z"
              ></path>
              <path
                fill="#9d9d9c"
                d="M1532.89 740.67H1570.5900000000001V766.18H1532.89z"
              ></path>
              <path
                fill="#fff"
                d="M1544.88 744.96v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1554.82 745.65c-1 1.14-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1564.23 745.65c-1 1.14-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.26v-15.86h-2.73z"
              ></path>
            </g>
            <path
              fill="#9d9d9c"
              d="M1151.08 722.63H1188.78V748.14H1151.08z"
            ></path>
            <path
              fill="#fff"
              d="M1163.07 726.92v10.24c-.05 2.11-.88 3.44-2.49 3.44s-2.44-1.33-2.49-3.44v-10.24h-3.44v10.47c.03 4.61 2.8 6.42 5.93 6.42s5.9-1.81 5.93-6.42v-10.47h-3.44zM1173.02 727.61c-1 1.14-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.27v-15.86h-2.73zM1182.42 727.61c-1 1.14-2.18 2.02-3.44 2.54v3.53c1.03-.46 1.99-1.19 2.9-1.97v11.76h3.26v-15.86h-2.73z"
            ></path>
          </g>
        </g>
        <g id="Hauptbahnhof-4" data-name="Hauptbahnhof">
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd-Bold, 'Univers LT Std'"
            fontSize="21"
            fontWeight="700"
            letterSpacing="0em"
            transform="matrix(.85 0 0 1 1073.02 729.12)"
          >
            <tspan x="0" y="0">
              Haupt-
            </tspan>
            <tspan x="0" y="19">
              bahnhof
            </tspan>
          </text>
          <text
            fill="#1d1d1b"
            fontFamily="UniversLTStd, 'Univers LT Std'"
            fontSize="21"
            transform="matrix(.75 0 0 1 1073.02 769.12)"
          >
            <tspan x="0" y="0">
              (Arnulf-Klett-P
            </tspan>
            <tspan x="141.14" y="0" letterSpacing="-.06em">
              l.
            </tspan>
            <tspan x="150.29" y="0">
              )
            </tspan>
          </text>
          <g strokeWidth="0">
            <path
              fill="#1d1d1b"
              fillRule="evenodd"
              d="M1092.22 685.51L1092.22 687.7 1107.9 681.08 1123.4 687.7 1123.4 685.51 1107.9 678.9 1092.22 685.51"
            ></path>
            <path
              fill="#1d1d1b"
              fillRule="evenodd"
              d="M1095.06 710.08L1123.4 710.08 1123.4 703.28 1113.92 703.28 1113.92 708.38 1109.73 708.38 1109.73 707.24 1106.73 707.24 1106.73 708.38 1100.23 708.38 1100.23 707.24 1097.23 707.24 1097.23 708.38 1095.06 708.38 1095.06 710.08"
            ></path>
            <path
              fill="#1d1d1b"
              fillRule="evenodd"
              d="M1110.09 691.75c-.83-2.08-2.61-2.65-6.62-2.65s-5.78.57-6.62 2.65c-.67 1.51-1.81 4.72-1.81 6.61v5.1c0 1.7 1.33 3.21 2.67 3.21h11.51c1.33 0 2.67-1.51 2.67-3.21v-5.1c0-1.89-1.14-5.1-1.81-6.61z"
            ></path>
            <path
              fill="#fff"
              fillRule="evenodd"
              d="M1104.62 699.44a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1099.33 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001zM1109.93 703.51a1.14 1.14 0 11-2.279.001 1.14 1.14 0 012.279-.001z"
            ></path>
            <path
              fill="#fff"
              d="M1109.44 694.31l-.67-1.92c-.28-.75-.8-1.11-1.37-1.29-.57-.18-1.64-.43-3.91-.43-2.27 0-3.35.25-3.91.43-.57.18-1.09.55-1.37 1.29l-.67 1.92c-.28.85-.19 1.74 1.09 1.62 1.28-.11 2.32-.4 4.88-.4s3.6.29 4.88.4c1.28.11 1.37-.77 1.09-1.62z"
            ></path>
            <path
              fill="#1d1d1b"
              d="M1103.47 686.34h-5.31v.65c2.48 0 4.99.96 4.99 3.11h.65c0-2.15 2.5-3.11 4.99-3.11v-.65h-5.31zm0 2.36c-.38-.75-1.08-1.32-1.94-1.71h3.87c-.86.39-1.55.95-1.94 1.71z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

  MapElement.propTypes = {};


export default MapElement;